// Lesson 3 - Oral Pathology

export const questions = {
  "1. Introduction to Oral Pathology": [
    {
      id: 93001,
      question: "What is Oral Pathology defined as, according to the American Academy of Oral & Maxillofacial Pathology?",
      options: [
        "A specialty that identifies, investigates causes, and manages diseases of the oral and maxillofacial regions",
        "A general medical field focused on diagnosing all diseases of the human body",
        "A branch of dentistry concerned only with surgical removal of oral tumors",
        "A science that studies nutrition-related disorders affecting the teeth and gums"
      ],
      correctAnswer: 0
    },
    {
      id: 93002,
      question: "Which of the following best reflects the WHO's definition of disease?",
      options: [
        "Any condition that requires hospitalization or surgical intervention to treat",
        "A deviation from normal health or wellness, including physical, mental, and social well-being",
        "A disorder affecting only physical health that has been verified by laboratory testing",
        "A condition caused exclusively by infectious agents requiring antibiotic treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 93003,
      question: "Which of the following is the simplified definition of disease used in the lecture?",
      options: [
        "A condition diagnosed only after laboratory testing confirms a pathogen",
        "A genetic disorder inherited from one or both biological parents at birth",
        "An abnormal body or mind condition causing discomfort, dysfunction, or distress",
        "An environmental reaction that affects only the musculoskeletal system"
      ],
      correctAnswer: 2
    },
    {
      id: 93004,
      question: "Which of the following is NOT listed as a broadly used term related to disease?",
      options: [
        "Syndromes and disabilities",
        "Deviant behaviours and injuries",
        "Atypical variations of structure and function",
        "Bacterial infections and viral outbreaks"
      ],
      correctAnswer: 3
    },
    {
      id: 93005,
      question: "What does the abbreviation \"ICD\" stand for in disease classification?",
      options: [
        "International Classification of Disease",
        "Integrated Clinical Diagnostics",
        "Indexed Criteria for Dental conditions",
        "Institutional Classification of Disorders"
      ],
      correctAnswer: 0
    },
    {
      id: 93006,
      question: "Which organization controls the International Classification of Disease (ICD)?",
      options: [
        "The American Dental Association (ADA)",
        "The World Health Organization (WHO)",
        "The Centers for Disease Control and Prevention (CDC)",
        "The International Academy of Oral Pathology (IAOP)"
      ],
      correctAnswer: 1
    },
    {
      id: 93007,
      question: "When did the ICD system originate, and what is the current edition referenced in the lecture?",
      options: [
        "Origins in the 1920s; current edition is ICD-8 (1975)",
        "Origins in the 1900s; current edition is ICD-11 (2010)",
        "Origins in the 1850s; current edition is ICD-10 (1994)",
        "Origins in the 1970s; current edition is ICD-9 (1985)"
      ],
      correctAnswer: 2
    },
    {
      id: 93008,
      question: "Which of the following is a listed risk factor for disease?",
      options: [
        "Adequate sleep and daily exercise",
        "Moderate alcohol consumption and organic diet",
        "High-protein diet and regular dental checkups",
        "Smoking, tobacco use, and adverse childhood experiences"
      ],
      correctAnswer: 3
    },
    {
      id: 93009,
      question: "How is stress defined in the context of this lecture?",
      options: [
        "A generalized or systemic response to change, known as a stressor",
        "A localized reaction to tissue damage caused by trauma or infection",
        "A chronic hormonal imbalance triggered by nutritional deficiency",
        "A mental health disorder that requires pharmacological management"
      ],
      correctAnswer: 0
    },
    {
      id: 93010,
      question: "Who first described the stress response, and what is the concept called?",
      options: [
        "Sigmund Freud in 1902; the Psychosomatic Stress Model",
        "Hans Selye in 1946; General Adaptation Syndrome (GAS)",
        "Walter Cannon in 1930; the Homeostatic Regulation Theory",
        "Louis Pasteur in 1875; the Immune Stress Response Framework"
      ],
      correctAnswer: 1
    },
    {
      id: 93011,
      question: "What are the three stages of the General Adaptation Syndrome (GAS)?",
      options: [
        "Onset, Progression, and Resolution",
        "Alert, Combat, and Recovery",
        "Alarm, Resistance, and Exhaustion",
        "Trigger, Response, and Adaptation"
      ],
      correctAnswer: 2
    },
    {
      id: 93012,
      question: "Which stage of GAS involves mobilization of the body's defenses through activation of the hypothalamus and adrenal glands?",
      options: [
        "Exhaustion Stage",
        "Recovery Stage",
        "Resistance Stage",
        "Alarm Stage"
      ],
      correctAnswer: 3
    },
    {
      id: 93013,
      question: "What happens during the Exhaustion Stage of the General Adaptation Syndrome?",
      options: [
        "The body is unable to respond further and becomes damaged by increased demands",
        "The immune system activates to fight off the primary stressor",
        "The body reaches peak performance and hormone levels stabilize",
        "The hypothalamus triggers release of calming neurotransmitters"
      ],
      correctAnswer: 0
    },
    {
      id: 93014,
      question: "Which body structures are involved in the stress response according to the lecture?",
      options: [
        "Thalamus, cerebellum, parasympathetic nervous system, and thyroid gland",
        "Hypothalamus, pituitary gland, sympathetic nervous system, and adrenal medulla",
        "Hippocampus, basal ganglia, somatic nervous system, and pancreas",
        "Medulla oblongata, limbic system, autonomic system, and adrenal cortex"
      ],
      correctAnswer: 1
    },
    {
      id: 93015,
      question: "Which of the following is a possible physiological complication of chronic stress?",
      options: [
        "Increased inflammatory response and hypoglycemia",
        "Decreased heart rate, reduced circulation, and enhanced immune function",
        "Elevated blood pressure, decreased immune response, and bronchodilation",
        "Lowered cortisol levels, improved metabolism, and reduced CNS activity"
      ],
      correctAnswer: 2
    },
    {
      id: 93016,
      question: "Which of the following is listed as an example of a stress-related complication?",
      options: [
        "Improved healing, stable blood sugar, and increased immunity",
        "Decreased endorphin release, lower BP, and hypoglycemia",
        "Reduced vasoconstriction, increased appetite, and improved sleep",
        "Hypertension, mouth ulcers, and exacerbation of chronic disorders like asthma"
      ],
      correctAnswer: 3
    },
    {
      id: 93017,
      question: "Which of the following is listed as a coping strategy for stress?",
      options: [
        "Exercise, counselling, relaxation techniques, and developing a support system",
        "Increasing tobacco use and relying solely on medications",
        "Avoiding social interaction and remaining sedentary",
        "Suppressing emotions, changing diet, and increasing alcohol intake"
      ],
      correctAnswer: 0
    },
    {
      id: 93018,
      question: "What is the relationship between stress and disease according to the lecture?",
      options: [
        "Stress is always harmful and is the sole cause of all diseases",
        "Stress can initiate, maintain, perpetuate, and exacerbate disease, but is not the only cause",
        "Stress has no connection to disease and only affects mental health",
        "Stress only triggers disease when combined with a poor diet and lack of sleep"
      ],
      correctAnswer: 1
    },
    {
      id: 93019,
      question: "What foundational knowledge is essential for Oral Pathology, according to the lecture?",
      options: [
        "Knowledge of pharmacology, biochemistry, and radiology only",
        "Medical law, bioethics, and health policy administration",
        "Human anatomy, physiology, histology, and dental anatomy",
        "Emergency procedures, surgical techniques, and clinical microbiology"
      ],
      correctAnswer: 2
    },
    {
      id: 93020,
      question: "What is the difference between Pathology and Nosology?",
      options: [
        "Pathology classifies diseases; Nosology studies the processes underlying disease",
        "Pathology deals with oral disease; Nosology deals with systemic disease",
        "Pathology focuses on symptoms; Nosology focuses on causes of disease",
        "Pathology is the study of disease processes; Nosology is the systematic classification of disease"
      ],
      correctAnswer: 3
    },
    {
      id: 93021,
      question: "What are the three ways disease can be classified according to the lecture?",
      options: [
        "Etiology, pathogenesis, and symptoms",
        "Location, duration, and severity",
        "Cell type, organ system, and age of onset",
        "Diagnosis, treatment, and prognosis"
      ],
      correctAnswer: 0
    },
    {
      id: 93022,
      question: "Why is classifying oral diseases particularly challenging?",
      options: [
        "There are too few oral diseases to develop a consistent classification system",
        "Oral lesions may represent local or distant disease, span many pathology types, and are infrequently occurring",
        "Oral diseases only affect soft tissue, making diagnosis straightforward",
        "Pathologists rarely include oral diseases in standard classification systems"
      ],
      correctAnswer: 1
    },
    {
      id: 93023,
      question: "How are oral lesions grouped according to the lecture?",
      options: [
        "By patient age, disease duration, and response to treatment",
        "By radiographic color, lesion size, and patient symptoms",
        "By microscopic appearance, presumed origin, and location",
        "By causative agent, genetic predisposition, and clinical signs"
      ],
      correctAnswer: 2
    },
    {
      id: 93024,
      question: "Which of the following represents the classification of dental diseases by location?",
      options: [
        "Diseases caused by bacteria, viruses, fungi, and parasites by region",
        "Diseases of enamel, dentin, pulp, and cementum only",
        "Diseases affecting children, adults, and elderly patients separately",
        "Diseases of the teeth, within the bone, on the mucosa/skin, and under the mucosa/skin"
      ],
      correctAnswer: 3
    },
    {
      id: 93025,
      question: "What are the four responsibilities of a Dental Hygienist when detecting oral pathology?",
      options: [
        "Identifying normal, identifying variations, documenting, disclosing findings, and monitoring",
        "Prescribing medication, performing surgery, ordering labs, and updating records",
        "Performing a biopsy, reviewing radiology, contacting specialists, and treating infection",
        "Sterilizing instruments, taking X-rays, polishing teeth, and scheduling appointments"
      ],
      correctAnswer: 0
    },
    {
      id: 93026,
      question: "What tools are used in the diagnostic process to detect and describe oral findings?",
      options: [
        "Stethoscope, otoscope, and blood pressure cuff",
        "Visual inspection, tactile palpation, and measurement",
        "Culture swabs, urinalysis strips, and spectrometry",
        "MRI, CT scan, and ultrasound imaging"
      ],
      correctAnswer: 1
    },
    {
      id: 93027,
      question: "What is a macule?",
      options: [
        "An elevated lesion less than 10 mm that contains serous fluid",
        "A circumscribed, elevated lesion containing pus of various sizes",
        "A flat lesion that is a different color than the surrounding tissue",
        "A palpable solid lesion found in soft tissue above or below the skin"
      ],
      correctAnswer: 2
    },
    {
      id: 93028,
      question: "What distinguishes a papule from other soft tissue lesions?",
      options: [
        "It is flat, diffuse, and may contain blood or exudates",
        "It is a segment of tissue that forms part of a larger whole structure",
        "It is elevated, greater than 5 mm, and filled with serous fluid",
        "It is circumscribed, elevated, and less than 10 mm in diameter"
      ],
      correctAnswer: 3
    },
    {
      id: 93029,
      question: "What is a pustule?",
      options: [
        "A circumscribed, elevated lesion of various sizes that contains pus",
        "A solid palpable lesion less than 10 mm found below the skin surface",
        "A flat lesion of different color from surrounding tissue of any size",
        "A lesion with a stem-like base resembling a mushroom attachment"
      ],
      correctAnswer: 0
    },
    {
      id: 93030,
      question: "What is a vesicle?",
      options: [
        "A circumscribed, elevated lesion greater than 5 mm filled with serous fluid",
        "An elevated lesion less than 10 mm in diameter containing serous fluid",
        "A broad-based elevated lesion with a flat attachment to surrounding tissue",
        "A segment of tissue forming a lobe that is part of a larger structure"
      ],
      correctAnswer: 1
    },
    {
      id: 93031,
      question: "What is a bulla and how does it differ from a vesicle?",
      options: [
        "A bulla is flat and white; a vesicle is elevated and red",
        "A bulla contains pus; a vesicle contains blood",
        "A bulla is greater than 5 mm and contains serous fluid; a vesicle is less than 10 mm",
        "A bulla is found only in bone; a vesicle is found only on the tongue"
      ],
      correctAnswer: 2
    },
    {
      id: 93032,
      question: "What is a lobule in terms of clinical appearance?",
      options: [
        "A flat lesion that is a different color from the surrounding tissue",
        "A solid palpable lesion found above or beneath the skin surface",
        "An elevated lesion attached to a stem-like base like a mushroom",
        "A segment or lobe that is part of a whole, sometimes appearing fused"
      ],
      correctAnswer: 3
    },
    {
      id: 93033,
      question: "What is the difference between a sessile and a pedunculated lesion?",
      options: [
        "Sessile lesions have a flat or broad base; pedunculated lesions have a stem-like base",
        "Sessile lesions are flat; pedunculated lesions contain pus",
        "Sessile lesions contain fluid; pedunculated lesions are solid",
        "Sessile lesions are larger than 5 mm; pedunculated lesions are smaller than 5 mm"
      ],
      correctAnswer: 0
    },
    {
      id: 93034,
      question: "What is a nodule?",
      options: [
        "A flat, color-differentiated lesion on the surface of the mucosa",
        "A palpable, solid lesion up to 1 cm found in soft tissue, above or below the skin",
        "An elevated lesion larger than 5 mm filled with serous fluid",
        "A circumscribed, elevated lesion with a broad flat base attachment"
      ],
      correctAnswer: 1
    },
    {
      id: 93035,
      question: "What does the color term \"erythema\" indicate in oral lesion description?",
      options: [
        "A white or pale discoloration of the oral mucosa",
        "A gray-white film that cannot be wiped off",
        "Abnormal redness of the tissue",
        "A brown or black discoloration caused by pigmentation"
      ],
      correctAnswer: 2
    },
    {
      id: 93036,
      question: "Which color-related term describes paleness of oral tissue?",
      options: [
        "Leukoplakic",
        "Erythema",
        "Melanotic",
        "Pallor"
      ],
      correctAnswer: 3
    },
    {
      id: 93037,
      question: "What does \"leukoplakic\" describe when referring to lesion color?",
      options: [
        "A white appearance of oral tissue",
        "A reddish lesion caused by increased vascularity",
        "A pale or bloodless appearance of the mucosa",
        "A gray-brown discoloration from pigment deposits"
      ],
      correctAnswer: 0
    },
    {
      id: 93038,
      question: "Which term describes a surface texture characterized by deep clefts or grooves?",
      options: [
        "Corrugated",
        "Fissured",
        "Papillary",
        "Folded"
      ],
      correctAnswer: 1
    },
    {
      id: 93039,
      question: "What does the term \"papillary\" refer to when describing surface texture?",
      options: [
        "A smooth, uniform surface without elevation or depression",
        "A wrinkled or wave-like surface pattern on the mucosa",
        "A cluster of small projections or elevations on the surface",
        "A folded surface associated with excess tissue growth"
      ],
      correctAnswer: 2
    },
    {
      id: 93040,
      question: "Which of the following terms describes a radiographic lesion appearance?",
      options: [
        "Papillary, corrugated, and folded",
        "Erythematous, leukoplakic, and pallor",
        "Sessile, pedunculated, and lobulated",
        "Radiolucent, radiopaque, and mixed"
      ],
      correctAnswer: 3
    },
    {
      id: 93041,
      question: "What does \"unilocular\" mean when describing a radiographic bone lesion?",
      options: [
        "The lesion appears as a single, undivided compartment on the radiograph",
        "The lesion causes scalloping around the roots of adjacent teeth",
        "The lesion has multiple separate compartments visible on the radiograph",
        "The lesion shows a mixed pattern of radiolucency and radiopacity"
      ],
      correctAnswer: 0
    },
    {
      id: 93042,
      question: "What is the significance of \"scalloping\" in a radiographic lesion?",
      options: [
        "It indicates the lesion is composed of multiple fused compartments",
        "It describes the relationship of the lesion to the roots of adjacent teeth",
        "It refers to the radiopaque density of the lesion's internal structure",
        "It confirms the lesion is benign and does not require treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 93043,
      question: "What are odontomas composed of?",
      options: [
        "Fibrous connective tissue, calcified deposits, and inflammatory cells",
        "Epithelial cells, cystic fluid, and keratinized tissue",
        "Mature enamel, dentin, and pulp components",
        "Bone, cartilage, and periosteal tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 93044,
      question: "What is the primary difference between compound and complex odontomas?",
      options: [
        "Compound odontomas are found in the mandible; complex odontomas in the maxilla",
        "Compound odontomas are found in adults; complex odontomas occur in children",
        "Compound odontomas are radiolucent; complex odontomas are radiopaque",
        "Compound odontomas resemble small tooth-like structures; complex odontomas have haphazardly arranged tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 93045,
      question: "In which decade of life do odontomas usually occur?",
      options: [
        "Second decade (teens)",
        "Third decade (20s–30s)",
        "First decade (under 10 years old)",
        "Fourth decade (30s–40s)"
      ],
      correctAnswer: 0
    },
    {
      id: 93046,
      question: "What is Paget disease characterized by?",
      options: [
        "A viral infection causing widespread gingival inflammation and bone loss",
        "Excessive breakdown and formation of bone, disrupting normal bone recycling",
        "A fungal overgrowth affecting the bone marrow and causing anemia",
        "A genetic condition resulting in incomplete enamel formation"
      ],
      correctAnswer: 1
    },
    {
      id: 93047,
      question: "What laboratory finding is associated with Paget disease?",
      options: [
        "Elevated white blood cell count and C-reactive protein",
        "Decreased serum calcium and elevated phosphorus levels",
        "Elevated serum alkaline phosphatase level",
        "Low hemoglobin and reduced platelet count"
      ],
      correctAnswer: 2
    },
    {
      id: 93048,
      question: "What is the primary purpose of microscopic diagnosis in oral pathology?",
      options: [
        "To determine the patient's blood type and immune status",
        "To assess bone density using specialized imaging technology",
        "To identify the patient's nutritional deficiencies and vitamin levels",
        "To provide a definitive diagnosis by examining tissue from a biopsy"
      ],
      correctAnswer: 3
    },
    {
      id: 93049,
      question: "What is the brush test used for in microscopic diagnosis?",
      options: [
        "To obtain full-thickness epithelial cells to determine if a scalpel biopsy is needed",
        "To measure the pH of saliva and assess caries risk",
        "To apply antifungal medication to the oral mucosa for treatment",
        "To collect bacterial samples for culture and sensitivity testing"
      ],
      correctAnswer: 0
    },
    {
      id: 93050,
      question: "Why can a white lesion NOT be diagnosed on clinical appearance alone?",
      options: [
        "White lesions are always benign and do not require further assessment",
        "The microscopic appearance can range from epithelial thickening to dysplasia, which may be premalignant",
        "White lesions are caused only by fungal infections that require culture testing",
        "Clinical photographs are needed alongside appearance to confirm diagnosis"
      ],
      correctAnswer: 1
    },
    {
      id: 93051,
      question: "What is a traumatic bone cyst, and how is it diagnosed surgically?",
      options: [
        "A cyst filled with pus that is diagnosed by its radiopaque appearance on X-ray",
        "A cyst containing salivary gland tissue found beneath the submandibular fossa",
        "A lesion that scallops around roots, and when opened surgically, reveals an empty void",
        "A lesion filled with serous fluid found in the mid-dorsal region of the tongue"
      ],
      correctAnswer: 2
    },
    {
      id: 93052,
      question: "What condition is diagnosed therapeutically with Nystatin cream?",
      options: [
        "Geographic tongue associated with burning sensation",
        "Necrotizing ulcerative gingivitis treated with hydrogen peroxide",
        "Hairy tongue treated with antifungal ointment",
        "Angular cheilitis when caused by a fungal condition"
      ],
      correctAnswer: 3
    },
    {
      id: 93053,
      question: "What is the differential diagnosis step in the diagnostic process?",
      options: [
        "The point where the practitioner determines which tests are needed to rule out suspected conditions",
        "The first step taken before any clinical or radiographic examination begins",
        "The final treatment plan after a definitive diagnosis has been confirmed",
        "The review of the patient's medical and dental history to identify known conditions"
      ],
      correctAnswer: 0
    },
    {
      id: 93054,
      question: "How many diagnostic categories are used to reach a final diagnosis in oral pathology?",
      options: [
        "Four",
        "Eight",
        "Ten",
        "Six"
      ],
      correctAnswer: 1
    },
    {
      id: 93055,
      question: "What type of diagnosis is made based on clinical appearance, color, shape, and texture?",
      options: [
        "Radiographic diagnosis",
        "Therapeutic diagnosis",
        "Clinical diagnosis",
        "Historical diagnosis"
      ],
      correctAnswer: 2
    },
    {
      id: 93056,
      question: "What is Fordyce's Granules?",
      options: [
        "Red-purple dilated veins found on the lateral and ventral tongue surface",
        "White striations at the occlusal plane level found on buccal mucosa",
        "A diffuse gray-white film found on the buccal mucosa that cannot be wiped off",
        "Clusters of yellow, ectopic sebaceous glands found on lips and buccal mucosa"
      ],
      correctAnswer: 3
    },
    {
      id: 93057,
      question: "Which of the following describes torus palatinus?",
      options: [
        "An exophytic bone growth located in the middle of the hard palate, more common in females",
        "An exophytic bone growth found on the buccal and labial surfaces of the jaws",
        "An exophytic bone growth on the lingual surface of the mandible, usually bilateral",
        "A sessile nodule found on the lingual gingival margin of mandibular cuspids"
      ],
      correctAnswer: 0
    },
    {
      id: 93058,
      question: "What distinguishes mandibular tori from torus palatinus?",
      options: [
        "Mandibular tori are radiolucent; torus palatinus appears radiopaque on X-ray",
        "Mandibular tori occur on the lingual surface of the mandible in the premolar area; torus palatinus is on the palate",
        "Mandibular tori are more common in females; torus palatinus affects males predominantly",
        "Mandibular tori are found on the buccal surface; torus palatinus is on the lingual surface"
      ],
      correctAnswer: 1
    },
    {
      id: 93059,
      question: "What is melanin pigmentation as a variant of normal?",
      options: [
        "A white discoloration caused by excess keratin formation on the gingiva",
        "A pathologic condition causing dark lesions on the palate requiring biopsy",
        "Physiologic pigmentation found on gingiva and oral mucosa, more common in dark-skinned individuals",
        "A brown discoloration caused by tobacco staining on the labial mucosa"
      ],
      correctAnswer: 2
    },
    {
      id: 93060,
      question: "Where are lingual varicosities typically found, and who are most commonly affected?",
      options: [
        "On the dorsal tongue surface, most common in children and adolescents",
        "On the gingival margin of mandibular cuspids, appearing as sessile nodules",
        "On the buccal mucosa, appearing as white striations more common in clenchers",
        "On the ventral and lateral tongue, appearing as red-purple prominent veins, more common in seniors"
      ],
      correctAnswer: 3
    },
    {
      id: 93061,
      question: "What is linea alba and what patient habit is it more prominent in?",
      options: [
        "A white line at the occlusal plane level on the buccal mucosa, more prominent in clenchers and grinders",
        "A diffuse gray-white film on the buccal mucosa, more prominent in African Americans",
        "Red-purple veins on the ventral tongue, more common in elderly patients",
        "Yellow clusters of sebaceous glands on the lips, more common in adults"
      ],
      correctAnswer: 0
    },
    {
      id: 93062,
      question: "What is leukoedema and how can it be identified clinically?",
      options: [
        "A white line at the occlusal plane that is more prominent with bruxism habits",
        "A diffuse gray-white film on the buccal mucosa that becomes less prominent when tissue is stretched",
        "Yellow, ectopic sebaceous glands on the lips that are asymptomatic and benign",
        "A pathologic white lesion that requires biopsy to rule out dysplasia"
      ],
      correctAnswer: 1
    },
    {
      id: 93063,
      question: "What is a lingual thyroid nodule and where is it found?",
      options: [
        "An enlarged lymph node on the lateral border of the tongue causing dysphagia",
        "A benign cystic lesion in the floor of the mouth filled with salivary secretions",
        "Thyroid tissue found in the mid-dorsal tongue behind the circumvallate papilla",
        "A fibrous growth on the anterior dorsal tongue associated with trauma"
      ],
      correctAnswer: 2
    },
    {
      id: 93064,
      question: "What is median rhomboid glossitis?",
      options: [
        "Deep grooves on the dorsal tongue with a familial trend found in 5% of population",
        "Elongated filiform papillae caused by tobacco, alcohol, or antibiotic use",
        "Red patches surrounded by a white border on the lateral and dorsal tongue surfaces",
        "A flat, rectangular, smooth, red area on the mid-dorsal tongue possibly associated with Candida albicans"
      ],
      correctAnswer: 3
    },
    {
      id: 93065,
      question: "What are the characteristics of geographic tongue?",
      options: [
        "Red patches of distinct fungiform papillae surrounded by a white border, possibly causing burning sensation",
        "Elongated filiform papillae that are white, yellow, brown, or black in color",
        "Deep grooves on the dorsal tongue with a familial trend, found in 5% of the population",
        "A smooth, flat rectangular red area in the mid-dorsal tongue associated with candida"
      ],
      correctAnswer: 0
    },
    {
      id: 93066,
      question: "What causes hairy tongue?",
      options: [
        "Median rhomboid glossitis caused by Candida overgrowth on the tongue",
        "Tobacco, alcohol, chemical rinses, antibiotics, head and neck radiation, and poor oral hygiene",
        "Thyroid tissue trapped in the tongue during embryonic development",
        "Deep fissures on the dorsal tongue caused by a hereditary familial condition"
      ],
      correctAnswer: 1
    },
    {
      id: 93067,
      question: "What are the four steps a dental hygienist must follow as part of an organized approach to detect pathology?",
      options: [
        "Prescribing medication, performing biopsy, ordering labs, and referring to a specialist",
        "Taking radiographs, performing scaling, applying fluoride, and documenting findings",
        "Careful history taking, methodical oral examinations, recognizing normal/deviations, and forming a differential diagnosis",
        "Interviewing the patient, applying topical anesthetic, probing pockets, and reviewing charts"
      ],
      correctAnswer: 2
    },
    {
      id: 93068,
      question: "Which of the following is an example of a historical diagnosis?",
      options: [
        "Using a biopsy to confirm the presence of epithelial dysplasia in a white lesion",
        "Prescribing Nystatin for angular cheilitis and observing the lesion resolve",
        "Determining that a radiolucency is a traumatic bone cyst by finding an empty void during surgery",
        "Identifying calcium channel blockers in a patient's drug history as the cause of gingival overgrowth"
      ],
      correctAnswer: 3
    },
    {
      id: 93069,
      question: "What data should a dental hygienist collect when participating in differential diagnosis?",
      options: [
        "Patient's medical and dental histories, history of the lesion, clinical description, and biopsy reports",
        "Vital signs, blood type, genetic screening, and dietary logs",
        "Social security information, insurance records, medication refill history, and surgeon notes",
        "Radiographs alone, along with the patient's chief complaint and pain level"
      ],
      correctAnswer: 0
    },
    {
      id: 93070,
      question: "What is exostosis?",
      options: [
        "An exophytic bone growth found on the lingual surface of the mandible in the premolar area",
        "An exophytic bone growth found on the buccal and labial surfaces of the maxilla and mandible",
        "An exophytic bone growth located in the midline of the hard palate",
        "A sessile bony nodule found on the dorsal surface of the tongue"
      ],
      correctAnswer: 1
    },
    {
      id: 93071,
      question: "What is fissured tongue and in what percentage of the population is it found?",
      options: [
        "A condition of elongated papillae found in 15% of the population",
        "A smooth red area on the mid-dorsal tongue found in 10% of the population",
        "Deep grooves on the dorsal tongue with a familial trend, found in 5% of the population",
        "A geographic pattern of red and white patches found in 20% of the population"
      ],
      correctAnswer: 2
    },
    {
      id: 93072,
      question: "Oral Pathology is a specialty of both dentistry and pathology that investigates the causes, processes, and effects of diseases affecting the oral and maxillofacial regions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93073,
      question: "Stress is always harmful and is the sole cause of disease, with no positive effects on the body.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93074,
      question: "The Exhaustion Stage of the General Adaptation Syndrome occurs when hormone levels are elevated and essential body systems operate at peak performance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93075,
      question: "A vesicle is an elevated lesion less than 10 mm in diameter that contains serous fluid.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93076,
      question: "Leukoedema is more prominent when the buccal mucosa tissue is stretched.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93077,
      question: "Mandibular tori are typically found bilaterally on the lingual surface of the mandible in the premolar area above the mylohyoid ridge.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93078,
      question: "A white oral lesion can be definitively diagnosed based on clinical appearance alone without microscopic examination.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93079,
      question: "The differential diagnosis is the final step in the diagnostic process where the practitioner determines which tests are needed to rule out suspected conditions and establish a definitive diagnosis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "2. Diagnostic Methods Chapter 1": [
    {
      id: 93080,
      question: "How many official methods of diagnosis are used in oral pathology?",
      options: [
        "Eight",
        "Six",
        "Ten",
        "Five"
      ],
      correctAnswer: 0
    },
    {
      id: 93081,
      question: "What is the primary basis of a clinical diagnosis?",
      options: [
        "Laboratory blood test results and urinalysis findings",
        "The clinical appearance of the lesion, including color, shape, and location",
        "Radiographic images and bone density measurements",
        "Microscopic examination of a biopsy specimen taken from the lesion"
      ],
      correctAnswer: 1
    },
    {
      id: 93082,
      question: "When is biopsy or surgical intervention NOT necessary in clinical diagnosis?",
      options: [
        "When the patient has confirmed systemic disease affecting the oral cavity",
        "When the lesion is larger than 1 cm and has changed in color recently",
        "When unique clinical information alone is sufficient to lead to a diagnosis",
        "When the lesion has been stable and present for more than six months"
      ],
      correctAnswer: 2
    },
    {
      id: 93083,
      question: "Which of the following is an example of a condition diagnosable by clinical appearance alone?",
      options: [
        "Leukoplakia requiring microscopic confirmation to assess dysplasia",
        "Traumatic bone cyst requiring surgical opening to find an empty void",
        "Paget disease requiring elevated serum alkaline phosphatase for confirmation",
        "Fordyce granules identified by their yellow clustered appearance on buccal mucosa"
      ],
      correctAnswer: 3
    },
    {
      id: 93084,
      question: "What clinical features are gathered when making a clinical diagnosis?",
      options: [
        "Color, shape, location, and history of the lesion",
        "Radiographic density, bone margin definition, and root relationship",
        "Blood type, white cell count, and family medical history",
        "Biopsy results, culture sensitivity reports, and tissue architecture"
      ],
      correctAnswer: 0
    },
    {
      id: 93085,
      question: "An amalgam tattoo in an edentulous area is best explained by which diagnostic component?",
      options: [
        "Laboratory history confirming heavy metal deposits in tissue",
        "History of the lesion combined with knowledge of a prior tooth extraction at the site",
        "Surgical history of a previously biopsied mucosal lesion at that site",
        "Radiographic history showing retained amalgam fragments in bone"
      ],
      correctAnswer: 1
    },
    {
      id: 93086,
      question: "What provides the main strength of a radiographic diagnosis?",
      options: [
        "The patient's reported symptoms and duration of the condition",
        "Blood chemistry results combined with urinalysis findings",
        "The radiograph itself providing sufficient information to establish a diagnosis",
        "Microscopic analysis of extracted tissue samples from the lesion"
      ],
      correctAnswer: 2
    },
    {
      id: 93087,
      question: "Which of the following conditions is best identified through radiographic diagnosis?",
      options: [
        "Fordyce granules presenting as yellow clusters on lips and buccal mucosa",
        "Melanin pigmentation on the gingiva in dark-skinned individuals",
        "Hairy tongue caused by tobacco use and antibiotic therapy",
        "Dental caries, root resorption, and interproximal calculus"
      ],
      correctAnswer: 3
    },
    {
      id: 93088,
      question: "What are nutrient canals and what do they contain?",
      options: [
        "Tube-like passageways through bone that contain nerves and blood vessels supplying teeth",
        "Calcified deposits within bone that appear radiopaque on radiographs",
        "Enlarged marrow spaces that appear as multilocular radiolucent defects in bone",
        "Pathologic voids in cortical bone that appear as well-defined radiopaque areas"
      ],
      correctAnswer: 0
    },
    {
      id: 93089,
      question: "How do nutrient canals appear radiographically and where are they most prominent?",
      options: [
        "As horizontal radiopaque lines, most prominent in the posterior maxilla",
        "As vertical radiolucent lines, most prominent in the anterior mandible where bone is thin",
        "As multilocular radiolucent defects, most prominent in the premolar-molar region",
        "As mixed density lesions, most prominent at the apices of maxillary incisors"
      ],
      correctAnswer: 1
    },
    {
      id: 93090,
      question: "What is internal root resorption and how does it appear radiographically?",
      options: [
        "Excessive cementum deposition at the root apex appearing as a bulbous opacity",
        "Calcification within the pulp chamber appearing as a radiopaque mass",
        "An oval or balloon-shaped radiolucent widening within the pulp canal or root dentin",
        "Widening of the periodontal ligament space surrounding the entire root"
      ],
      correctAnswer: 2
    },
    {
      id: 93091,
      question: "What is the key principle of historical diagnosis?",
      options: [
        "It is an optional step rarely used in modern diagnostic procedures",
        "It only applies to conditions that are genetic and inherited in nature",
        "It replaces the need for clinical examination in patients with systemic disease",
        "Historical data combined with observation can be the most important diagnostic contribution"
      ],
      correctAnswer: 3
    },
    {
      id: 93092,
      question: "Which of the following types of information is collected during a historical diagnosis?",
      options: [
        "Medical history, dental history, family history, and personal history",
        "Biopsy pathology results, culture reports, and drug sensitivity data",
        "Radiographic bone density, lesion surface texture, and lesion color",
        "Blood pressure readings, heart rate, oxygen saturation, and glucose levels"
      ],
      correctAnswer: 0
    },
    {
      id: 93093,
      question: "Which genetic condition is an example that requires historical diagnosis?",
      options: [
        "Geographic tongue with its characteristic red patches and white borders",
        "Amelogenesis imperfecta, a hereditary defect affecting enamel formation",
        "Hairy tongue caused by antibiotic use and poor oral hygiene practices",
        "Median rhomboid glossitis possibly associated with Candida albicans"
      ],
      correctAnswer: 1
    },
    {
      id: 93094,
      question: "What types of laboratory tests can lead to a diagnosis in oral pathology?",
      options: [
        "Pulp vitality testing and periodontal probing depth measurements",
        "Bite-wing radiographic interpretation and tactile clinical palpation",
        "Blood chemistries, urinalysis, and culture tests",
        "Salivary flow rate testing and transillumination of hard dental tissues"
      ],
      correctAnswer: 2
    },
    {
      id: 93095,
      question: "What laboratory finding is significant in diagnosing Paget disease?",
      options: [
        "Elevated white blood cell count and reduced platelet levels",
        "Decreased serum calcium and elevated serum phosphorus levels",
        "Low hemoglobin and elevated red blood cell sedimentation rate",
        "Elevated serum alkaline phosphatase level"
      ],
      correctAnswer: 3
    },
    {
      id: 93096,
      question: "What is the distinctive radiographic appearance associated with Paget disease?",
      options: [
        "Cotton-wool effect and hypercementosis on the roots of affected teeth",
        "Unilocular radiolucency with well-defined borders and root resorption",
        "Vertical radiolucent lines and widened periodontal ligament spaces",
        "Mixed multilocular radiolucency with irregular poorly defined borders"
      ],
      correctAnswer: 0
    },
    {
      id: 93097,
      question: "What is the main source of information in a microscopic diagnosis?",
      options: [
        "The radiograph showing the extent and internal density of the lesion",
        "Microscopic examination of a biopsy specimen taken from the lesion",
        "Blood chemistry results confirming elevated serum enzyme levels",
        "The patient's medical history and prior response to treatments"
      ],
      correctAnswer: 1
    },
    {
      id: 93098,
      question: "Why must the practitioner be skilled when obtaining tissue for microscopic diagnosis?",
      options: [
        "To avoid altering the radiographic appearance of adjacent structures",
        "To ensure that the lesion is documented thoroughly before tissue removal",
        "To obtain an adequate tissue sample that allows accurate microscopic evaluation",
        "To prevent the need for any laboratory or therapeutic testing afterward"
      ],
      correctAnswer: 2
    },
    {
      id: 93099,
      question: "Which of the following conditions requires microscopic diagnosis to establish a definitive finding?",
      options: [
        "Geographic tongue identified by its red patches surrounded by white borders",
        "Lingual varicosities identified by their red-purple color on ventral tongue",
        "Torus palatinus identified by its exophytic midpalatal bony location",
        "Leukoplakia and erythroplakia to assess the degree of epithelial dysplasia"
      ],
      correctAnswer: 3
    },
    {
      id: 93100,
      question: "What is erythroplakia defined as?",
      options: [
        "A pre-malignant red patch that cannot be rubbed off and cannot be characterized as any other disease",
        "A gray-white film on the buccal mucosa that fades when tissue is stretched",
        "A red lesion caused by trauma that resolves after the irritant is removed",
        "A white patch that can be wiped off and is associated with Candida infection"
      ],
      correctAnswer: 0
    },
    {
      id: 93101,
      question: "What causes the red color of erythroplakia clinically?",
      options: [
        "Bacterial pigmentation staining the surface layers of the oral mucosa",
        "Vascular submucosal tissue shining through under-keratinized mucosa",
        "Hemorrhage pooling into the submucosal connective tissue layer",
        "Increased keratin deposition causing reflective color changes on the surface"
      ],
      correctAnswer: 1
    },
    {
      id: 93102,
      question: "How does the malignant potential of erythroplakia compare to leukoplakia?",
      options: [
        "Erythroplakia has the same malignant potential as leukoplakia",
        "Erythroplakia has a malignant potential 5 times greater than leukoplakia",
        "Erythroplakia has a malignant potential 17 times greater than leukoplakia",
        "Erythroplakia has a lower malignant potential than leukoplakia"
      ],
      correctAnswer: 2
    },
    {
      id: 93103,
      question: "What is the treatment for erythroplakia?",
      options: [
        "Topical antifungal cream applied to the affected area twice daily",
        "Hydrogen peroxide rinses and improved oral hygiene measures only",
        "Vitamin supplementation and dietary modification therapy",
        "Excision biopsy to remove and histologically examine the lesion"
      ],
      correctAnswer: 3
    },
    {
      id: 93104,
      question: "What is the main source of information in a surgical diagnosis?",
      options: [
        "Information gained directly during the surgical procedure itself",
        "The patient's drug history and documented systemic medical conditions",
        "The radiographic appearance of the lesion identified prior to surgery",
        "Microscopic findings obtained from a pre-operative incisional biopsy"
      ],
      correctAnswer: 0
    },
    {
      id: 93105,
      question: "What conclusive surgical finding confirms the diagnosis of a traumatic bone cyst?",
      options: [
        "Serous fluid filling the cystic space surrounded by a fibrous capsule",
        "An empty void within the bone with no epithelial lining present",
        "Keratinized epithelial lining within a multilocular cystic space",
        "Granulomatous tissue with chronic inflammatory cells replacing bone"
      ],
      correctAnswer: 1
    },
    {
      id: 93106,
      question: "What are the radiographic features of a traumatic bone cyst?",
      options: [
        "Radiopaque mass with a surrounding thin radiolucent halo",
        "Mixed radiopaque and radiolucent lesion with ill-defined borders",
        "Well-delineated radiolucent defect, unilocular or multilocular, with scalloping between roots and no root resorption",
        "Multilocular radiolucency with root resorption of all adjacent teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 93107,
      question: "Where is the traumatic bone cyst essentially restricted to?",
      options: [
        "The anterior maxilla near the canine and incisor region",
        "The condylar and ramus region of the mandible",
        "Both jaws equally, with no jaw predilection reported",
        "The mandible, most commonly in the premolar-molar region"
      ],
      correctAnswer: 3
    },
    {
      id: 93108,
      question: "What sex predominance is noted for traumatic bone cysts?",
      options: [
        "60% male predominance",
        "Equal distribution between males and females",
        "75% female predominance",
        "80% male predominance"
      ],
      correctAnswer: 0
    },
    {
      id: 93109,
      question: "What typically happens to the surgical void after intervention for a traumatic bone cyst?",
      options: [
        "It becomes filled with scar tissue and remains as a permanent fibrous defect",
        "It fills with bone and heals naturally after the surgical procedure",
        "It must be packed with bone graft material to ensure complete healing",
        "It collapses and requires placement of a drainage tube for recovery"
      ],
      correctAnswer: 1
    },
    {
      id: 93110,
      question: "What is the fundamental principle of therapeutic diagnosis?",
      options: [
        "A diagnosis is confirmed through laboratory culture and sensitivity testing",
        "Diagnosis is made through surgical exploration and direct visual inspection",
        "A condition is identified based on the patient's response to treatment",
        "A condition is confirmed through microscopic analysis of tissue samples"
      ],
      correctAnswer: 2
    },
    {
      id: 93111,
      question: "Why does NUG respond to hydrogen peroxide rinses as a therapeutic diagnosis?",
      options: [
        "Hydrogen peroxide kills all oral bacteria regardless of their oxygen requirements",
        "Hydrogen peroxide reduces inflammation by blocking prostaglandin synthesis",
        "Hydrogen peroxide dissolves the pseudomembrane that covers the necrotic papillae",
        "The anaerobic NUG bacteria cannot survive in an oxygenated environment created by peroxide"
      ],
      correctAnswer: 3
    },
    {
      id: 93112,
      question: "What makes NUG an example of therapeutic rather than laboratory diagnosis?",
      options: [
        "Hydrogen peroxide rinses are prescribed and results observed without culturing bacteria",
        "NUG is confirmed by its characteristic pattern of bone loss on radiographs",
        "NUG can only be confirmed through blood culture testing of the organisms",
        "NUG bacteria are definitively identified through microscopic tissue examination"
      ],
      correctAnswer: 0
    },
    {
      id: 93113,
      question: "What is differential diagnosis in the context of oral pathology?",
      options: [
        "The first step taken before any clinical examination of the patient begins",
        "The point where the practitioner decides which tests are needed to rule out suspected conditions",
        "The process of reviewing radiographs to identify the most likely condition",
        "A synonym for clinical diagnosis made solely through visual examination"
      ],
      correctAnswer: 1
    },
    {
      id: 93114,
      question: "What must be applied when completing a differential diagnosis?",
      options: [
        "Prescribing medications and monitoring patient response over time",
        "Performing surgical biopsy and interpreting histopathology slides alone",
        "All previously discussed diagnostic categories used as combined tools",
        "Reading laboratory values and interpreting blood chemistry panels only"
      ],
      correctAnswer: 2
    },
    {
      id: 93115,
      question: "How is a lesion defined in this lecture?",
      options: [
        "Any discoloration of the oral mucosa regardless of cause or clinical severity",
        "A raised or elevated area of soft tissue found anywhere in the oral cavity",
        "Any finding that deviates from normal and requires an immediate biopsy",
        "A pathological change in an organ or tissue that alters normal form or function"
      ],
      correctAnswer: 3
    },
    {
      id: 93116,
      question: "What is the first step in the assessment of oral pathologic conditions?",
      options: [
        "Detection or recognition of a lesion during examination",
        "Performing a complete radiographic survey to assess bone involvement",
        "Ordering laboratory tests to confirm the initial clinical impression",
        "Taking a complete medical and dental history from the patient"
      ],
      correctAnswer: 0
    },
    {
      id: 93117,
      question: "What are the four steps of the organized DH approach to detecting oral pathology?",
      options: [
        "Documenting, prescribing, monitoring, and referring to a specialist",
        "Careful history taking, methodical examination, recognizing normal and deviations, forming a differential diagnosis",
        "Clinical diagnosis, radiographic diagnosis, laboratory testing, and biopsy",
        "Palpating, probing, documenting, and radiographing all oral structures"
      ],
      correctAnswer: 1
    },
    {
      id: 93118,
      question: "Which of the following is NOT listed as a DH responsibility in this lecture?",
      options: [
        "Understanding what is normal and identifying variations of normal",
        "Documenting accurate findings and disclosing them to the client and DDS",
        "Prescribing antifungal medications and independently performing surgical biopsies",
        "Determining and implementing treatment modalities and monitoring the situation"
      ],
      correctAnswer: 2
    },
    {
      id: 93119,
      question: "What must a dental hygienist do after identifying findings during an oral examination?",
      options: [
        "Disclose the findings only to the dentist and not to the patient directly",
        "Only report findings that appear clearly pathological and require biopsy",
        "Wait for the dentist to confirm the findings before documenting anything",
        "Disclose findings to both the client and the dentist (DDS)"
      ],
      correctAnswer: 3
    },
    {
      id: 93120,
      question: "In clinical diagnosis, biopsy or surgical intervention is always required regardless of the clinical appearance of the lesion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93121,
      question: "Radiographic diagnosis is based primarily on the radiograph, with clinical and historical data serving only as secondary contributors.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93122,
      question: "Nutrient canals appear as vertical radiolucent lines on radiographs and are most prominent in the anterior mandible where bone is thin.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93123,
      question: "Erythroplakia has a malignant potential 17 times greater than leukoplakia and its primary treatment is excision biopsy.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93124,
      question: "The traumatic bone cyst is most commonly found in the maxilla and has a 60% female sex predominance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93125,
      question: "In therapeutic diagnosis, NUG is confirmed by culturing the specific bacteria from the lesion to identify the organisms involved.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93126,
      question: "Differential diagnosis is the final step where the practitioner determines which tests are required to rule out suspected conditions and establish a definitive diagnosis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "3. Introduction to Preliminary Diagnosis of Oral Lesions": [
    {
      id: 93127,
      question: "Which of the following is one of the three ways oral lesions are grouped according to this lecture?",
      options: [
        "By presumed origin, such as odontogenic and non-odontogenic cysts",
        "By the patient's age and gender at time of discovery",
        "By treatment cost and insurance classification",
        "By the clinician's specialty area and training level"
      ],
      correctAnswer: 0
    },
    {
      id: 93128,
      question: "Which classification of dental disease refers to lesions found beneath the mucosa or skin surface?",
      options: [
        "Diseases occurring under the mucosa or skin surface (submucosa)",
        "Diseases of the teeth and hard structures only",
        "Diseases occurring on the mucosa or skin surface",
        "Diseases occurring within the bone or jaws"
      ],
      correctAnswer: 0
    },
    {
      id: 93129,
      question: "What is a bulla?",
      options: [
        "A flat area distinguished only by a color difference from surrounding tissue",
        "A small solid lesion less than 1 cm that protrudes above normal tissue",
        "A circumscribed, elevated lesion more than 5 mm in diameter containing serous fluid",
        "A lesion with completely undefined and irregular borders"
      ],
      correctAnswer: 2
    },
    {
      id: 93130,
      question: "What type of fluid is most commonly found inside a bulla?",
      options: [
        "Mucinous thick secretion from nearby salivary glands",
        "Serous fluid, giving it a blister-like appearance",
        "Purulent exudate mixed with necrotic debris",
        "Sanguinous blood from ruptured capillaries in the area"
      ],
      correctAnswer: 1
    },
    {
      id: 93131,
      question: "A lobule is best described as which of the following?",
      options: [
        "A segment or lobe that is part of a whole, with lobes sometimes appearing fused",
        "A flat discolored area that does not protrude above surrounding tissue",
        "A palpable solid nodule up to 1 cm found in soft tissue",
        "A circumscribed elevated lesion greater than 5 mm containing fluid"
      ],
      correctAnswer: 0
    },
    {
      id: 93132,
      question: "Where is a lobulated torus palatinus located, making it a clinical example of a lobule?",
      options: [
        "On the hard palate, illustrating the lobule appearance with fused lobes",
        "On the buccal mucosa along the plane of occlusion",
        "Along the lingual surface of the mandible bilaterally",
        "On the gingival margin of the mandibular cuspids"
      ],
      correctAnswer: 0
    },
    {
      id: 93133,
      question: "How is a macule defined?",
      options: [
        "An elevated solid lesion less than 1 cm that protrudes above normal tissue",
        "A raised fluid-filled lesion greater than 5 mm in diameter",
        "A flat area distinguished by a color different from the surrounding tissue",
        "A cleft or groove in the surface tissue showing prominent depth"
      ],
      correctAnswer: 2
    },
    {
      id: 93134,
      question: "Which of the following is given as a classic example of a macule?",
      options: [
        "A sessile fibroma on the buccal mucosa",
        "A freckle on the skin or lip",
        "A pustule on the gingival sulcus tissue",
        "A vesicle filled with serous fluid on the soft palate"
      ],
      correctAnswer: 1
    },
    {
      id: 93135,
      question: "What is the definition of a papule?",
      options: [
        "A small, circumscribed lesion less than 1 cm in diameter that is elevated above normal tissue",
        "A palpable solid lesion more than 1 cm found deep in submucosa",
        "A circumscribed lesion more than 5 mm containing serous or blood-filled fluid",
        "A variously sized circumscribed elevation containing pus"
      ],
      correctAnswer: 0
    },
    {
      id: 93136,
      question: "What is a pustule?",
      options: [
        "A flat area that is distinguished by a color different from surrounding tissue",
        "An elevated solid nodule that can occur above or below the skin surface",
        "A variously sized circumscribed elevation containing pus",
        "A small elevated lesion less than 1 cm containing serous fluid"
      ],
      correctAnswer: 2
    },
    {
      id: 93137,
      question: "How does a vesicle differ from a bulla in terms of size?",
      options: [
        "A vesicle is less than 1 cm in diameter, while a bulla is more than 5 mm in diameter",
        "A vesicle is flat while a bulla is elevated above the tissue surface",
        "A vesicle is found only in bone while a bulla occurs on soft tissue",
        "A vesicle contains pus while a bulla always contains blood"
      ],
      correctAnswer: 0
    },
    {
      id: 93138,
      question: "What does \"pedunculated\" mean when describing the base of a lesion?",
      options: [
        "The base is flat or broad rather than stemlike",
        "The base is attached by a stem-like or stalk-like structure similar to a mushroom",
        "The lesion has multiple lobes that appear fused together",
        "The lesion is fluid-filled and compressible on palpation"
      ],
      correctAnswer: 1
    },
    {
      id: 93139,
      question: "How is a sessile lesion base defined?",
      options: [
        "A sessile base is flat or broad instead of stemlike",
        "Attached by a stem-like or stalk-like base similar to that of a mushroom",
        "Defined by multiple lobes or compartments that are fused together",
        "Describes a lesion with borders that are not well defined"
      ],
      correctAnswer: 0
    },
    {
      id: 93140,
      question: "Palpation is defined as which of the following?",
      options: [
        "The evaluation of a lesion by feeling it with the fingers to determine tissue texture",
        "Measuring the diameter of a lesion using a calibrated periodontal probe",
        "The process of describing the surface texture using standardized visual criteria",
        "The radiographic evaluation of bone density using digital imaging"
      ],
      correctAnswer: 0
    },
    {
      id: 93141,
      question: "Which soft tissue consistency term describes a fluid-filled lesion on palpation?",
      options: [
        "Fluctuant",
        "Indurated",
        "Compressible",
        "Bony hard"
      ],
      correctAnswer: 0
    },
    {
      id: 93142,
      question: "What does \"indurated\" mean when describing soft tissue consistency during palpation?",
      options: [
        "Soft and easily deformable with light finger pressure",
        "Extremely firm on palpation, harder than normal tissue",
        "Fluid-filled and fluctuant on palpation",
        "Spongy and compressible with notable rebound"
      ],
      correctAnswer: 1
    },
    {
      id: 93143,
      question: "What does erythema mean in the context of describing oral lesion color?",
      options: [
        "A white plaque-like lesion that cannot be rubbed off the mucosa",
        "Paleness of the skin or mucosal tissues throughout",
        "Abnormal redness of the mucosa or gingiva",
        "A smooth red patch or granular velvety red area on the mucosa"
      ],
      correctAnswer: 2
    },
    {
      id: 93144,
      question: "How is erythroplakia described clinically?",
      options: [
        "A smooth red patch or granular red and velvety patch on the oral mucosa",
        "Paleness or whitish discoloration of the gingival and buccal tissues",
        "An abnormal redness that appears uniformly across the entire mucosa",
        "A white plaque-like lesion on the mucosa that cannot be rubbed off"
      ],
      correctAnswer: 0
    },
    {
      id: 93145,
      question: "What percentage of erythroplakias demonstrate epithelial dysplasia or squamous cell carcinoma?",
      options: [
        "90%",
        "75%",
        "50%",
        "25%"
      ],
      correctAnswer: 0
    },
    {
      id: 93146,
      question: "How is leukoplakia defined clinically?",
      options: [
        "An abnormal redness of the mucosa or gingiva related to inflammation",
        "A red granular patch that is less common than white lesions of the mucosa",
        "A white plaque-like lesion on oral mucosa that cannot be rubbed off or diagnosed as a specific disease",
        "Paleness of the skin or mucosal tissues due to reduced vascularity"
      ],
      correctAnswer: 2
    },
    {
      id: 93147,
      question: "What clinical instrument is described as being of great assistance in documenting lesion size in millimeters?",
      options: [
        "A calibrated dental explorer with depth markings",
        "A periodontal probe",
        "A digital caliper with millimeter increments",
        "A radiographic ruler placed directly at the lesion site"
      ],
      correctAnswer: 1
    },
    {
      id: 93148,
      question: "Which periodontal probe has markings at 1, 2, 3, 5, 7, 8, 9, and 10 mm?",
      options: [
        "Williams probe",
        "PSR probe",
        "Michigan \"O\" probe",
        "Marquis probe"
      ],
      correctAnswer: 0
    },
    {
      id: 93149,
      question: "What surface texture term describes a wrinkled appearance of the mucosal surface?",
      options: [
        "Papillary",
        "Folded",
        "Corrugated",
        "Fissured"
      ],
      correctAnswer: 2
    },
    {
      id: 93150,
      question: "What does \"papillary\" mean as a surface texture descriptor for oral lesions?",
      options: [
        "A cleft or groove in the surface tissue showing prominent depth",
        "A wrinkled or creased appearance of the mucosal surface",
        "A surface that shows folds or ridges due to excess tissue",
        "Resembling small nipple-shaped projections or elevations found in clusters"
      ],
      correctAnswer: 3
    },
    {
      id: 93151,
      question: "How is a \"fissure\" described as a surface texture term?",
      options: [
        "Resembling small nipple-shaped projections or elevations found in clusters",
        "A cleft or groove showing prominent depth in the tissue surface",
        "A wrinkled appearance of the mucosa or skin surface",
        "A folded surface texture caused by excess tissue growth"
      ],
      correctAnswer: 1
    },
    {
      id: 93152,
      question: "How is coalescence defined as a radiographic bone term?",
      options: [
        "A single well-defined compartment that is clearly outlined on radiographs",
        "A lesion with borders that are not well defined making parameters impossible to detect",
        "The process by which parts of a whole join together or fuse to make one",
        "A lesion that extends beyond the confines of one distinct area into multiple lobes"
      ],
      correctAnswer: 2
    },
    {
      id: 93153,
      question: "What does a \"diffuse\" lesion describe radiographically?",
      options: [
        "A lesion with clearly defined borders allowing easy detection of its full extent",
        "A lesion composed of many lobes or parts that are somewhat fused together",
        "A lesion showing a mixture of light and dark areas indicating different stages",
        "A lesion with borders that are not well defined, making exact parameters impossible to detect"
      ],
      correctAnswer: 3
    },
    {
      id: 93154,
      question: "What term describes a radiographic lesion with many lobes or parts fused together, sometimes described as resembling soap bubbles?",
      options: [
        "Unilocular",
        "Multilocular",
        "Diffuse",
        "Scalloping"
      ],
      correctAnswer: 1
    },
    {
      id: 93155,
      question: "What does \"radiolucent\" describe on a dental radiograph?",
      options: [
        "White or light areas where radiant energy cannot pass through dense structures",
        "A mixture of light and dark areas within a lesion denoting a developmental stage",
        "Clearly defined borders of a lesion showing its exact margins and extent",
        "Black or dark areas where radiant energy passes through less dense structures"
      ],
      correctAnswer: 3
    },
    {
      id: 93156,
      question: "What is a radiopaque structure on a radiograph, and which tissue example is given in the lecture?",
      options: [
        "Dark areas on the film; soft tissue such as muscle is a typical example",
        "Mixed light and dark areas; cementum at the root apex is a typical example",
        "Light or white areas; denser structures appear whiter, with amalgam as an example",
        "Completely black areas; the pulp of the tooth is a typical example"
      ],
      correctAnswer: 2
    },
    {
      id: 93157,
      question: "What does the combined \"radiolucent and radiopaque\" appearance of a lesion indicate?",
      options: [
        "The lesion is benign requiring only monitoring in community practice",
        "A mixture of light and dark areas within a lesion that denotes a stage in lesion development",
        "The lesion is completely radiolucent extending into all adjacent bone and tissue",
        "A single well-defined compartment clearly outlined with distinct borders"
      ],
      correctAnswer: 1
    },
    {
      id: 93158,
      question: "What is root resorption, and what are listed as possible causes?",
      options: [
        "A radiographic finding where the root apex appears shortened or blunted due to a cyst, tumor, or trauma",
        "Thickening of the periodontal ligament space due to inflammatory processes",
        "Excessive calcification of the pulp canal making it appear radiopaque",
        "Normal bone overgrowth at the root apex without any disease process involved"
      ],
      correctAnswer: 0
    },
    {
      id: 93159,
      question: "How does external root resorption differ from internal root resorption?",
      options: [
        "External arises from within pulp tissue, while internal arises from the periodontal ligament outside",
        "External is always pathological, while internal is a normal part of tooth development",
        "External appears as radiopacity in the crown, while internal appears as radiolucency in the apex",
        "External arises from tissue outside the tooth like the periodontal ligament, while internal is triggered by pulpal tissue reaction from within"
      ],
      correctAnswer: 3
    },
    {
      id: 93160,
      question: "What does scalloping around the root describe on a radiograph?",
      options: [
        "A well-defined radiolucency with a thick corticated border around a single root",
        "A multilocular radiolucency with many soap-bubble-like compartments visible",
        "A mixed radiolucent and radiopaque area indicating a stage of lesion development",
        "A radiolucent lesion that appears to extend up the periodontal ligament and between the roots"
      ],
      correctAnswer: 3
    },
    {
      id: 93161,
      question: "What is a unilocular lesion on a radiograph?",
      options: [
        "A lesion with borders that are not well defined and parameters impossible to detect",
        "Having one compartment or unit that is well defined or outlined, as in a simple radicular cyst",
        "A lesion composed of many lobes or parts that are somewhat fused together",
        "A radiolucent lesion that extends up the periodontal ligament and between the roots"
      ],
      correctAnswer: 1
    },
    {
      id: 93162,
      question: "What does \"well circumscribed\" mean when describing a radiographic lesion?",
      options: [
        "The lesion has borders that are not well defined making exact parameters impossible",
        "The lesion extends beyond the confines of one distinct area into multiple lobes",
        "The lesion has a mixture of light and dark areas denoting a stage in development",
        "A lesion with specifically defined borders where one can clearly see the exact margins and extent"
      ],
      correctAnswer: 3
    },
    {
      id: 93163,
      question: "According to the suspicious oral lesion referral pathway, what is the next step when a suspicious lesion resolves at a 3-week re-evaluation?",
      options: [
        "The patient is monitored in community practice with continued observation",
        "The patient is immediately referred to a cancer agency for oncology assessment",
        "The patient is referred to a general dentist comfortable with biopsy procedures",
        "The lesion is treated with antifungal agents and re-evaluated in 3 more weeks"
      ],
      correctAnswer: 0
    },
    {
      id: 93164,
      question: "What is a differential diagnosis in clinical practice?",
      options: [
        "A list of diseases sharing signs and symptoms investigated to narrow down to a definitive diagnosis",
        "A radiographic classification system used to categorize bone lesions by location",
        "A color-coding system used to document lesion characteristics in the patient chart",
        "A confirmed final pathological diagnosis reached after biopsy results are obtained"
      ],
      correctAnswer: 0
    },
    {
      id: 93165,
      question: "What information does a dental hygienist collect when contributing to a differential diagnosis?",
      options: [
        "Insurance classification codes, billing information, and referral documentation",
        "Microscopic tissue samples, blood cultures, and specialized imaging orders",
        "Prescription drug history, allergies, and specialist contact information only",
        "Patient medical, dental, and social history; lesion history; clinical description; and signs and symptoms"
      ],
      correctAnswer: 3
    },
    {
      id: 93166,
      question: "What is linea alba?",
      options: [
        "A translucent opalescent covering over the buccal mucosa that disappears when stretched",
        "Prominent lingual veins on the ventral tongue appearing red to purple in color",
        "A white line along the plane of occlusion that can be unilateral or bilateral",
        "Yellow nodules along the buccal mucosa that actively secrete sebum"
      ],
      correctAnswer: 2
    },
    {
      id: 93167,
      question: "Which habit is known to make linea alba more prominent in patients?",
      options: [
        "Tongue thrusting or habitual lip licking behaviors",
        "Chronic mouth breathing through the oral cavity",
        "Clenching or bruxing habits",
        "Habitual gum chewing on one side of the mouth"
      ],
      correctAnswer: 2
    },
    {
      id: 93168,
      question: "What are Fordyce granules?",
      options: [
        "Prominent lingual veins appearing red to purple on the ventral and lateral tongue",
        "Ectopic sebaceous glands appearing as yellow nodules along the buccal and labial mucosa",
        "Excessive bone growth occurring in the absence of other disease processes",
        "A sessile nodule on the gingival margin of the mandibular cuspids"
      ],
      correctAnswer: 1
    },
    {
      id: 93169,
      question: "What percentage of adults over age 20 have Fordyce granules?",
      options: [
        "Less than 20%",
        "Approximately 35%",
        "Approximately 50%",
        "More than 80%"
      ],
      correctAnswer: 3
    },
    {
      id: 93170,
      question: "What is leukoedema and how is it identified clinically?",
      options: [
        "A sessile nodule on the lingual gingival margin most often seen in children",
        "Excessive bone growth along the palatal suture line in the absence of disease",
        "A generalized translucent or opalescent covering of the buccal mucosa that disappears when stretched",
        "Prominent veins on the ventral tongue appearing as red to purple clusters"
      ],
      correctAnswer: 2
    },
    {
      id: 93171,
      question: "In which population is leukoedema most commonly observed, and what is the prevalence rate?",
      options: [
        "Young adults of Asian descent under 30 years of age with up to 50%",
        "Elderly patients over age 70 with dentures with a prevalence of 60%",
        "Children under age 12 regardless of ethnic background at up to 40%",
        "Dark-skinned individuals, occurring in up to 85% of this group"
      ],
      correctAnswer: 3
    },
    {
      id: 93172,
      question: "What are torus palatinus and torus mandibularis classified as in terms of clinical diagnosis?",
      options: [
        "Cystic lesions requiring biopsy and surgical removal for proper diagnosis",
        "Inflammatory lesions caused by chronic irritation from dental appliances",
        "Variant manifestations of leukoplakia restricted to bony prominences",
        "Excessive growth of normal bone (exostoses) occurring in the absence of other disease processes"
      ],
      correctAnswer: 3
    },
    {
      id: 93173,
      question: "Where does torus mandibularis most often occur?",
      options: [
        "Along the midline of the hard palate at the palatal suture line",
        "Bilaterally along the lingual surface of the mandible",
        "On the dorsal tongue posterior to the circumvallate papillae",
        "Unilaterally on the maxillary alveolar ridge near the canine"
      ],
      correctAnswer: 1
    },
    {
      id: 93174,
      question: "What is melanin pigmentation of the oral cavity?",
      options: [
        "An abnormal redness of the mucosa that may indicate inflammatory disease",
        "A white plaque-like covering of the gingiva not attributed to specific pathology",
        "Pigmentation from melanin giving color to skin, eyes, hair, mucosa, and gingiva, most common in dark-skinned individuals",
        "Yellow nodules along the buccal mucosa secreting sebum as a normal variant"
      ],
      correctAnswer: 2
    },
    {
      id: 93175,
      question: "What are lingual varicosities, and in which age group are they most commonly found?",
      options: [
        "Sessile nodules on the gingival margin of mandibular cuspids, most common in children",
        "Yellow translucent nodules on the ventral tongue, most common in middle-aged adults",
        "Ectopic sebaceous glands along the lateral tongue, most common in adults over age 20",
        "Prominent lingual veins appearing as red to purple enlarged vessels on the tongue, most common in individuals over age 60"
      ],
      correctAnswer: 3
    },
    {
      id: 93176,
      question: "What is the retrocuspid papilla, and in whom is it most often observed?",
      options: [
        "Ectopic sebaceous glands secreting sebum along the buccal and labial mucosa",
        "A translucent opalescent covering over the buccal mucosa in dark-skinned individuals",
        "Excessive bone growth on the hard palate along the midline suture in adults",
        "A sessile nodule on the gingival margin of the lingual aspect of the mandibular cuspids, often seen in children"
      ],
      correctAnswer: 3
    },
    {
      id: 93177,
      question: "A bulla is defined as a circumscribed, elevated lesion that is more than 5 mm in diameter and usually contains serous fluid.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93178,
      question: "A macule protrudes above the surface of normal surrounding tissue, making it easily palpable.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93179,
      question: "Erythroplakia is more common than leukoplakia in the oral cavity.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93180,
      question: "Leukoedema disappears when the buccal mucosa is stretched, which helps distinguish it from pathological white lesions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93181,
      question: "Torus mandibularis represents excessive growth of normal bone and is classified as a variant of normal in the absence of other disease processes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93182,
      question: "Radiolucent areas on a radiograph appear white or light because radiant energy cannot pass through them.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "4. Classification of Benign Conditions of Unknown Cause": [
    {
      id: 93183,
      question: "Where does the thyroid gland initially develop during fetal life?",
      options: [
        "Along the lateral border of the tongue near the tonsils",
        "Adjacent to the hyoid bone in the upper neck",
        "In the anterior floor of the mouth near the sublingual gland",
        "In the midline of the dorsal tongue at the foramen cecum"
      ],
      correctAnswer: 3
    },
    {
      id: 93184,
      question: "What term describes thyroid tissue that fails to descend to its normal location in the neck and remains trapped in tongue tissue?",
      options: [
        "Lingual thyroid nodule (ectopic thyroid)",
        "Median rhomboid glossitis",
        "Benign migratory glossitis",
        "Fissured thyroid anomaly"
      ],
      correctAnswer: 0
    },
    {
      id: 93185,
      question: "A lingual thyroid nodule typically appears as which of the following?",
      options: [
        "Deep fissures or grooves across the entire dorsal tongue surface",
        "A flat erythematous patch with a white or yellow perimeter",
        "A mass in the midline dorsal tongue posterior to the circumvallate papillae",
        "Elongated white papillae along the central groove of the tongue"
      ],
      correctAnswer: 2
    },
    {
      id: 93186,
      question: "Which of the following best describes the typical size and base of a lingual thyroid nodule?",
      options: [
        "4-5 cm wide with a broad flat base and smooth surface",
        "Less than 1 cm wide with a raised cystic base and fibrous tissue",
        "1 cm wide with a pedunculated base and irregular borders",
        "2-3 cm wide with a sessile base and normal thyroid tissue histologically"
      ],
      correctAnswer: 3
    },
    {
      id: 93187,
      question: "Which demographic group shows an increased predilection for lingual thyroid nodule?",
      options: [
        "Females, linked to hormonal changes at puberty, pregnancy, and menopause",
        "Elderly males with a history of neck radiation",
        "Children under age 5 due to incomplete thyroid migration",
        "Adolescent males during periods of rapid growth"
      ],
      correctAnswer: 0
    },
    {
      id: 93188,
      question: "Why must the presence of adequate thyroid tissue in the neck be evaluated before removing a lingual thyroid nodule?",
      options: [
        "Because removal may trigger an autoimmune response in cervical lymph nodes",
        "Because the nodule may be the patient's only functioning thyroid tissue",
        "Because surgery on the tongue always requires concurrent neck dissection",
        "Because the nodule is often connected to parathyroid tissue that must be preserved"
      ],
      correctAnswer: 1
    },
    {
      id: 93189,
      question: "Along what anatomical route can ectopic thyroid tissue remain trapped between the tongue and the neck?",
      options: [
        "The parotid fascia extending from the ear to the hyoid bone",
        "The nasopalatine canal connecting the oral and nasal cavities",
        "The submandibular duct from the floor of mouth to the neck",
        "The thyroglossal tract, the migration path of the thyroid to the neck"
      ],
      correctAnswer: 3
    },
    {
      id: 93190,
      question: "What is the most common presentation of a lingual thyroid nodule?",
      options: [
        "Chronic infection causing recurring fever and cervical lymphadenopathy",
        "Asymptomatic, requiring no treatment in most cases",
        "A rapidly growing mass that obstructs the airway within weeks",
        "Painful swelling that bleeds easily and requires immediate biopsy"
      ],
      correctAnswer: 1
    },
    {
      id: 93191,
      question: "What is the primary etiology of fissured tongue?",
      options: [
        "Unknown, but genetic factors are suspected due to familial patterns",
        "A secondary complication of untreated geographic tongue",
        "Chronic trauma from repeated biting of the tongue surface",
        "Fungal infection by Candida albicans on the dorsal surface"
      ],
      correctAnswer: 0
    },
    {
      id: 93192,
      question: "What does fissured tongue look like clinically?",
      options: [
        "A midline raised rectangular area devoid of filiform papillae",
        "A brown-to-black discoloration with elongated papillae centrally",
        "Erythematous patches with white borders on the dorsal surface",
        "Deep fissures or grooves on the dorsal surface of the tongue"
      ],
      correctAnswer: 3
    },
    {
      id: 93193,
      question: "Approximately what percentage of the population has fissured tongue?",
      options: [
        "5%",
        "15%",
        "25%",
        "1%"
      ],
      correctAnswer: 0
    },
    {
      id: 93194,
      question: "What is the recommended management for a patient with fissured tongue?",
      options: [
        "Referral to an oral medicine specialist for biopsy and monitoring",
        "Antifungal medication applied twice daily to the tongue surface",
        "Gentle tongue brushing to remove debris from the fissures",
        "Surgical smoothing of the tongue surface under local anesthesia"
      ],
      correctAnswer: 2
    },
    {
      id: 93195,
      question: "Which condition is frequently found coexisting with fissured tongue?",
      options: [
        "Median rhomboid glossitis",
        "Black hairy tongue",
        "Lingual thyroid nodule",
        "Geographic tongue"
      ],
      correctAnswer: 3
    },
    {
      id: 93196,
      question: "What is another name for geographic tongue?",
      options: [
        "Candida glossitis or pseudomembranous stomatitis",
        "Erythema migrans or benign migratory glossitis",
        "Median rhomboid glossitis or central papillary atrophy",
        "Fissured glossitis or scrotal tongue syndrome"
      ],
      correctAnswer: 1
    },
    {
      id: 93197,
      question: "Which surfaces of the tongue are typically involved in geographic tongue?",
      options: [
        "The sublingual surface and the lateral walls of the tongue",
        "The dorsal and lateral borders of the tongue",
        "The ventral surface and tip of the tongue only",
        "The posterior dorsal tongue near the circumvallate papillae only"
      ],
      correctAnswer: 1
    },
    {
      id: 93198,
      question: "How do the erythematous patches of geographic tongue appear clinically?",
      options: [
        "Raised nodular areas covered with thick white plaques and firm borders",
        "Diffuse areas devoid of filiform papillae surrounded by a white or yellow perimeter",
        "Flat brown patches with irregular edges and no associated papillae changes",
        "Ulcerated craters with raised red margins and yellow necrotic centers"
      ],
      correctAnswer: 1
    },
    {
      id: 93199,
      question: "Which papillae remain distinct and visible within the erythematous patches of geographic tongue?",
      options: [
        "Fungiform papillae",
        "Circumvallate papillae",
        "Filiform papillae",
        "Foliate papillae"
      ],
      correctAnswer: 0
    },
    {
      id: 93200,
      question: "What symptom may some patients with geographic tongue report?",
      options: [
        "Persistent metallic taste and numbness of the tongue tip",
        "A burning sensation",
        "Difficulty swallowing due to papillary enlargement",
        "Severe pain that worsens with spicy food and acidic drinks"
      ],
      correctAnswer: 1
    },
    {
      id: 93201,
      question: "What systemic condition has some histologic association with geographic tongue?",
      options: [
        "Hypothyroidism",
        "Diabetes mellitus",
        "Psoriasis",
        "Rheumatoid arthritis"
      ],
      correctAnswer: 2
    },
    {
      id: 93202,
      question: "What factor is known to exacerbate geographic tongue?",
      options: [
        "High-sugar diet and poor oral hygiene",
        "Stress",
        "Use of antibiotic mouthwashes over long periods",
        "Excessive fluoride intake from toothpaste"
      ],
      correctAnswer: 1
    },
    {
      id: 93203,
      question: "What is the treatment for geographic tongue?",
      options: [
        "No treatment is necessary",
        "Corticosteroid gel applied to affected patches twice daily",
        "Tongue scraping followed by antiseptic rinse each morning",
        "Antifungal lozenges used for two weeks to clear the lesions"
      ],
      correctAnswer: 0
    },
    {
      id: 93204,
      question: "What is ectopic geographic tongue?",
      options: [
        "Geographic tongue associated with a concurrent fungal infection",
        "Geographic tongue that recurs more than three times per year",
        "Geographic tongue found on mucosal surfaces other than the tongue",
        "Geographic tongue that appears only on the ventral surface of the tongue"
      ],
      correctAnswer: 2
    },
    {
      id: 93205,
      question: "On which specific intraoral locations is ectopic geographic tongue illustrated in the lecture?",
      options: [
        "The hard palate and labial mucosa anteriorly",
        "The soft palate and posterior oropharynx",
        "The maxillary tuberosity and retromolar pad region",
        "The mandibular anterior mucobuccal fold and sublingual floor of mouth"
      ],
      correctAnswer: 3
    },
    {
      id: 93206,
      question: "What causes the \"hairy\" appearance in hairy tongue?",
      options: [
        "Overgrowth of Candida filaments on the dorsal tongue surface",
        "Excessive cell proliferation of the circumvallate papillae after antibiotic use",
        "Increased keratin accumulation on the filiform papillae with decreased desquamation",
        "Inflammatory enlargement of the fungiform papillae due to irritant exposure"
      ],
      correctAnswer: 2
    },
    {
      id: 93207,
      question: "What is the clinical appearance of white hairy tongue?",
      options: [
        "Elongated white filiform papillae giving a hairy appearance",
        "A midline oval patch devoid of papillae with white borders",
        "Flat white plaques that cannot be wiped off the dorsal tongue",
        "Diffuse white coating with scattered red erosions across the tongue"
      ],
      correctAnswer: 0
    },
    {
      id: 93208,
      question: "What gives black hairy tongue its dark coloration?",
      options: [
        "Iron sulfide deposits from long-term use of iron supplements",
        "Melanin deposits from systemic hyperpigmentation disorders",
        "Hemosiderin accumulation from repeated minor trauma and bleeding",
        "Chromogenic bacteria producing brown-to-black pigmentation"
      ],
      correctAnswer: 3
    },
    {
      id: 93209,
      question: "Which of the following is listed as a contributing factor to black hairy tongue?",
      options: [
        "Fluoride, acidic beverages, and xerostomia-inducing medications",
        "Antifungal drugs, corticosteroids, and mouth breathing",
        "Tobacco, foods, hydrogen peroxide, and alcohol",
        "Stress, psoriasis, hormonal changes, and genetic factors"
      ],
      correctAnswer: 2
    },
    {
      id: 93210,
      question: "What is the recommended treatment for hairy tongue (both white and black)?",
      options: [
        "Prescription antifungal mouthwash used morning and night for one month",
        "Gentle tongue brushing with a water-wet toothbrush to remove debris",
        "Surgical trimming of the papillae under local anesthesia if severe",
        "Chemical cauterization of the elongated papillae by a dental specialist"
      ],
      correctAnswer: 1
    },
    {
      id: 93211,
      question: "What is the prognosis for black hairy tongue after treatment?",
      options: [
        "It progresses to malignancy in about 5% of untreated cases",
        "It resolves with antifungal therapy but leaves permanent discoloration",
        "The condition often clears completely but may recur",
        "It is permanent and does not resolve without surgical intervention"
      ],
      correctAnswer: 2
    },
    {
      id: 93212,
      question: "What is the suspected etiology of median rhomboid glossitis?",
      options: [
        "A congenital failure of the posterior tongue papillae to develop",
        "A traumatic injury to the midline tongue from repeated biting",
        "A viral infection of the tongue musculature causing focal atrophy",
        "A chronic fungal infection by Candida albicans"
      ],
      correctAnswer: 3
    },
    {
      id: 93213,
      question: "Where exactly does median rhomboid glossitis appear on the tongue?",
      options: [
        "In the midline dorsal tongue at the junction of the anterior and middle thirds extending posterior to the circumvallate papillae",
        "On the ventral tongue surface adjacent to the lingual frenum",
        "On the lateral borders of the tongue posterior to the foliate papillae",
        "At the tip of the tongue along the anterior third"
      ],
      correctAnswer: 0
    },
    {
      id: 93214,
      question: "How is the lesion of median rhomboid glossitis described clinically?",
      options: [
        "Multiple small vesicles coalescing into a larger erythematous patch",
        "A flat or slightly raised oval or rectangular erythematous area in the midline",
        "A raised nodular mass with an irregular white surface and firm texture",
        "A deep ulceration with necrotic base surrounded by a bright red halo"
      ],
      correctAnswer: 1
    },
    {
      id: 93215,
      question: "The thyroid gland normally descends from the foramen cecum area to its final location in the neck during fetal development.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93216,
      question: "A lingual thyroid nodule is always symptomatic and will interfere with breathing and swallowing in every patient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93217,
      question: "Fissured tongue requires surgical treatment in most patients to prevent serious complications.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93218,
      question: "Geographic tongue is a static condition that does not change over time once it appears.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93219,
      question: "Black hairy tongue and white hairy tongue share the same underlying etiology involving increased keratin accumulation on the filiform papillae.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "5. Inflammation and Repair": [
    {
      id: 93220,
      question: "What is the definition of injury in the context of tissue pathology?",
      options: [
        "A normal variation in tissue structure that improves healing",
        "A reversible cellular change that always returns to normal function",
        "An alteration in the environment that causes tissue damage or necrosis",
        "A systemic response to a foreign antigen in the bloodstream"
      ],
      correctAnswer: 2
    },
    {
      id: 93221,
      question: "Which of the following is an example of a less severe injury that does NOT cause necrosis?",
      options: [
        "Hyperplasia, hypertrophy, or atrophy of a tissue or organ",
        "Perforation of a hollow organ leading to bacterial contamination",
        "Infarction caused by a complete blockage of blood supply to tissue",
        "Fulminant hepatic failure from toxic chemical ingestion"
      ],
      correctAnswer: 0
    },
    {
      id: 93222,
      question: "What is the primary role of inflammation in the body?",
      options: [
        "To permanently scar injured tissue and prevent further damage",
        "To eliminate injurious agents, contain injuries, and heal defects",
        "To alert the immune system to produce antibodies against pathogens",
        "To increase blood pressure and divert blood away from injured areas"
      ],
      correctAnswer: 1
    },
    {
      id: 93223,
      question: "Which natural defense provides a physical barrier against injury?",
      options: [
        "Intact skin or mucosa that separates internal tissue from the environment",
        "Complement proteins circulating in the bloodstream at all times",
        "Lysosomal enzymes released by white blood cells during infection",
        "Elevated C-reactive protein levels detected during systemic inflammation"
      ],
      correctAnswer: 0
    },
    {
      id: 93224,
      question: "Which body fluid provides a flushing action that removes foreign substances as a natural defense?",
      options: [
        "Synovial fluid lubricating the joints and preventing friction",
        "Cerebrospinal fluid surrounding and protecting the brain and spinal cord",
        "Bile secreted by the liver to emulsify dietary fats and lipids",
        "Tears, saliva, urine, and diarrhea that flush foreign material out"
      ],
      correctAnswer: 3
    },
    {
      id: 93225,
      question: "Which of the following correctly describes the nature of the inflammatory response?",
      options: [
        "It is a specific, targeted response directed only at known pathogens",
        "It is only triggered by bacterial infections and not by physical trauma",
        "It is always systemic and involves the entire body regardless of injury size",
        "It is a nonspecific response whose extent depends on the extent of injury"
      ],
      correctAnswer: 3
    },
    {
      id: 93226,
      question: "Which of the following is a localized sign of inflammation?",
      options: [
        "Redness, heat, swelling, pain, and loss of normal tissue function",
        "Fever controlled by the hypothalamus in response to pyrogens",
        "Leukocytosis indicating an increase in circulating white blood cells",
        "Lymphadenopathy with enlarged and palpable superficial lymph nodes"
      ],
      correctAnswer: 0
    },
    {
      id: 93227,
      question: "Which of the following is a systemic sign of inflammation?",
      options: [
        "Pain, swelling, and heat localized to the site of tissue injury",
        "Fever, leukocytosis, elevated C-reactive protein, and lymphadenopathy",
        "Erythema resulting from increased blood flow in injured capillary beds",
        "Loss of normal tissue function at the site of acute inflammation"
      ],
      correctAnswer: 1
    },
    {
      id: 93228,
      question: "What is the correct sequence of vascular events in the early inflammatory response?",
      options: [
        "Vasodilation occurs first, followed immediately by tissue necrosis and abscess formation",
        "Vasoconstriction of the microcirculation occurs first, then vasodilation leading to hyperemia",
        "Increased permeability occurs before any vascular changes at the site of injury",
        "Phagocytosis begins immediately without any preceding changes in blood vessels"
      ],
      correctAnswer: 1
    },
    {
      id: 93229,
      question: "What is hyperemia and what does it produce clinically?",
      options: [
        "A decrease in blood flow that results in pallor and reduced tissue temperature",
        "Increased blood flow in capillary beds of injured tissue, producing erythema and heat",
        "An abnormal accumulation of WBCs in the lymph nodes causing lymphadenopathy",
        "The process by which WBCs escape from blood vessels into surrounding tissue"
      ],
      correctAnswer: 1
    },
    {
      id: 93230,
      question: "What is the difference between serous exudate and purulent exudate?",
      options: [
        "Serous exudate contains bacteria while purulent exudate contains only proteins",
        "Serous exudate has many WBCs while purulent exudate has only plasma proteins",
        "Serous exudate is mainly plasma and proteins with few WBCs; purulent exudate contains tissue debris and many WBCs",
        "Serous exudate only occurs systemically while purulent exudate is always localized"
      ],
      correctAnswer: 2
    },
    {
      id: 93231,
      question: "What is edema in the context of the inflammatory response?",
      options: [
        "A type of exudate that contains mainly WBCs and tissue debris from phagocytosis",
        "A dense fibrous connective tissue scar replacing previously injured tissue",
        "Excess fluid accumulating in tissues as a result of increased plasma in injured areas",
        "An abnormal proliferation of lymphocytes during a chronic inflammatory reaction"
      ],
      correctAnswer: 2
    },
    {
      id: 93232,
      question: "What is chemotaxis in the inflammatory process?",
      options: [
        "The process by which WBCs ingest and digest foreign substances and debris",
        "The process by which WBCs escape from blood vessels through endothelial gaps",
        "The margination of neutrophils along the walls of blood vessel endothelium",
        "Directed movement of WBCs toward the site of injury in damaged tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 93233,
      question: "What is emigration in the context of the inflammatory response?",
      options: [
        "The process by which WBCs escape from blood vessels through gaps in endothelial cells",
        "Directed movement of WBCs along a chemical gradient toward the injury site",
        "The process by which WBCs ingest and then digest foreign material and pathogens",
        "Increased blood plasma and proteins accumulating in the injured tissue area"
      ],
      correctAnswer: 0
    },
    {
      id: 93234,
      question: "What is phagocytosis?",
      options: [
        "The directed migration of WBCs through the walls of blood vessels into tissue",
        "A chemical signal that attracts WBCs from the bloodstream to areas of injury",
        "The process by which WBCs ingest and then digest foreign substances including pathogens and tissue debris",
        "The proliferation of fibroblasts to produce new collagen fibers in healing tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 93235,
      question: "What are neutrophils also known as, and what is their primary function?",
      options: [
        "Mononuclear leukocytes primarily involved in the long-term immune response",
        "Lymphoid cells seen mainly in chronic inflammation and autoimmune reactions",
        "Polymorphonuclear leukocytes whose primary function is phagocytosis",
        "Granulated mast cells involved in releasing histamine during allergic reactions"
      ],
      correctAnswer: 2
    },
    {
      id: 93236,
      question: "What percentage of the white blood cell population do neutrophils constitute?",
      options: [
        "3% to 8% of the total white blood cell population in circulation",
        "20% to 30% of the total white blood cell population in circulation",
        "60% to 70% of the total white blood cell population in circulation",
        "80% to 90% of the total white blood cell population in circulation"
      ],
      correctAnswer: 2
    },
    {
      id: 93237,
      question: "What is the microscopic appearance of a monocyte?",
      options: [
        "A multilobed nucleus with granular cytoplasm containing lysosomal enzymes",
        "A small cell with a bilobed nucleus and large eosinophilic cytoplasmic granules",
        "A large cell with a horseshoe-shaped nucleus found predominantly in bone marrow",
        "A single round nucleus without granular cytoplasm, constituting 3%–8% of WBCs"
      ],
      correctAnswer: 3
    },
    {
      id: 93238,
      question: "What happens to monocytes when they enter tissue from the bloodstream?",
      options: [
        "They differentiate into plasma cells that produce antibodies for immune defense",
        "They transform into fibroblasts that synthesize collagen during wound healing",
        "They become macrophages that continue phagocytosis and secrete growth factors",
        "They revert to stem cells and migrate back to the bone marrow for storage"
      ],
      correctAnswer: 2
    },
    {
      id: 93239,
      question: "Which white blood cells are primarily seen during chronic inflammation and the immune response?",
      options: [
        "Neutrophils and eosinophils, which are the first cells recruited to injured tissue",
        "Monocytes and basophils, which are common in the early acute inflammatory phase",
        "Lymphocytes and plasma cells, which appear during chronic inflammation and immunity",
        "Mast cells and platelets, which initiate the clotting cascade at the injury site"
      ],
      correctAnswer: 2
    },
    {
      id: 93240,
      question: "What are the three interrelated chemical mediator systems involved in inflammation?",
      options: [
        "The endocrine system, the nervous system, and the lymphatic system",
        "The prostaglandin pathway, the cytokine cascade, and the histamine pathway",
        "The kinin system, the clotting mechanism, and the complement system",
        "The coagulation cascade, the fibrinolytic system, and the renin-angiotensin system"
      ],
      correctAnswer: 2
    },
    {
      id: 93241,
      question: "What are the main effects of the kinin system during inflammation?",
      options: [
        "It produces fibrin clots and mediates long-term immune responses in lymph nodes",
        "It causes vasoconstriction and reduces permeability to limit fluid loss from vessels",
        "It activates complement proteins and triggers release of lysosomal enzymes from WBCs",
        "It causes vasodilation and increased permeability of local blood vessels, and induces pain"
      ],
      correctAnswer: 3
    },
    {
      id: 93242,
      question: "How does the complement system contribute to the inflammatory response?",
      options: [
        "It produces fibrin clots and activates the kinin system to cause vasoconstriction",
        "It directly kills bacteria by phagocytosis without involving any other mediators",
        "It releases prostaglandins that cause pain and changes in connective tissue structure",
        "It causes mast cells to release histamine, promotes vasodilation, and enhances phagocytosis"
      ],
      correctAnswer: 3
    },
    {
      id: 93243,
      question: "What is the role of prostaglandins as chemical mediators of inflammation?",
      options: [
        "They suppress inflammation by blocking the kinin system and reducing vascular permeability",
        "They stimulate fibroblast activity to accelerate scar tissue formation during healing",
        "They cause increased vascular dilation and permeability, tissue pain and redness, and connective tissue changes",
        "They act only as chemotactic factors to recruit neutrophils to the site of injury"
      ],
      correctAnswer: 2
    },
    {
      id: 93244,
      question: "What is endotoxin and from where is it derived?",
      options: [
        "A protein produced by gram-positive bacteria that activates the complement pathway",
        "A substance produced by the cell walls of gram-negative bacteria that serves as a chemotactic factor and can damage bone and tissue",
        "A mediator released by platelets during clot formation at the site of tissue injury",
        "A lysosomal enzyme released by white blood cells that degrades fibrin clots"
      ],
      correctAnswer: 1
    },
    {
      id: 93245,
      question: "What are pyrogens and how do they cause fever?",
      options: [
        "Fever-producing substances from WBCs and pathogens that act on the hypothalamus via prostaglandins",
        "Toxins from gram-positive bacteria that stimulate the adrenal gland to raise temperature",
        "Foreign proteins that directly increase metabolism in peripheral muscles causing heat",
        "Inflammatory mediators released from mast cells that trigger shivering and vasodilation"
      ],
      correctAnswer: 0
    },
    {
      id: 93246,
      question: "What is leukocytosis and what does it indicate?",
      options: [
        "A decrease in circulating WBCs below 4,000/mm³ indicating severe immunosuppression",
        "An increase in circulating WBCs to 10,000–30,000/mm³, indicating a systemic inflammatory response",
        "A normal WBC count of 4,000–10,000/mm³ indicating the absence of active infection",
        "An abnormal proliferation of RBCs in the bone marrow causing polycythemia vera"
      ],
      correctAnswer: 1
    },
    {
      id: 93247,
      question: "During leukocytosis, which type of WBC increase suggests a viral infection?",
      options: [
        "An increase in neutrophils, which are recruited to fight intracellular viral particles",
        "An increase in eosinophils, which are specifically triggered by viral replication",
        "An increase in monocytes, which are the primary phagocytic cells against viruses",
        "An increase in lymphocytes, which are the cells specifically associated with viral infection"
      ],
      correctAnswer: 3
    },
    {
      id: 93248,
      question: "Which WBC type increases in number during an allergic reaction?",
      options: [
        "Neutrophils, which are the primary defenders during acute bacterial infections",
        "Eosinophils, which are the specific WBCs that increase during allergic reactions",
        "Lymphocytes, which are involved in the adaptive immune response to allergens",
        "Monocytes, which differentiate into macrophages and suppress allergic responses"
      ],
      correctAnswer: 1
    },
    {
      id: 93249,
      question: "What is lymphadenopathy and why does it occur?",
      options: [
        "An increase in circulating WBCs caused by bone marrow stimulation during infection",
        "Enlargement and palpability of superficial lymph nodes due to changes in lymphocytes",
        "A decrease in lymph node size resulting from suppression of the immune response",
        "Inflammation of the spleen caused by systemic bacterial or viral infections"
      ],
      correctAnswer: 1
    },
    {
      id: 93250,
      question: "What are the two types of cellular changes that cause lymph node enlargement?",
      options: [
        "Necrosis of existing cells and fibrosis replacing normal lymphoid tissue",
        "Apoptosis of damaged cells and regeneration of new lymphoid tissue",
        "Hyperplasia (increase in cell number) and hypertrophy (enlargement of individual cells)",
        "Atrophy of the cortex and hypertrophy of the medullary sinuses only"
      ],
      correctAnswer: 2
    },
    {
      id: 93251,
      question: "Where is C-reactive protein produced and what is its clinical significance?",
      options: [
        "It is produced by the spleen and is used to measure red blood cell destruction",
        "It is produced by the liver and is used to assess rheumatoid arthritis, lupus, cardiovascular risk, and periodontal disease",
        "It is produced by WBCs and serves as a direct marker for leukocytosis and infection",
        "It is produced by the thymus and is used exclusively to monitor autoimmune disorders"
      ],
      correctAnswer: 1
    },
    {
      id: 93252,
      question: "Which of the following cells are involved in chronic inflammation?",
      options: [
        "Only neutrophils and eosinophils, which are specific to acute inflammatory reactions",
        "Macrophages, lymphocytes, plasma cells, neutrophils, monocytes, and fibroblasts",
        "Only mast cells and basophils, which are involved in long-term hypersensitivity",
        "Only red blood cells and platelets, which are needed to form the healing clot"
      ],
      correctAnswer: 1
    },
    {
      id: 93253,
      question: "What is a granuloma and with which conditions is it associated?",
      options: [
        "A dense fibrous scar tissue that forms after primary intention healing is complete",
        "A purulent exudate that develops within a walled-off area of acute inflammation",
        "A collection of eosinophils and mast cells responding to a parasitic infestation",
        "Microscopic groupings of macrophages surrounded by lymphocytes and plasma cells, associated with foreign body reactions and tuberculosis"
      ],
      correctAnswer: 3
    },
    {
      id: 93254,
      question: "Which of the following is classified as a nonsteroidal anti-inflammatory drug (NSAID)?",
      options: [
        "Prednisone, which is a corticosteroid used to suppress chronic inflammation",
        "Methotrexate, which is a cancer treatment drug that also suppresses inflammation",
        "Acetylsalicylic acid (aspirin) or ibuprofen, which are nonsteroidal anti-inflammatory drugs",
        "Antihistamines, which work by blocking histamine receptors at inflammatory sites"
      ],
      correctAnswer: 2
    },
    {
      id: 93255,
      question: "What is the definition of hyperplasia?",
      options: [
        "A decrease in the size or function of a cell, tissue, or organ from disuse",
        "An increase in the size of individual cells in response to increased demand",
        "The replacement of one type of tissue with a structurally different tissue type",
        "An increase in the number of cells, often in response to chronic irritation or abrasion"
      ],
      correctAnswer: 3
    },
    {
      id: 93256,
      question: "What is atrophy?",
      options: [
        "A decrease in size or function of a cell, tissue, organ, or entire body",
        "An increase in the size of individual cells such as seen in cardiac muscle hypertrophy",
        "An increase in the number of cells often triggered by chronic low-grade irritation",
        "The abnormal accumulation of extracellular matrix proteins in connective tissue"
      ],
      correctAnswer: 0
    },
    {
      id: 93257,
      question: "What is the difference between regeneration and repair?",
      options: [
        "Regeneration involves scar formation while repair produces tissue identical to the original",
        "Regeneration replaces injured tissue with identical tissue; repair is the broader process of restoring damaged or diseased tissue",
        "Regeneration always results in keloid formation while repair leads to primary intention healing",
        "Regeneration only occurs in bone tissue while repair only occurs in soft tissue"
      ],
      correctAnswer: 1
    },
    {
      id: 93258,
      question: "What is the composition of the blood clot that forms in the early phase of wound healing?",
      options: [
        "Mainly white blood cells, fibronectin, and activated complement proteins",
        "Fibrin, clumped red blood cells, and platelets that flow into injured tissue",
        "Collagen fibers, fibroblasts, and macrophages that migrate from surrounding tissue",
        "Granulation tissue, newly formed blood vessels, and epithelial progenitor cells"
      ],
      correctAnswer: 1
    },
    {
      id: 93259,
      question: "What is angiogenesis in the context of wound healing?",
      options: [
        "The growth of new blood vessels stimulated by macrophage-secreted growth factors",
        "The formation of scar tissue from immature collagen fibers after the inflammatory phase",
        "The process by which neutrophils migrate from blood vessels into injured tissue",
        "The migration of epithelial cells across the wound surface to form new surface tissue"
      ],
      correctAnswer: 0
    },
    {
      id: 93260,
      question: "What is fibroplasia in the wound healing process?",
      options: [
        "The breakdown of the fibrin clot by tissue enzymes to complete initial repair",
        "The migration of epithelial cells to form new surface tissue over the wound",
        "The increase in fibroblasts that produce new collagen fibers to form granulation tissue",
        "The contraction of wounds by myofibroblasts during the maturation phase of healing"
      ],
      correctAnswer: 2
    },
    {
      id: 93261,
      question: "What is epithelialization?",
      options: [
        "The process by which fibroblasts differentiate into myofibroblasts to contract wounds",
        "The formation of new collagen fibers by activated fibroblasts in granulation tissue",
        "The breakdown of immature collagen fibers during the remodeling phase of healing",
        "The process by which new surface tissue is created over a wound during healing"
      ],
      correctAnswer: 3
    },
    {
      id: 93262,
      question: "What is scar tissue and how does it differ from granulation tissue?",
      options: [
        "Scar tissue forms first and is highly vascular; granulation tissue is pale and avascular",
        "Scar tissue contains more inflammatory cells while granulation tissue is mostly collagen",
        "Scar tissue is matured fibrous connective tissue that is whiter and paler due to increased collagen and decreased vascularity",
        "Scar tissue is the same as granulation tissue but contains more red blood cells"
      ],
      correctAnswer: 2
    },
    {
      id: 93263,
      question: "What is healing by primary intention?",
      options: [
        "Healing of an injury with little tissue loss where margins are close and minimal granulation tissue forms",
        "Healing where wound edges cannot be joined, resulting in a large clot and more scar tissue",
        "Delaying surgical repair until an active infection at the wound site is fully resolved",
        "Healing that involves a large keloid formation at the site of extensive tissue loss"
      ],
      correctAnswer: 0
    },
    {
      id: 93264,
      question: "What is a keloid?",
      options: [
        "A granuloma that forms in response to a foreign body embedded in connective tissue",
        "Excess scar tissue that may result from healing by secondary intention with a large clot",
        "A cyst that develops when a salivary gland duct is blocked by a calcified stone",
        "An abscess cavity that drains through a fistulous tract to the surface of the skin"
      ],
      correctAnswer: 1
    },
    {
      id: 93265,
      question: "What is healing by tertiary intention?",
      options: [
        "Healing of a small wound with close margins and minimal granulation tissue formation",
        "Healing of a large wound where edges cannot be joined, resulting in more scar tissue",
        "Healing that occurs automatically without medical intervention in healthy individuals",
        "Delaying surgical tissue repair until infection at the wound site is first resolved"
      ],
      correctAnswer: 3
    },
    {
      id: 93266,
      question: "Which of the following is a LOCAL factor that impairs wound healing?",
      options: [
        "Bacterial infection, tissue necrosis, hematoma, excessive movement, or poor blood supply",
        "Immunosuppression preventing the normal immune response to injury",
        "Malnutrition reducing the availability of proteins and vitamins needed for repair",
        "Genetic connective tissue disorders affecting collagen synthesis throughout the body"
      ],
      correctAnswer: 0
    },
    {
      id: 93267,
      question: "Which of the following are SYSTEMIC factors that impair wound healing?",
      options: [
        "Malnutrition, immunosuppression, genetic connective tissue disorders, and metabolic disorders",
        "Bacterial infection, poor blood supply, excessive movement, and tissue necrosis",
        "Hematoma formation, local infection, and inadequate surgical technique",
        "Edema, growth factor deficiency, and excessive osteoblast activity at the wound site"
      ],
      correctAnswer: 0
    },
    {
      id: 93268,
      question: "What is attrition of teeth?",
      options: [
        "Pathologic wearing from a repetitive mechanical habit such as improper brushing",
        "Tooth-to-tooth wear that may be observed in both primary and permanent dentition",
        "Chemical loss of tooth structure from acids without any bacterial involvement",
        "Microfractures at cervical areas caused by concentration of flexure stress forces"
      ],
      correctAnswer: 1
    },
    {
      id: 93269,
      question: "What is bruxism and what conditions may trigger it?",
      options: [
        "Chemical erosion of tooth enamel caused by chronic exposure to acidic beverages",
        "Pathologic wear from repetitive mechanical habits such as nail biting or toothpick use",
        "Grinding and clenching teeth for nonfunctional purposes, triggered by occlusal interferences, stress, tension, or seizure disorders",
        "Wedge-shaped lesions at cervical areas from microfractures due to excessive occlusal loading"
      ],
      correctAnswer: 2
    },
    {
      id: 93270,
      question: "What is abrasion of teeth?",
      options: [
        "Tooth-to-tooth wear caused by grinding and clenching for nonfunctional purposes",
        "Pathologic wearing away of tooth structure resulting from a repetitive mechanical habit",
        "Chemical dissolution of tooth structure from acids without bacterial involvement",
        "Stress-related microfractures at the cervical areas of teeth from flexure and fatigue"
      ],
      correctAnswer: 1
    },
    {
      id: 93271,
      question: "What is abfraction of teeth?",
      options: [
        "Tooth-to-tooth wear seen in patients who clench and grind their teeth habitually",
        "Chemical loss of tooth structure from acids produced by stomach acid or beverages",
        "Mechanical wear from repetitive habits such as aggressive brushing or nail biting",
        "Microfractures at cervical areas from stress concentration, fatigue, and flexure of tooth structure"
      ],
      correctAnswer: 3
    },
    {
      id: 93272,
      question: "What is tooth erosion and how is it distinguished from attrition?",
      options: [
        "Erosion is tooth-to-tooth wear while attrition is caused by chemical dissolution",
        "Erosion is chemical loss of tooth structure without bacterial involvement; attrition is tooth-to-tooth mechanical wear",
        "Erosion occurs only on root surfaces while attrition only occurs on occlusal surfaces",
        "Erosion involves microfractures while attrition involves repetitive mechanical habits"
      ],
      correctAnswer: 1
    },
    {
      id: 93273,
      question: "What are potential causes of dental erosion?",
      options: [
        "Industrial factors, cocaine hydrochloride use, overuse of soft drinks, chronic vomiting, and sucking on lemons",
        "Aggressive toothbrushing, improper flossing technique, and abrasive toothpaste use",
        "Bruxism, occlusal interferences, masticatory muscle hypertrophy, and bite splints",
        "Periodontal disease, root exposure from gingival recession, and dentin hypersensitivity"
      ],
      correctAnswer: 0
    },
    {
      id: 93274,
      question: "What oral health management strategies are recommended for patients with bulimia?",
      options: [
        "Use fluoride rinse and toothpaste, rinse with water after purging, avoid brushing immediately after vomiting, and use a very soft toothbrush",
        "Prescribe hard-bristle toothbrushes and strong whitening toothpastes for patients",
        "Encourage brushing immediately after vomiting to remove acidic residue from teeth",
        "Prescribe calcium supplements and limit all dental treatment to emergency procedures"
      ],
      correctAnswer: 0
    },
    {
      id: 93275,
      question: "What causes the rapid destruction of teeth associated with methamphetamine abuse?",
      options: [
        "Bruxism exclusively, since methamphetamine causes teeth grinding and jaw clenching",
        "Direct chemical erosion from methamphetamine vapors contacting enamel surfaces",
        "Methamphetamine's acid content, decreased salivary flow, cravings for high-sugar beverages, and lack of oral hygiene",
        "Increased salivary flow that washes away protective proteins and minerals from teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 93276,
      question: "What is the clinical result of topically misapplying aspirin to oral tissue?",
      options: [
        "The tissue becomes inflamed and swollen, requiring immediate surgical debridement",
        "The tissue undergoes immediate analgesia and the pain from the underlying lesion resolves",
        "The tissue becomes necrotic and white; the surface may slough off, leaving a painful ulcer that heals in 7–21 days",
        "The tissue becomes permanently discolored with a gray or black melanotic pigmentation"
      ],
      correctAnswer: 2
    },
    {
      id: 93277,
      question: "What is a traumatic ulcer of the oral mucosa?",
      options: [
        "A lesion caused by cheek, lip, or tongue biting; denture irritation; or overzealous brushing that usually heals within 7–14 days",
        "A flat bluish-gray lesion caused by the introduction of amalgam particles into tissue",
        "A benign white hyperkeratotic lesion caused by chronic friction against mucosal surfaces",
        "A hard indurated lesion resulting from persistent trauma that heals rapidly after biopsy"
      ],
      correctAnswer: 0
    },
    {
      id: 93278,
      question: "What is frictional keratosis?",
      options: [
        "A form of hyperkeratosis caused by chronic rubbing or friction on oral mucosal surfaces, resembling a skin callus",
        "A benign lesion associated with pipe and cigar smoking appearing on the hard palate",
        "A white raised line on the buccal mucosa associated with a teeth-clenching habit",
        "A white corrugated lesion located where chewing tobacco is placed in the mucobuccal fold"
      ],
      correctAnswer: 0
    },
    {
      id: 93279,
      question: "What is linea alba and what is its microscopic appearance?",
      options: [
        "A benign red lesion on the palate associated with pipe smoking and salivary gland inflammation",
        "A white lesion in the mucobuccal fold caused by long-term exposure to chewing tobacco",
        "A benign granulomatous reaction to chronic friction from a poorly fitting dental prosthesis",
        "A white, raised line on the buccal mucosa at the occlusal plane showing epithelial hyperplasia and hyperkeratosis"
      ],
      correctAnswer: 3
    },
    {
      id: 93280,
      question: "What is nicotinic stomatitis?",
      options: [
        "A benign red and white lesion associated with pipe and/or cigar smoking on the hard palate",
        "A corrugated white lesion in the mucobuccal fold caused by placing chewing tobacco",
        "A traumatic ulcer caused by the thermal irritation from hot foods and beverages",
        "A hyperkeratotic white line on the buccal mucosa at the level of the occlusal plane"
      ],
      correctAnswer: 0
    },
    {
      id: 93281,
      question: "What is tobacco pouch keratosis and why is its treatment important?",
      options: [
        "A red granulomatous lesion on the hard palate seen in cigarette smokers only",
        "A nicotine-stained white plaque on the dorsal tongue with no malignant potential",
        "A harmless white line on the buccal mucosa that requires no treatment or surveillance",
        "A white lesion in the mucobuccal fold from chewing tobacco, treated with tobacco cessation because of associated squamous cell carcinoma risk"
      ],
      correctAnswer: 3
    },
    {
      id: 93282,
      question: "What is a traumatic neuroma?",
      options: [
        "A benign amalgam tattoo caused by introduction of amalgam particles into oral tissue",
        "A flat melanotic macule caused by postinflammatory pigmentation of the oral mucosa",
        "A painful lesion from injury to a peripheral nerve where nerve tissue proliferates into a mass mixed with fibrous scar tissue",
        "A salivary gland lesion caused by blockage of the blood supply causing tissue necrosis"
      ],
      correctAnswer: 2
    },
    {
      id: 93283,
      question: "What is an amalgam tattoo?",
      options: [
        "A flat, bluish-gray lesion of the oral mucosa caused by amalgam introduced into tissue during dental procedures",
        "A painful traumatic neuroma caused by injury to peripheral nerve fibers in oral tissue",
        "An inflammatory pigmentation caused by chronic irritation of the oral mucosal surface",
        "A melanotic macule on the vermilion border of the lips from sun-induced degeneration"
      ],
      correctAnswer: 0
    },
    {
      id: 93284,
      question: "What condition must an amalgam tattoo be differentiated from, and what is the recommended treatment?",
      options: [
        "It must be differentiated from malignant melanoma; treatment is none if melanoma is ruled out",
        "It must be differentiated from nicotinic stomatitis; treatment is cessation of tobacco use",
        "It must be differentiated from tobacco pouch keratosis; treatment is surgical excision",
        "It must be differentiated from a traumatic ulcer; treatment is identification and elimination of the cause"
      ],
      correctAnswer: 0
    },
    {
      id: 93285,
      question: "What is solar cheilitis and what are its prevention strategies?",
      options: [
        "A salivary gland lesion from duct obstruction requiring antibiotic treatment",
        "A chemical burn of the lips caused by topical application of dental cavity agents",
        "A benign inflammatory reaction on the hard palate associated with pipe smoking",
        "A degeneration of lip tissue from sun exposure with increased squamous cell carcinoma risk, prevented by avoiding sun and using sun-block"
      ],
      correctAnswer: 3
    },
    {
      id: 93286,
      question: "What is a mucocele?",
      options: [
        "A true epithelium-lined cyst associated with a blocked minor salivary gland duct",
        "A salivary gland stone formed by precipitation of calcium salts around a central core",
        "A lesion formed when a salivary gland duct is severed and mucous secretion spills into adjacent connective tissue; not a true cyst",
        "A benign swelling of the salivary gland caused by obstruction of the major duct"
      ],
      correctAnswer: 2
    },
    {
      id: 93287,
      question: "What is a sialolith?",
      options: [
        "A mucocele that forms on the floor of the mouth associated with sublingual glands",
        "A benign condition of salivary glands caused by blockage of the blood supply",
        "An inflammatory condition of the salivary gland duct causing painful swelling",
        "A salivary gland stone formed by precipitation of calcium salts around a central core"
      ],
      correctAnswer: 3
    },
    {
      id: 93288,
      question: "What is a ranula?",
      options: [
        "A salivary gland infection caused by bacterial obstruction of the submandibular duct",
        "A benign neoplasm of the sublingual gland requiring surgical excision for treatment",
        "A unilateral mucocele-like lesion on the floor of the mouth associated with the submandibular and sublingual gland ducts",
        "A stone in the parotid gland duct that causes intermittent painful swelling during eating"
      ],
      correctAnswer: 2
    },
    {
      id: 93289,
      question: "What is necrotizing sialometaplasia?",
      options: [
        "A malignant salivary gland tumor that requires immediate radical surgical excision",
        "A benign condition of salivary glands with painful swelling and ulceration caused by blockage of blood supply leading to necrosis; salivary epithelium is replaced by squamous epithelium",
        "A salivary gland stone causing painful duct obstruction and inflammatory swelling",
        "A chronic inflammatory condition of salivary glands from bacterial duct obstruction"
      ],
      correctAnswer: 1
    },
    {
      id: 93290,
      question: "What is reactive connective tissue hyperplasia?",
      options: [
        "A normal physiologic response that permanently replaces damaged tissue with identical cells",
        "An autoimmune condition where the body attacks its own connective tissue proteins",
        "A malignant transformation of connective tissue in response to carcinogenic stimuli",
        "Proliferating exuberant granulation tissue and dense fibrous connective tissue resulting from overzealous repair in response to chronic injury"
      ],
      correctAnswer: 3
    },
    {
      id: 93291,
      question: "What is a pyogenic granuloma?",
      options: [
        "A true pus-forming granuloma caused by bacterial infection in the oral cavity",
        "A granuloma composed of macrophages surrounded by lymphocytes and plasma cells",
        "A proliferation of connective tissue with numerous blood vessels and inflammatory cells in response to injury; the name is a misnomer as it is neither pyogenic nor a true granuloma",
        "A dense fibrous scar tissue lesion with few blood vessels caused by repetitive trauma"
      ],
      correctAnswer: 2
    },
    {
      id: 93292,
      question: "What is a pregnancy tumor?",
      options: [
        "A benign salivary gland tumor that develops exclusively during the third trimester",
        "A pyogenic granuloma seen in a pregnant woman, caused by hormonal changes and increased response to plaque; it often regresses after delivery",
        "A malignant lesion of the oral mucosa associated with hormonal changes in pregnancy",
        "A mucocele of the floor of the mouth that develops due to increased fluid retention"
      ],
      correctAnswer: 1
    },
    {
      id: 93293,
      question: "What is a giant cell granuloma and how is it classified?",
      options: [
        "A granuloma composed of macrophages surrounded by lymphocytes, associated with tuberculosis",
        "A lesion containing multinucleated giant cells and well-vascularized connective tissue, classified as peripheral (outside bone) or central (within mandible or maxilla)",
        "A pyogenic granuloma that develops within the bone marrow of the mandibular alveolus",
        "A benign fibrous lesion on the gingiva caused by trauma and composed of dense scar tissue"
      ],
      correctAnswer: 1
    },
    {
      id: 93294,
      question: "What is an irritation fibroma?",
      options: [
        "Excess granulation tissue forming as a result of overzealous repair after tooth extraction",
        "A proliferation of connective tissue containing numerous blood vessels, caused by chronic infection",
        "A granuloma composed of macrophages surrounded by lymphocytes and plasma cells",
        "The most common mass on the gingiva, caused by trauma, composed of dense scarlike connective tissue with few blood vessels"
      ],
      correctAnswer: 3
    },
    {
      id: 93295,
      question: "What causes denture-induced fibrous hyperplasia and how is it treated?",
      options: [
        "Caused by bacterial infection under the denture; treated with antibiotics and antifungals",
        "Caused by poor oral hygiene under the denture; treated with improved cleaning protocols",
        "Caused by chronic biting of the cheek or lip adjacent to the denture flange area",
        "Caused by an ill-fitting denture, producing elongated folds of dense fibrous connective tissue; treated by surgical removal and relining or replacing the prosthesis"
      ],
      correctAnswer: 3
    },
    {
      id: 93296,
      question: "What is papillary hyperplasia of the palate?",
      options: [
        "A condition associated with denture-induced hyperplasia where the palatal mucosa shows multiple erythematous papillary projections with a \"cobblestone\" appearance",
        "A fibrous proliferation caused by an ill-fitting denture's flange irritating the vestibule",
        "A benign red lesion of the hard palate caused by pipe smoking and salivary gland irritation",
        "A white lesion on the palate caused by placing smokeless tobacco on the hard palate"
      ],
      correctAnswer: 0
    },
    {
      id: 93297,
      question: "What is chronic hyperplastic pulpitis?",
      options: [
        "A periapical granuloma at the root apex of a nonvital tooth caused by pulp necrosis",
        "An epithelium-lined cyst associated with the root of a nonvital tooth from pulp infection",
        "An excessive proliferation of chronically inflamed dental pulp tissue occurring in teeth with large open carious lesions, usually asymptomatic",
        "A purulent exudate at the root apex causing severe pain and possible tooth extrusion"
      ],
      correctAnswer: 2
    },
    {
      id: 93298,
      question: "What is a periapical abscess?",
      options: [
        "A localized mass of chronically inflamed granulation tissue at the apex of a nonvital tooth",
        "An epithelium-lined cyst associated with the root of a nonvital tooth from rests of Malassez",
        "A change in bone density near tooth apices as a reaction to low-grade infection",
        "A purulent exudate surrounded by connective tissue with neutrophils and lymphocytes, producing severe pain and possibly extruding the tooth from its socket"
      ],
      correctAnswer: 3
    },
    {
      id: 93299,
      question: "What is a periapical granuloma?",
      options: [
        "A localized mass of chronically inflamed granulation tissue at the apex of a nonvital tooth; usually asymptomatic and treated with endodontic therapy or extraction",
        "A purulent exudate at the tooth apex causing severe pain and tooth extrusion",
        "A true epithelium-lined cyst associated with a nonvital tooth and rests of Malassez",
        "A bone reaction to low-grade infection appearing as a radiopaque lesion near the apex"
      ],
      correctAnswer: 0
    },
    {
      id: 93300,
      question: "What is a radicular (periapical) cyst?",
      options: [
        "A localized collection of pus at the root apex surrounded by connective tissue",
        "A chronic granuloma at the root apex composed of macrophages and lymphocytes",
        "A reactive bone lesion near the mandibular first molar that appears radiopaque",
        "A true epithelium-lined cyst associated with a nonvital tooth, resulting from proliferation of the rests of Malassez; the most common cyst in the oral region"
      ],
      correctAnswer: 3
    },
    {
      id: 93301,
      question: "What is a residual cyst?",
      options: [
        "A cyst that forms after tooth extraction when all or part of the radicular cyst remains",
        "A periapical cyst that develops at the apex of an erupted tooth with a vital pulp",
        "A granuloma that persists after endodontic therapy has been successfully completed",
        "An abscess that reforms after inadequate drainage of the original purulent exudate"
      ],
      correctAnswer: 0
    },
    {
      id: 93302,
      question: "What are the causes of external tooth resorption?",
      options: [
        "Inflammation, pressure, reimplantation of an avulsed tooth, or idiopathic reasons",
        "Caries, periodontal disease, and occlusal trauma only",
        "Bruxism, abfraction, and chemical erosion from acidic beverages or vomiting",
        "Genetic factors, metabolic disorders, and systemic medication side effects only"
      ],
      correctAnswer: 0
    },
    {
      id: 93303,
      question: "What is internal tooth resorption and how does it appear clinically and radiographically?",
      options: [
        "Resorption starting from the outside of the tooth; appears as wedge-shaped cervical lesions",
        "Resorption associated with pulp inflammation; appears clinically as a pinkish area in the crown and radiographically as a radiolucency",
        "Resorption caused by occlusal pressure; appears as flattened root tips on radiograph",
        "Resorption from reimplantation; appears as external root surface irregularities on radiograph"
      ],
      correctAnswer: 1
    },
    {
      id: 93304,
      question: "What is focal sclerosing osteomyelitis?",
      options: [
        "A painful periapical abscess that develops from untreated pulpal inflammation",
        "A radiopaque change in bone near tooth apices, thought to be a reaction to low-grade infection; commonly associated with the mandibular first molar and usually asymptomatic",
        "An epithelium-lined periapical cyst associated with a nonvital tooth in the mandible",
        "A granuloma composed of macrophages and lymphocytes at the root apex of a dead tooth"
      ],
      correctAnswer: 1
    },
    {
      id: 93305,
      question: "What is alveolar osteitis (\"dry socket\")?",
      options: [
        "A chronic infection of the alveolar bone that develops weeks after a tooth extraction",
        "A postoperative complication where the blood clot is lost before healing, exposing raw nerve endings; most common in mandibular third molar areas",
        "A periapical abscess that develops when a blood clot becomes infected after extraction",
        "A form of osteomyelitis caused by bacterial contamination of the extraction socket"
      ],
      correctAnswer: 1
    },
    {
      id: 93306,
      question: "What are the risk factors for developing alveolar osteitis (\"dry socket\")?",
      options: [
        "Dissolution of the clot, traumatic extraction, pre-existing infection, and tobacco smoking after extraction",
        "Prior radiation therapy, bone loss from periodontal disease, and systemic bone disorders",
        "Young age, maxillary tooth extraction, patient on anticoagulants, and poor bone density",
        "Excessive irrigation of the socket, use of local anesthetic with vasoconstrictors, and systemic antibiotics"
      ],
      correctAnswer: 0
    },
    {
      id: 93307,
      question: "What is the treatment for alveolar osteitis?",
      options: [
        "Gentle irrigation and daily application of Dry Socket Paste containing eucalyptol until symptoms are relieved",
        "Surgical debridement, bone grafting, and systemic antibiotics for at least two weeks",
        "Immediate re-extraction of the socket followed by primary closure with sutures",
        "Prescription of opioid analgesics and systemic corticosteroids to reduce inflammation"
      ],
      correctAnswer: 0
    },
    {
      id: 93308,
      question: "What is gingival enlargement and what are its potential causes?",
      options: [
        "A localized increase in interdental papillae caused exclusively by bacterial plaque accumulation",
        "A decrease in gingival tissue volume caused by inflammatory destruction of bone",
        "A generalized recession of the gingival margin caused by aggressive brushing habits",
        "An increase in the bulk of free and attached gingiva caused by local irritants, hormonal changes, drugs, heredity, leukemia, or idiopathic factors"
      ],
      correctAnswer: 3
    },
    {
      id: 93309,
      question: "Inflammation is a specific response that only occurs in reaction to known antigens.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93310,
      question: "The kinin system is active in the early phases of inflammation and is responsible for inducing vasodilation, increased permeability, and pain.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93311,
      question: "Neutrophils constitute 3% to 8% of the total white blood cell population in circulating blood.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93312,
      question: "A pyogenic granuloma is so named because it produces pus and is a true granuloma in the histopathological sense.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93313,
      question: "A radicular cyst is the most commonly occurring cyst in the oral region and is associated with the root of a nonvital tooth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93314,
      question: "Healing by secondary intention involves less granulation tissue and less scar tissue formation than healing by primary intention.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93315,
      question: "Tobacco pouch keratosis from long-term chewing tobacco use has been associated with an increased risk of squamous cell carcinoma.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93316,
      question: "Alveolar osteitis most commonly occurs following extraction of maxillary incisors.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93317,
      question: "C-reactive protein is produced by the liver and a chronically increased level is associated with an increased risk for cardiovascular disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93318,
      question: "A mucocele is a true epithelium-lined cyst because it is formed when mucous secretion pools in the connective tissue.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "6. Immunity and Immunologic Oral Lesions": [
    {
      id: 93319,
      question: "Which of the following is a key characteristic of the acquired immune response?",
      options: [
        "It responds more slowly than the inflammatory response",
        "It has memory capability and defends the body against injury",
        "It only involves red blood cells in its network",
        "It cannot result in tissue damage under any circumstances"
      ],
      correctAnswer: 1
    },
    {
      id: 93320,
      question: "Which condition results when the immune system fails to recognize foreign material as an antigen?",
      options: [
        "Autoimmune disease",
        "Hypersensitivity",
        "Passive immunity",
        "Immunodeficiency"
      ],
      correctAnswer: 3
    },
    {
      id: 93321,
      question: "Overreaction of the immune system to an antigen is called:",
      options: [
        "Hypersensitivity",
        "Immunodeficiency",
        "Cellular immunity",
        "Immunologic tolerance"
      ],
      correctAnswer: 0
    },
    {
      id: 93322,
      question: "Which cells are NOT listed as part of the cellular involvement in the immune response?",
      options: [
        "Erythrocytes",
        "B-cell lymphocytes",
        "Natural killer cells",
        "Dendritic cells"
      ],
      correctAnswer: 0
    },
    {
      id: 93323,
      question: "B-cell lymphocytes develop from stem cells in which organ?",
      options: [
        "Bone marrow",
        "Thymus",
        "Spleen",
        "Liver"
      ],
      correctAnswer: 0
    },
    {
      id: 93324,
      question: "Which type of B-cell retains memory of a previously encountered antigen and clones itself upon re-exposure?",
      options: [
        "Natural killer cell",
        "B memory cell",
        "T-helper cell",
        "Plasma cell"
      ],
      correctAnswer: 1
    },
    {
      id: 93325,
      question: "Plasma cells are best characterized by which of the following descriptions?",
      options: [
        "Round cells with a pinwheel-shaped nucleus that produce antibodies",
        "Large cells with irregular nuclei that perform phagocytosis",
        "Small lymphocytes that suppress immune activity",
        "Dendritic cells with long projections that present antigens"
      ],
      correctAnswer: 0
    },
    {
      id: 93326,
      question: "Which immunoglobulin is associated with Type I hypersensitivity reactions such as hay fever and anaphylaxis?",
      options: [
        "IgE",
        "IgA",
        "IgM",
        "IgG"
      ],
      correctAnswer: 0
    },
    {
      id: 93327,
      question: "The term \"antibody titer\" refers to:",
      options: [
        "The level of a specific antibody in serum",
        "The number of T cells in circulation",
        "The ratio of T cells to B cells in lymph tissue",
        "The amount of antigen present in the bloodstream"
      ],
      correctAnswer: 0
    },
    {
      id: 93328,
      question: "An immune complex is formed by the combination of:",
      options: [
        "Two different antibodies binding together",
        "An antibody and its corresponding antigen",
        "A T cell and a dendritic cell",
        "A macrophage and a plasma cell"
      ],
      correctAnswer: 1
    },
    {
      id: 93329,
      question: "T-cell lymphocytes mature in which organ before entering circulation?",
      options: [
        "Thymus",
        "Bone marrow",
        "Spleen",
        "Lymph node"
      ],
      correctAnswer: 0
    },
    {
      id: 93330,
      question: "Which type of T cell increases the functioning of B cells and enhances the antibody response?",
      options: [
        "T-helper cell",
        "T-suppressor cell",
        "T-cytotoxic cell",
        "T-memory cell"
      ],
      correctAnswer: 0
    },
    {
      id: 93331,
      question: "T-cytotoxic cells carry which surface marker?",
      options: [
        "CD4",
        "CD8",
        "CD3",
        "CD19"
      ],
      correctAnswer: 1
    },
    {
      id: 93332,
      question: "Natural killer (NK) cells are primarily active against:",
      options: [
        "Bacterial infections and parasites only",
        "Viruses, cancer cells, and foreign cells",
        "Fungal spores and environmental allergens",
        "Only cells marked by IgM antibodies"
      ],
      correctAnswer: 1
    },
    {
      id: 93333,
      question: "Macrophages serve as a messenger between which two responses?",
      options: [
        "The inflammatory response and the immune response",
        "Humoral immunity and cell-mediated immunity",
        "Passive immunity and active immunity",
        "Innate immunity and passive immunity"
      ],
      correctAnswer: 0
    },
    {
      id: 93334,
      question: "Which of the following is TRUE regarding macrophages and immunological memory?",
      options: [
        "Macrophages amplify the immune response but do not retain memory of the encountered antigen",
        "Macrophages retain strong memory of previously encountered antigens",
        "Macrophages are the primary cells responsible for long-term immunity",
        "Macrophages produce immunoglobulins that neutralize specific antigens"
      ],
      correctAnswer: 0
    },
    {
      id: 93335,
      question: "Dendritic cells are classified as antigen-presenting cells (APCs) because they:",
      options: [
        "Produce large quantities of IgG antibodies in response to pathogens",
        "Process antigenic material and present it to other immune system cells",
        "Release histamine to cause vasodilation at infection sites",
        "Directly destroy virally infected cells through cytotoxic mechanisms"
      ],
      correctAnswer: 1
    },
    {
      id: 93336,
      question: "The Langerhans' cell is best described as:",
      options: [
        "A type of macrophage found in connective tissue",
        "A specialized dendritic cell",
        "A plasma cell that produces IgA",
        "A T-memory cell found in the epidermis"
      ],
      correctAnswer: 1
    },
    {
      id: 93337,
      question: "Which of the following is a cytokine?",
      options: [
        "Complement protein",
        "Interleukin",
        "IgE",
        "Immunoglobulin G"
      ],
      correctAnswer: 1
    },
    {
      id: 93338,
      question: "The two major divisions of the immune response are:",
      options: [
        "Innate immunity and passive immunity",
        "Humoral immunity and cell-mediated immunity",
        "Active immunity and acquired immunity",
        "Cellular immunity and passive immunity"
      ],
      correctAnswer: 1
    },
    {
      id: 93339,
      question: "In humoral immunity, which cells are the primary effectors?",
      options: [
        "T cells",
        "B cells",
        "NK cells",
        "Macrophages"
      ],
      correctAnswer: 1
    },
    {
      id: 93340,
      question: "Cell-mediated immunity primarily regulates the immune response through the activity of:",
      options: [
        "Dendritic cells presenting antigens",
        "T cells",
        "Plasma cells secreting immunoglobulins",
        "Macrophages releasing lysosomal enzymes"
      ],
      correctAnswer: 1
    },
    {
      id: 93341,
      question: "What distinguishes the immune system from the inflammatory system with regard to memory?",
      options: [
        "The inflammatory system has memory; the immune system does not",
        "Both systems have equal memory capabilities for pathogens",
        "Neither system retains memory after the initial response",
        "The immune system has memory; the inflammatory system does not"
      ],
      correctAnswer: 3
    },
    {
      id: 93342,
      question: "Passive immunity acquired naturally occurs through which mechanism?",
      options: [
        "Immunization with a killed-type vaccine",
        "Transfer of antibodies from mother to fetus",
        "The individual contracting and recovering from a disease",
        "Administration of a live-attenuated vaccine"
      ],
      correctAnswer: 1
    },
    {
      id: 93343,
      question: "Active immunity acquired through immunization may involve which vaccine type?",
      options: [
        "Killed-type vaccine or live-attenuated vaccine",
        "Passive transfer only, with no antigen exposure",
        "Maternal antibody transfer to newborns",
        "Direct injection of T cells from a donor"
      ],
      correctAnswer: 0
    },
    {
      id: 93344,
      question: "Immunopathology is defined as:",
      options: [
        "The branch of medicine that designs antibody-based therapies",
        "The study of vaccine development and immunization schedules",
        "The analysis of lymphocyte counts in peripheral blood samples",
        "The study of immune reactions involved in disease or malfunctioning of the immune system"
      ],
      correctAnswer: 3
    },
    {
      id: 93345,
      question: "Which of the following is an example of Type I (anaphylactic) hypersensitivity?",
      options: [
        "Rejection of a transplanted organ",
        "Hay fever and anaphylaxis",
        "Autoimmune hemolytic anemia",
        "Granulomatous disease"
      ],
      correctAnswer: 1
    },
    {
      id: 93346,
      question: "In Type I hypersensitivity, IgE causes which cells to release histamine?",
      options: [
        "Plasma cells",
        "NK cells",
        "Mast cells",
        "Dendritic cells"
      ],
      correctAnswer: 2
    },
    {
      id: 93347,
      question: "Type II hypersensitivity is characterized by:",
      options: [
        "Formation of immune complexes deposited in body tissues",
        "T cells causing delayed tissue damage after antigen exposure",
        "IgE-mediated release of histamine from mast cells",
        "Antibody combining with an antigen on the surface of tissue cells, leading to cell destruction"
      ],
      correctAnswer: 3
    },
    {
      id: 93348,
      question: "Which immunoglobulins participate in Type II hypersensitivity reactions alongside activated complement?",
      options: [
        "IgA and IgE",
        "IgG and IgM",
        "IgD and IgE",
        "IgA and IgD"
      ],
      correctAnswer: 1
    },
    {
      id: 93349,
      question: "Type III hypersensitivity is also known as:",
      options: [
        "Anaphylactic type",
        "Cytotoxic type",
        "Cell-mediated type",
        "Immune complex type"
      ],
      correctAnswer: 3
    },
    {
      id: 93350,
      question: "In Type III hypersensitivity, tissue destruction ultimately results from:",
      options: [
        "IgE binding to mast cells and releasing histamine",
        "Direct attack by T-cytotoxic cells on infected tissue",
        "Phagocytosis of deposited immune complexes by neutrophils",
        "Complement-mediated lysis of red blood cells"
      ],
      correctAnswer: 2
    },
    {
      id: 93351,
      question: "Type IV hypersensitivity (cell-mediated type) is responsible for:",
      options: [
        "Anaphylactic shock after bee stings",
        "Autoimmune hemolytic anemia",
        "Hay fever and allergic asthma",
        "Rejection of tissue grafts and transplanted organs"
      ],
      correctAnswer: 3
    },
    {
      id: 93352,
      question: "Regarding drug hypersensitivity, which route of administration tends to cause more widespread and severe reactions?",
      options: [
        "Parenteral administration",
        "Oral administration",
        "Topical administration",
        "Inhalation administration"
      ],
      correctAnswer: 0
    },
    {
      id: 93353,
      question: "Aphthous ulcers occur in approximately what percentage of the population?",
      options: [
        "5%",
        "20%",
        "40%",
        "10%"
      ],
      correctAnswer: 1
    },
    {
      id: 93354,
      question: "Which factor is listed as the most common precipitating factor for aphthous ulcers?",
      options: [
        "Emotional stress",
        "Certain foods",
        "Hormonal changes",
        "Trauma"
      ],
      correctAnswer: 3
    },
    {
      id: 93355,
      question: "Aphthous ulcers occur in which three forms?",
      options: [
        "Superficial, deep, and nodular",
        "Vesicular, bullous, and erosive",
        "Minor, major, and herpetiform",
        "Primary, secondary, and recurrent"
      ],
      correctAnswer: 2
    },
    {
      id: 93356,
      question: "Minor aphthous ulcers are characterized by all of the following EXCEPT:",
      options: [
        "Discrete, round or oval shape",
        "Erythematous halo surrounding yellowish-white fibrin surface",
        "Size greater than 2 cm in diameter",
        "Occurring on movable mucosa"
      ],
      correctAnswer: 2
    },
    {
      id: 93357,
      question: "Major aphthous ulcers differ from minor aphthous ulcers in that they are:",
      options: [
        "Smaller, shallower, and heal within one week",
        "Located exclusively on the attached gingiva and hard palate",
        "Caused by a viral pathogen rather than an immunologic mechanism",
        "Larger (>1 cm), deeper, more painful, and may require several weeks to heal"
      ],
      correctAnswer: 3
    },
    {
      id: 93358,
      question: "Herpetiform aphthous ulcers are described as:",
      options: [
        "Large solitary ulcers exceeding 2 cm located on the soft palate",
        "Bullous lesions that rupture to form irregular erosions on attached gingiva",
        "Recurrent vesicular lesions caused by the herpes simplex virus",
        "Tiny (1–2 mm) ulcers resembling herpes simplex ulcers that occur in groups"
      ],
      correctAnswer: 3
    },
    {
      id: 93359,
      question: "Which systemic disease is listed as associated with recurrent aphthous ulcers?",
      options: [
        "Crohn disease",
        "Diabetes mellitus",
        "Rheumatoid arthritis",
        "Systemic hypertension"
      ],
      correctAnswer: 0
    },
    {
      id: 93360,
      question: "Treatment for aphthous ulcers may include all of the following EXCEPT:",
      options: [
        "Topical corticosteroids",
        "Systemic antibiotics for bacterial eradication",
        "Nicotine replacement therapy",
        "Lidocaine or benzocaine for pain relief"
      ],
      correctAnswer: 1
    },
    {
      id: 93361,
      question: "Urticaria (hives) lesions are caused by:",
      options: [
        "Immune complex deposition in deep connective tissue vessels",
        "T-cell-mediated cytotoxicity against skin keratinocytes",
        "Localized areas of vascular permeability in superficial connective tissue",
        "Autoantibody formation against basement membrane proteins"
      ],
      correctAnswer: 2
    },
    {
      id: 93362,
      question: "How does angioedema differ from urticaria?",
      options: [
        "Angioedema involves the superficial skin and is intensely pruritic",
        "Angioedema only affects mucosal surfaces while urticaria only affects the skin",
        "Angioedema is an IgE-independent reaction while urticaria always involves IgE",
        "Angioedema involves diffuse swelling from deeper vessel permeability and usually does not itch"
      ],
      correctAnswer: 3
    },
    {
      id: 93363,
      question: "Which of the following is listed as treatment for urticaria and angioedema?",
      options: [
        "Antihistaminic drugs and epinephrine",
        "Topical corticosteroids and antifungal agents",
        "Systemic antibiotics and antiviral medications",
        "Fluoride application and saliva substitutes"
      ],
      correctAnswer: 0
    },
    {
      id: 93364,
      question: "Contact mucositis and contact dermatitis involve which type of hypersensitivity?",
      options: [
        "Type I (anaphylactic type)",
        "Type II (cytotoxic type)",
        "Type III (immune complex type)",
        "Type IV (cell-mediated type)"
      ],
      correctAnswer: 3
    },
    {
      id: 93365,
      question: "Which of the following is listed as a possible cause of contact mucositis in a dental setting?",
      options: [
        "Fluoride supplements and xylitol gum",
        "Saline rinses and chlorhexidine",
        "Acrylics, metal-based alloys, and preservatives in local anesthetics",
        "Calcium hydroxide, zinc oxide, and eugenol only"
      ],
      correctAnswer: 2
    },
    {
      id: 93366,
      question: "The characteristic skin lesion of erythema multiforme is described as:",
      options: [
        "A target or bull's-eye lesion with concentric erythematous rings",
        "A smooth urticarial wheal with a pale center",
        "A vesicular eruption in a dermatomal distribution",
        "A malar butterfly rash across the bridge of the nose"
      ],
      correctAnswer: 0
    },
    {
      id: 93367,
      question: "Stevens-Johnson syndrome is best described as:",
      options: [
        "The mildest form of erythema multiforme with limited skin involvement",
        "A variant of lichen planus with gingival desquamation",
        "A Type I hypersensitivity reaction affecting only the oral mucosa",
        "The most severe form of erythema multiforme with bloody lips and possible blindness"
      ],
      correctAnswer: 3
    },
    {
      id: 93368,
      question: "Treatment for erythema multiforme may include:",
      options: [
        "Topical antifungals and antiviral rinses only",
        "Removing the cause when possible, corticosteroids, and antiviral medications",
        "Surgical excision of affected mucosa and radiation therapy",
        "Pilocarpine for xerostomia and fluoride therapy"
      ],
      correctAnswer: 1
    },
    {
      id: 93369,
      question: "Lichen planus is classified as:",
      options: [
        "An acute, self-limited viral infection of the oral mucosa",
        "A bacterial infection of the salivary glands causing xerostomia",
        "A benign, chronic disease of unknown cause affecting skin and oral mucosa",
        "An aggressive autoimmune condition with high malignant transformation rate"
      ],
      correctAnswer: 2
    },
    {
      id: 93370,
      question: "The characteristic lacelike white pattern of lichen planus lesions is called:",
      options: [
        "Nikolsky sign",
        "Tzanck pattern",
        "Acantholysis",
        "Wickham striae"
      ],
      correctAnswer: 3
    },
    {
      id: 93371,
      question: "Lichen planus most commonly affects which oral site?",
      options: [
        "Dorsum of the tongue",
        "Hard palate",
        "Buccal mucosa",
        "Floor of the mouth"
      ],
      correctAnswer: 2
    },
    {
      id: 93372,
      question: "Which demographic is most commonly affected by oral lichen planus?",
      options: [
        "Children under 10 years of age",
        "Teenagers and young adults",
        "Middle-aged individuals, slightly more common in women",
        "Elderly men over 70 years of age"
      ],
      correctAnswer: 2
    },
    {
      id: 93373,
      question: "The most common form of oral lichen planus is:",
      options: [
        "Reticular lichen planus",
        "Erosive lichen planus",
        "Bullous lichen planus",
        "Plaque-type lichen planus"
      ],
      correctAnswer: 0
    },
    {
      id: 93374,
      question: "In erosive and bullous lichen planus, the epithelium:",
      options: [
        "Shows hyperkeratosis with parakeratosis above the basal layer",
        "Displays acantholytic Tzanck cells throughout the spinous layer",
        "Becomes thickened with broad rete ridges",
        "Separates from the connective tissue, forming erosive areas"
      ],
      correctAnswer: 3
    },
    {
      id: 93375,
      question: "Patients with lichen planus require biopsy of suspicious lesions because they may be at increased risk for:",
      options: [
        "Sjögren syndrome",
        "Pemphigus vulgaris",
        "Squamous cell carcinoma",
        "Mucous membrane pemphigoid"
      ],
      correctAnswer: 2
    },
    {
      id: 93376,
      question: "Reactive arthritis (Reiter syndrome) classically presents with which triad?",
      options: [
        "Xerostomia, xerophthalmia, and rheumatoid arthritis",
        "Oral ulcers, genital ulcers, and ocular inflammation",
        "Arthritis, urethritis, and conjunctivitis",
        "Bullous skin lesions, esophageal involvement, and sclerodactyly"
      ],
      correctAnswer: 2
    },
    {
      id: 93377,
      question: "Which antigenic marker found in most Reiter syndrome patients suggests a genetic influence?",
      options: [
        "HLA-DR4",
        "Anti-dsDNA",
        "ANA",
        "HLA-B27"
      ],
      correctAnswer: 3
    },
    {
      id: 93378,
      question: "Langerhans' cell histiocytosis lesions are characterized microscopically by:",
      options: [
        "Langerhans' cells and eosinophils",
        "Plasma cells and Russell bodies",
        "Acantholytic Tzanck cells within the spinous layer",
        "Band-like lymphocytes at the epithelial–connective tissue junction"
      ],
      correctAnswer: 0
    },
    {
      id: 93379,
      question: "The acute disseminated form of Langerhans' cell histiocytosis is known as:",
      options: [
        "Eosinophilic granuloma",
        "Letterer-Siwe disease",
        "Hand-Schüller-Christian disease",
        "Behçet syndrome"
      ],
      correctAnswer: 1
    },
    {
      id: 93380,
      question: "Which form of Langerhans' cell histiocytosis affects older children and young adults, involves the skull and mandible, and may resemble periodontal disease radiographically?",
      options: [
        "Letterer-Siwe disease",
        "Bullous pemphigoid",
        "Eosinophilic granuloma",
        "Hand-Schüller-Christian disease"
      ],
      correctAnswer: 2
    },
    {
      id: 93381,
      question: "Treatment for eosinophilic granuloma includes:",
      options: [
        "Pilocarpine and artificial tears",
        "Topical and systemic corticosteroids only",
        "Antihistamines and epinephrine",
        "Surgical excision and radiation therapy"
      ],
      correctAnswer: 3
    },
    {
      id: 93382,
      question: "Sjögren syndrome primarily affects which organs?",
      options: [
        "Salivary and lacrimal glands",
        "Kidneys and adrenal glands",
        "Lungs and pleura",
        "Liver and pancreas"
      ],
      correctAnswer: 0
    },
    {
      id: 93383,
      question: "Secondary Sjögren syndrome is defined as Sjögren syndrome that:",
      options: [
        "Occurs in patients over 65 years with no other autoimmune disease",
        "Occurs in men with a history of radiation therapy to the head",
        "Occurs in conjunction with other autoimmune disorders",
        "Occurs in children as a rare congenital form of the disease"
      ],
      correctAnswer: 2
    },
    {
      id: 93384,
      question: "Parotid gland enlargement occurs in approximately what percentage of Sjögren syndrome patients?",
      options: [
        "10%",
        "25%",
        "50%",
        "90%"
      ],
      correctAnswer: 2
    },
    {
      id: 93385,
      question: "Patients with Sjögren syndrome are at high risk for which oral complications?",
      options: [
        "Leukoplakia, erythroplakia, and oral lichen planus",
        "Caries, periodontal disease, and oral candidiasis",
        "Aphthous ulcers, herpetic stomatitis, and geographic tongue",
        "Pemphigus vulgaris, mucous membrane pemphigoid, and angioedema"
      ],
      correctAnswer: 1
    },
    {
      id: 93386,
      question: "Histologically, minor salivary gland biopsy in Sjögren syndrome reveals:",
      options: [
        "Acantholytic cells with loss of intercellular bridges",
        "Dense fibrosis replacing glandular parenchyma",
        "Granulomatous inflammation with Langhans giant cells",
        "Aggregates of lymphocytes surrounding the salivary gland ducts"
      ],
      correctAnswer: 3
    },
    {
      id: 93387,
      question: "Diagnosis of Sjögren syndrome is made when at least two of which three components are present?",
      options: [
        "Arthralgia, myalgia, and chronic fatigue",
        "Parotid enlargement, elevated ESR, and positive ANA",
        "Xerostomia, keratoconjunctivitis sicca, and rheumatoid arthritis",
        "Oral ulcers, genital ulcers, and ocular inflammation"
      ],
      correctAnswer: 2
    },
    {
      id: 93388,
      question: "Which drug is mentioned as a saliva stimulant treatment for xerostomia in Sjögren syndrome?",
      options: [
        "Hydroxychloroquine",
        "Chlorambucil",
        "Pilocarpine",
        "Methotrexate"
      ],
      correctAnswer: 2
    },
    {
      id: 93389,
      question: "Systemic lupus erythematosus (SLE) affects which gender more frequently and at what ratio?",
      options: [
        "Women, eight times more than men",
        "Men, six times more than women",
        "Men and women equally across all age groups",
        "Women, twice as often as men"
      ],
      correctAnswer: 0
    },
    {
      id: 93390,
      question: "The classic skin finding in SLE is:",
      options: [
        "Wickham striae on the buccal mucosa",
        "Target lesions on the extremities",
        "Vesicular eruptions in a dermatomal pattern",
        "A butterfly rash on the bridge of the nose"
      ],
      correctAnswer: 3
    },
    {
      id: 93391,
      question: "SLE diagnosis is based on multiorgan involvement and the presence of which antibodies in serum?",
      options: [
        "Anti-Sjögren syndrome A and B antibodies",
        "Anti-desmoglein antibodies",
        "Antinuclear antibodies (ANA)",
        "Rheumatoid factor (anti-IgG)"
      ],
      correctAnswer: 2
    },
    {
      id: 93392,
      question: "Pemphigus vulgaris is characterized by intraepithelial blister formation resulting from:",
      options: [
        "Separation of the epithelium from the basement membrane",
        "Lymphocyte infiltration causing basal cell layer degeneration",
        "IgE-mediated mast cell degranulation in the submucosa",
        "Acantholysis — a breakdown of cellular adhesion between epithelial cells"
      ],
      correctAnswer: 3
    },
    {
      id: 93393,
      question: "In what percentage of pemphigus vulgaris cases do the first signs occur in the oral cavity?",
      options: [
        "More than 50%",
        "Approximately 25%",
        "Less than 10%",
        "Exactly 75%"
      ],
      correctAnswer: 0
    },
    {
      id: 93394,
      question: "The Nikolsky sign in pemphigus vulgaris refers to:",
      options: [
        "A white lacelike pattern visible on the buccal mucosa",
        "A positive skin test confirming IgE-mediated allergy",
        "Rubbing with a finger producing a bulla due to fragile epithelium",
        "Development of a pustular lesion after needle puncture"
      ],
      correctAnswer: 2
    },
    {
      id: 93395,
      question: "The acantholytic cells seen histologically in pemphigus vulgaris are also called:",
      options: [
        "Russell bodies",
        "Langhans giant cells",
        "Wickham cells",
        "Tzanck cells"
      ],
      correctAnswer: 3
    },
    {
      id: 93396,
      question: "Treatment for pemphigus vulgaris includes high doses of corticosteroids, and the five-year mortality rate related to complications of corticosteroid treatment is:",
      options: [
        "Less than 1%",
        "3–5%",
        "8–10%",
        "20–25%"
      ],
      correctAnswer: 2
    },
    {
      id: 93397,
      question: "Mucous membrane pemphigoid (cicatricial pemphigoid) differs from pemphigus vulgaris in that it:",
      options: [
        "Is not as severe as pemphigus vulgaris, and shows no acantholysis",
        "Is more severe and has higher mortality",
        "Only affects the oral mucosa with no skin involvement",
        "Is caused by Type I hypersensitivity rather than autoimmunity"
      ],
      correctAnswer: 0
    },
    {
      id: 93398,
      question: "Gingival lesions associated with mucous membrane pemphigoid have been called:",
      options: [
        "Geographic tongue",
        "Acute necrotizing ulcerative gingivitis",
        "Desquamative gingivitis",
        "Plasma cell gingivitis"
      ],
      correctAnswer: 2
    },
    {
      id: 93399,
      question: "In the diagnosis of mucous membrane pemphigoid, histologic examination reveals inflammatory infiltrate with which predominant cells in connective tissue?",
      options: [
        "Neutrophils and macrophages",
        "Plasma cells and eosinophils",
        "T lymphocytes and NK cells",
        "Mast cells and basophils"
      ],
      correctAnswer: 1
    },
    {
      id: 93400,
      question: "Bullous pemphigoid primarily affects which age group?",
      options: [
        "Infants younger than 1 year",
        "Children aged 5–15 years",
        "Adults aged 30–50 years",
        "Patients older than 60 years, with 80% over age 60"
      ],
      correctAnswer: 3
    },
    {
      id: 93401,
      question: "Behçet syndrome diagnosis requires the presence of at least two of which three lesion types?",
      options: [
        "Articular, neurological, and cutaneous",
        "Oral, genital, and ocular",
        "Cutaneous, gastrointestinal, and vascular",
        "Lymphadenopathy, fever, and mucosal ulcers"
      ],
      correctAnswer: 1
    },
    {
      id: 93402,
      question: "Which clinical sign is suggestive of Behçet syndrome after needle puncture?",
      options: [
        "Nikolsky sign — bulla formation with lateral pressure",
        "Positive Tzanck smear showing acantholytic cells",
        "Wickham striae appearing on the buccal mucosa",
        "A pustular lesion developing at the needle puncture site"
      ],
      correctAnswer: 3
    },
    {
      id: 93403,
      question: "Chlorambucil is specifically used in Behçet syndrome treatment for which type of lesions?",
      options: [
        "Oral ulcers",
        "Genital ulcers",
        "Skin lesions",
        "Ocular lesions"
      ],
      correctAnswer: 3
    },
    {
      id: 93404,
      question: "Raynaud phenomenon, associated with Sjögren syndrome in 20% of patients, is characterized by:",
      options: [
        "Diffuse joint swelling with warmth and erythema triggered by stress",
        "Initial pallor and cyanosis of fingers and toes caused by cold or stress",
        "Sudden onset of oral ulcers and xerostomia during cold weather",
        "Persistent periorbital edema and sclerodactyly after infections"
      ],
      correctAnswer: 1
    },
    {
      id: 93405,
      question: "In major salivary glands affected by Sjögren syndrome, histology shows replacement by lymphocytes and the presence of epithelial islands called:",
      options: [
        "Epimyoepithelial islands",
        "Tzanck cells",
        "Russell bodies",
        "Langerhans islands"
      ],
      correctAnswer: 0
    },
    {
      id: 93406,
      question: "Immunodeficiency is defined as a deficiency in the:",
      options: [
        "Number, function, or interrelationships of WBCs and their products",
        "Number of red blood cells and their oxygen-carrying capacity",
        "Efficiency of the inflammatory response at wound sites",
        "Production of complement proteins in the liver"
      ],
      correctAnswer: 0
    },
    {
      id: 93407,
      question: "SLE treatment includes which of the following drug combinations?",
      options: [
        "Pilocarpine, fluoride, and artificial tears",
        "Aspirin, hydroxychloroquine, corticosteroids, and immunosuppressive agents",
        "Antihistamines, epinephrine, and topical corticosteroids",
        "Chlorambucil, methotrexate, and systemic antiviral medications"
      ],
      correctAnswer: 1
    },
    {
      id: 93408,
      question: "Oral lesions in SLE accompany skin lesions in about what percentage of patients with discoid lupus?",
      options: [
        "10%",
        "50%",
        "25%",
        "75%"
      ],
      correctAnswer: 2
    },
    {
      id: 93409,
      question: "Which of the following best describes the microscopic hallmark of lichen planus?",
      options: [
        "Intraepithelial vesicle formation with acantholytic cells",
        "Granulomatous inflammation with Langhans giant cells",
        "Broad band of lymphocytes in connective tissue with degeneration of the basal cell layer",
        "Diffuse neutrophilic infiltration with microabscesses"
      ],
      correctAnswer: 2
    },
    {
      id: 93410,
      question: "Which cytokine is NOT listed in the chapter as part of the immune communication system?",
      options: [
        "Interleukins",
        "Tumor necrosis factor",
        "Interferons",
        "Prostaglandins"
      ],
      correctAnswer: 3
    },
    {
      id: 93411,
      question: "Which oral diseases are listed among those with immunologic pathogenesis in this chapter?",
      options: [
        "Dental caries, periodontitis, and oral candidiasis",
        "Aphthous ulcers, lichen planus, erythema multiforme, and Langerhans' cell disease",
        "Herpes simplex, herpes zoster, and herpangina",
        "Osteomyelitis, cellulitis, and Ludwig's angina"
      ],
      correctAnswer: 1
    },
    {
      id: 93412,
      question: "Hand-Schüller-Christian disease oral manifestations include all of the following EXCEPT:",
      options: [
        "Mobile and sensitive teeth",
        "Nonhealing extraction sites and bone loss",
        "Xerostomia and loss of tongue papillae",
        "Halitosis and early exfoliation of teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 93413,
      question: "The acquired immune response responds more slowly than the inflammatory response.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93414,
      question: "B-cell lymphocytes mature in the thymus before migrating to lymphoid tissue.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93415,
      question: "There are five different types of immunoglobulins: IgA, IgD, IgE, IgG, and IgM.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93416,
      question: "T-helper cells carry the CD8 surface marker.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93417,
      question: "Macrophages amplify the immune response but do not have memory of the encountered antigen.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93418,
      question: "In Type I hypersensitivity, the reaction occurs within minutes of exposure to an antigen.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93419,
      question: "Lichen planus lesions are most commonly found on the attached gingiva.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93420,
      question: "Both pemphigus vulgaris and mucous membrane pemphigoid show a positive Nikolsky sign.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93421,
      question: "Sjögren syndrome diagnosis requires all three components — xerostomia, keratoconjunctivitis sicca, and rheumatoid arthritis — to be simultaneously present.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93422,
      question: "Systemic lupus erythematosus affects women eight times more frequently than men, predominantly during childbearing years.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "7. Autoimmune Disease": [
    {
      id: 93423,
      question: "Which of the following autoimmune diseases primarily affects the salivary and lacrimal glands, resulting in dry mouth and dry eyes?",
      options: [
        "Sjögren syndrome",
        "Behçet syndrome",
        "Systemic lupus erythematosus",
        "Pemphigus vulgaris"
      ],
      correctAnswer: 0
    },
    {
      id: 93424,
      question: "The term \"xerostomia\" refers to which of the following conditions?",
      options: [
        "Dry eyes caused by lacrimal gland damage",
        "Dry mouth caused by decreased salivary output",
        "Parotid gland swelling in autoimmune disease",
        "Loss of papillae on the dorsum of the tongue"
      ],
      correctAnswer: 1
    },
    {
      id: 93425,
      question: "In Sjögren syndrome, when the disease occurs together with another autoimmune disorder, it is classified as:",
      options: [
        "Primary Sjögren syndrome",
        "Idiopathic Sjögren syndrome",
        "Tertiary Sjögren syndrome",
        "Secondary Sjögren syndrome"
      ],
      correctAnswer: 3
    },
    {
      id: 93426,
      question: "Parotid gland enlargement occurs in approximately what percentage of patients with Sjögren syndrome?",
      options: [
        "75%",
        "25%",
        "50%",
        "90%"
      ],
      correctAnswer: 2
    },
    {
      id: 93427,
      question: "Which of the following oral findings is associated with Sjögren syndrome?",
      options: [
        "Loss of filiform and fungiform papillae on the dorsum of the tongue",
        "Intraepithelial blister formation and acantholysis",
        "Gingival hyperplasia and increased salivary flow",
        "Hyperemia and papillary hyperplasia of the tongue"
      ],
      correctAnswer: 0
    },
    {
      id: 93428,
      question: "What is the histologic appearance on biopsy of the minor salivary glands in Sjögren syndrome?",
      options: [
        "Aggregates of lymphocytes surrounding the salivary gland ducts",
        "Granulomatous infiltrate with multinucleated giant cells",
        "Epimyoepithelial islands replacing acinar tissue",
        "Intraepithelial blister formation with acantholytic cells"
      ],
      correctAnswer: 0
    },
    {
      id: 93429,
      question: "What are \"epimyoepithelial islands\" as seen on biopsy of major salivary glands in Sjögren syndrome?",
      options: [
        "Lymphocytic aggregates encircling the salivary ducts",
        "Islands of epithelium remaining after lymphocytic replacement of gland tissue",
        "Plasma cell clusters within the acinar lobules",
        "Granulomatous nodules replacing normal glandular parenchyma"
      ],
      correctAnswer: 1
    },
    {
      id: 93430,
      question: "Which of the following is the correct diagnostic requirement for Sjögren syndrome?",
      options: [
        "All three components must be present — xerostomia, keratoconjunctivitis sicca, and rheumatoid arthritis",
        "Only a positive biopsy and positive rheumatoid factor are required for diagnosis",
        "A positive anti-nuclear antibody test plus dry mouth are both required for diagnosis",
        "Two of three components must be present — xerostomia, keratoconjunctivitis sicca, and rheumatoid arthritis"
      ],
      correctAnswer: 3
    },
    {
      id: 93431,
      question: "Which autoantibodies are specifically associated with Sjögren syndrome in addition to rheumatoid factor?",
      options: [
        "Autoantibodies to DNA and anti-nuclear antibodies",
        "Anti-Sjögren syndrome A and anti-Sjögren syndrome B",
        "Anti-smooth muscle antibodies and anti-mitochondrial antibodies",
        "Autoantibodies to human mucosa and anti-DNA antibodies"
      ],
      correctAnswer: 1
    },
    {
      id: 93432,
      question: "Rheumatoid factor is best described as:",
      options: [
        "An antibody to an antibody (specifically, an antibody to IgG present in serum)",
        "A T-cell receptor protein that binds to nuclear DNA",
        "An antibody to salivary gland epithelium",
        "A complement protein that triggers autoimmune tissue destruction"
      ],
      correctAnswer: 0
    },
    {
      id: 93433,
      question: "Which of the following best describes Raynaud phenomenon as it relates to Sjögren syndrome?",
      options: [
        "It affects 90% of patients and involves joint inflammation and swelling",
        "It affects 20% of patients, causing pallor and cyanosis of the fingers and toes due to cold or stress",
        "It occurs in 50% of patients and causes dry eyes and oral ulcers",
        "It affects 10% of patients and causes intraepithelial blistering of the skin"
      ],
      correctAnswer: 1
    },
    {
      id: 93434,
      question: "Which drug is used as a salivary stimulant in the symptomatic management of Sjögren syndrome?",
      options: [
        "Hydroxychloroquine",
        "Chlorambucil",
        "Methotrexate",
        "Pilocarpine"
      ],
      correctAnswer: 3
    },
    {
      id: 93435,
      question: "Systemic lupus erythematosus (SLE) affects women how many times more frequently than men?",
      options: [
        "Three times more frequently",
        "Five times more frequently",
        "Eight times more frequently",
        "Ten times more frequently"
      ],
      correctAnswer: 2
    },
    {
      id: 93436,
      question: "Which demographic group is three times more likely to develop SLE compared to white women?",
      options: [
        "Asian women during reproductive years",
        "Black women, predominantly during childbearing years",
        "Hispanic women over the age of 50",
        "Native American women in the postmenopausal period"
      ],
      correctAnswer: 1
    },
    {
      id: 93437,
      question: "What type of autoantibodies are found in the serum of SLE patients and help confirm the diagnosis?",
      options: [
        "Anti-Sjögren syndrome A and B antibodies",
        "Rheumatoid factor directed at IgG",
        "Autoantibodies to human mucosa only",
        "Anti-nuclear antibodies and autoantibodies to DNA"
      ],
      correctAnswer: 3
    },
    {
      id: 93438,
      question: "The characteristic skin rash of SLE is described as:",
      options: [
        "A \"butterfly\" rash located on the bridge of the nose",
        "A diffuse maculopapular rash spreading across the torso",
        "Vesicular eruptions on the dorsum of the hands and feet",
        "A psoriatic plaque pattern on the extensor surfaces"
      ],
      correctAnswer: 0
    },
    {
      id: 93439,
      question: "Oral lesions in SLE accompany skin lesions in approximately what percentage of patients with discoid lupus erythematosus?",
      options: [
        "75%",
        "10%",
        "50%",
        "25%"
      ],
      correctAnswer: 3
    },
    {
      id: 93440,
      question: "How do oral lesions of SLE differ from lichen planus on clinical examination?",
      options: [
        "SLE lesions are always painless, while lichen planus lesions are consistently painful",
        "SLE lesions appear as bullae only, while lichen planus presents only as erosions",
        "SLE lesions are less symmetric than lichen planus lesions",
        "SLE lesions affect only the tongue, while lichen planus affects only the buccal mucosa"
      ],
      correctAnswer: 2
    },
    {
      id: 93441,
      question: "On histologic examination of SLE, the inflammatory infiltrate is characteristically located:",
      options: [
        "Around blood vessels in the connective tissue",
        "Within the epithelial layer around acantholytic cells",
        "Aggregated around salivary gland ducts",
        "Beneath the basement membrane with eosinophils"
      ],
      correctAnswer: 0
    },
    {
      id: 93442,
      question: "Which drug combination is used for severe cases of SLE?",
      options: [
        "Pilocarpine and fluoride supplementation for xerostomia management",
        "Chlorambucil and topical corticosteroids as the primary regimen",
        "Nonsteroidal antiinflammatory drugs and artificial tears only",
        "Hydroxychloroquine with corticosteroids and immunosuppressive agents"
      ],
      correctAnswer: 3
    },
    {
      id: 93443,
      question: "Pemphigus vulgaris is characterized by intraepithelial blister formation resulting from:",
      options: [
        "Acantholysis, a breakdown of cellular adhesion between epithelial cells",
        "Subepithelial separation due to basement membrane destruction",
        "Lymphocytic replacement of epithelial tissue in the oral cavity",
        "An inflammatory infiltrate of plasma cells and eosinophils"
      ],
      correctAnswer: 0
    },
    {
      id: 93444,
      question: "In what percentage of pemphigus vulgaris cases do the first signs of disease appear in the oral cavity?",
      options: [
        "More than 50% of cases",
        "Approximately 25% of cases",
        "Less than 10% of cases",
        "Exactly 75% of cases"
      ],
      correctAnswer: 0
    },
    {
      id: 93445,
      question: "The Nikolsky sign refers to:",
      options: [
        "A positive rheumatoid factor result combined with oral blistering",
        "The presence of rounded acantholytic cells on cytologic smear",
        "The ability to produce a bulla by rubbing apparently normal skin with a finger",
        "An inflammatory infiltrate visible beneath the epithelium on biopsy"
      ],
      correctAnswer: 2
    },
    {
      id: 93446,
      question: "What are Tzanck cells as seen microscopically in pemphigus vulgaris?",
      options: [
        "Rounded acantholytic epithelial cells resulting from loss of intercellular attachment",
        "Lymphocytes aggregated around salivary gland ducts",
        "Plasma cells and eosinophils found in subepithelial connective tissue",
        "Epimyoepithelial islands within major salivary gland biopsies"
      ],
      correctAnswer: 0
    },
    {
      id: 93447,
      question: "What is the 5-year mortality rate associated with pemphigus vulgaris, and what is it related to?",
      options: [
        "1% to 2%, related to secondary bacterial infections",
        "8% to 10%, related to complications of corticosteroid treatment",
        "20% to 25%, related to systemic organ failure",
        "5% to 6%, related to nutritional deficiencies from severe oral lesions"
      ],
      correctAnswer: 1
    },
    {
      id: 93448,
      question: "Mucous membrane pemphigoid is also known by which two alternative names?",
      options: [
        "Benign mucous membrane pemphigoid and cicatricial pemphigoid",
        "Bullous pemphigoid and desquamative pemphigoid",
        "Discoid pemphigoid and erosive pemphigoid",
        "Chronic pemphigoid and ulcerative pemphigoid"
      ],
      correctAnswer: 0
    },
    {
      id: 93449,
      question: "Which of the following best distinguishes mucous membrane pemphigoid from pemphigus vulgaris?",
      options: [
        "Mucous membrane pemphigoid shows no positive Nikolsky sign in any patient",
        "Mucous membrane pemphigoid only affects skin and not mucous membranes",
        "Mucous membrane pemphigoid is not as severe as pemphigus vulgaris",
        "Mucous membrane pemphigoid has a significantly higher mortality rate"
      ],
      correctAnswer: 2
    },
    {
      id: 93450,
      question: "The gingival lesion pattern seen in mucous membrane pemphigoid is referred to as:",
      options: [
        "Necrotizing ulcerative gingivitis",
        "Hyperplastic gingivitis",
        "Proliferative gingivitis",
        "Desquamative gingivitis"
      ],
      correctAnswer: 3
    },
    {
      id: 93451,
      question: "The histologic appearance of mucous membrane pemphigoid on biopsy shows:",
      options: [
        "Acantholytic cells and Tzanck cells within the epithelium",
        "Epimyoepithelial islands replacing glandular tissue",
        "An inflammatory infiltrate with predominant plasma cells and eosinophils in connective tissue",
        "Granulomatous inflammation with multinucleated giant cells"
      ],
      correctAnswer: 2
    },
    {
      id: 93452,
      question: "Which of the following best describes the prognosis and course of mucous membrane pemphigoid?",
      options: [
        "Acute and rapidly progressive, with a mortality rate over 20%",
        "Chronic with a benign course, though eye lesions can lead to eye damage",
        "Self-limiting and resolves completely within one year without any treatment",
        "Chronic and progressive with high risk of internal organ involvement"
      ],
      correctAnswer: 1
    },
    {
      id: 93453,
      question: "Which of the following is TRUE about bullous pemphigoid?",
      options: [
        "It predominantly affects children under the age of 10",
        "Oral lesions are more common in bullous pemphigoid than in cicatricial pemphigoid",
        "It is treated exclusively with topical corticosteroids, with no systemic component",
        "About 80% of patients with bullous pemphigoid are older than 60 years"
      ],
      correctAnswer: 3
    },
    {
      id: 93454,
      question: "Some investigators believe bullous pemphigoid and mucous membrane pemphigoid are:",
      options: [
        "Completely distinct diseases with unrelated autoimmune mechanisms",
        "Different presentations of the same disease driven by identical antibodies",
        "Variants of a single underlying disease",
        "Unrelated conditions that happen to share only the feature of blistering"
      ],
      correctAnswer: 2
    },
    {
      id: 93455,
      question: "Behçet syndrome primarily involves which three types of lesions?",
      options: [
        "Nasal lesions, esophageal erosions, and cutaneous blistering",
        "Salivary gland enlargement, joint inflammation, and lacrimal gland dysfunction",
        "Gingival lesions, intraepithelial bullae, and dry eyes",
        "Oral ulcers, genital ulcers, and ocular inflammation"
      ],
      correctAnswer: 3
    },
    {
      id: 93456,
      question: "What is the mean age of onset for Behçet syndrome, and what is its sex predilection?",
      options: [
        "Mean onset at 50 years; predominantly affects women",
        "Mean onset at 30 years; no sex predilection",
        "Mean onset at 15 years; predominantly affects men",
        "Mean onset at 65 years; predominantly affects postmenopausal women"
      ],
      correctAnswer: 1
    },
    {
      id: 93457,
      question: "Autoantibodies found in Behçet syndrome are directed against:",
      options: [
        "DNA and nuclear antigens",
        "IgG (rheumatoid factor)",
        "Human mucosa",
        "Salivary gland epithelium"
      ],
      correctAnswer: 2
    },
    {
      id: 93458,
      question: "Which finding following needle puncture specifically suggests a diagnosis of Behçet syndrome?",
      options: [
        "A vesicular lesion filled with clear fluid at the puncture site",
        "A pustular lesion developing at the puncture site",
        "A hematoma with surrounding erythema at the puncture site",
        "A granulomatous nodule forming at the puncture site"
      ],
      correctAnswer: 1
    },
    {
      id: 93459,
      question: "Which drug is used specifically for ocular lesions in Behçet syndrome?",
      options: [
        "Hydroxychloroquine",
        "Pilocarpine",
        "Chlorambucil",
        "Methotrexate"
      ],
      correctAnswer: 2
    },
    {
      id: 93460,
      question: "Behçet syndrome is diagnosed when which of the following criteria is met?",
      options: [
        "Biopsy shows plasma cells and eosinophils in connective tissue",
        "The presence of anti-nuclear antibodies is confirmed alongside oral ulcers",
        "Two of three lesion types — oral, genital, and ocular — are present",
        "A positive rheumatoid factor test combined with xerostomia is confirmed"
      ],
      correctAnswer: 2
    },
    {
      id: 93461,
      question: "Which of the following is a correct dental hygiene management recommendation for patients with Sjögren syndrome?",
      options: [
        "Avoid fluoride applications, as they may irritate dry oral mucosa",
        "Reduce the frequency of recare appointments to minimize patient discomfort",
        "Prescribe high-dose systemic corticosteroids as first-line dental management",
        "Frequent recare appointments, fluoride application, and meticulous oral hygiene"
      ],
      correctAnswer: 3
    },
    {
      id: 93462,
      question: "A patient with Sjögren syndrome is at elevated risk for all of the following EXCEPT:",
      options: [
        "Dental caries",
        "Periodontal disease",
        "Oral candidiasis",
        "Intraepithelial blister formation from acantholysis"
      ],
      correctAnswer: 3
    },
    {
      id: 93463,
      question: "Sjögren syndrome only affects the major salivary glands and does not involve the minor salivary glands.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93464,
      question: "The diagnosis of Sjögren syndrome requires all three components — xerostomia, keratoconjunctivitis sicca, and rheumatoid arthritis — to be present simultaneously.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93465,
      question: "Pemphigus vulgaris is characterized by subepithelial, not intraepithelial, blister formation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93466,
      question: "SLE affects women eight times more frequently than men and is three times more common in black women than in white women.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93467,
      question: "Mucous membrane pemphigoid is more clinically severe than pemphigus vulgaris.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93468,
      question: "Behçet syndrome shows no sex predilection and has a mean age of onset of approximately 30 years.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "8. Infectious Diseases": [
    {
      id: 93469,
      question: "Which type of immunity involves T-cell lymphocytes and is effective against intracellular bacteria, viruses, and fungi?",
      options: [
        "Cell-mediated immunity",
        "Innate immunity",
        "Humoral immunity",
        "Passive immunity"
      ],
      correctAnswer: 0
    },
    {
      id: 93470,
      question: "Which two organisms are responsible for causing impetigo?",
      options: [
        "Mycobacterium tuberculosis and Actinomyces israelii",
        "Treponema pallidum and Borrelia vincentii",
        "Group A streptococci and Mycobacterium tuberculosis",
        "Streptococcus pyogenes and Staphylococcus aureus"
      ],
      correctAnswer: 3
    },
    {
      id: 93471,
      question: "Impetigo most commonly affects which population and requires what condition to establish infection?",
      options: [
        "Adults with chronic illness, requiring intact mucous membranes for entry",
        "Elderly patients, requiring a compromised immune system for infection",
        "Young children, requiring nonintact skin to allow bacterial entry",
        "Teenagers and young adults, requiring breaks in the oral mucosa"
      ],
      correctAnswer: 2
    },
    {
      id: 93472,
      question: "Tonsillitis and pharyngitis may be spread by which of the following routes?",
      options: [
        "Airborne transmission through respiratory droplets only",
        "Blood transfusion from an infected individual",
        "Indirect contact with contaminated surfaces only",
        "Contact with infectious nasal or oral secretions"
      ],
      correctAnswer: 3
    },
    {
      id: 93473,
      question: "Group A β-hemolytic streptococcal infections of the tonsils and pharynx can lead to which two serious systemic complications?",
      options: [
        "Tuberculosis and actinomycosis",
        "Pericoronitis and necrotizing ulcerative gingivitis",
        "Osteomyelitis and bacteremia",
        "Rheumatic fever and scarlet fever"
      ],
      correctAnswer: 3
    },
    {
      id: 93474,
      question: "In scarlet fever, the generalized red skin rash is caused by:",
      options: [
        "Direct infiltration of the skin by streptococcal organisms",
        "A toxin released by the bacteria",
        "A direct hypersensitivity reaction to penicillin",
        "An autoimmune response to streptococcal antigens"
      ],
      correctAnswer: 1
    },
    {
      id: 93475,
      question: "The oral manifestation known as \"strawberry tongue\" in scarlet fever is characterized by:",
      options: [
        "White pseudomembranous plaques covering the dorsum of the tongue",
        "Loss of all papillae, leaving a smooth, depapillated tongue surface",
        "Red, prominent fungiform papillae with the dorsal surface showing white coating or erythema",
        "Ulceration of the tongue with a yellow-gray necrotic base"
      ],
      correctAnswer: 2
    },
    {
      id: 93476,
      question: "Rheumatic fever is a childhood disease that follows which type of streptococcal infection?",
      options: [
        "Group A β-hemolytic streptococcal infection",
        "Group D streptococcal bacteremia",
        "Group B β-hemolytic streptococcal pharyngitis",
        "Alpha-hemolytic streptococcal endocarditis"
      ],
      correctAnswer: 0
    },
    {
      id: 93477,
      question: "Why may a patient with a history of rheumatic fever require premedication before dental hygiene treatment?",
      options: [
        "Rheumatic fever causes xerostomia requiring salivary stimulants before treatment",
        "Rheumatic fever causes immune suppression requiring antibiotic prophylaxis",
        "Rheumatic fever causes bone fragility requiring careful instrumentation",
        "Heart valve damage from rheumatic fever may increase the risk of bacterial endocarditis"
      ],
      correctAnswer: 3
    },
    {
      id: 93478,
      question: "Tuberculosis is most commonly caused by which organism?",
      options: [
        "Actinomyces israelii",
        "Mycobacterium tuberculosis",
        "Treponema pallidum",
        "Borrelia vincentii"
      ],
      correctAnswer: 1
    },
    {
      id: 93479,
      question: "Which of the following best describes the oral ulcerations seen in tuberculosis?",
      options: [
        "Multiple, painless, grayish-white plaques that undergo spontaneous remission",
        "Shallow, fragile vesicles that rupture to form large bullae",
        "Cratered interdental papillae with a pseudomembranous covering",
        "Painful, nonhealing, slowly enlarging ulcers"
      ],
      correctAnswer: 3
    },
    {
      id: 93480,
      question: "What does biopsy of an oral tuberculosis lesion typically reveal?",
      options: [
        "Chronic granulomatous lesions with necrosis surrounded by macrophages, giant cells, and lymphocytes",
        "Acantholytic cells and Tzanck cells within the epithelium",
        "Plasma cells and eosinophils infiltrating the subepithelial connective tissue",
        "Intraepithelial blisters with lymphocytic infiltration of the lamina propria"
      ],
      correctAnswer: 0
    },
    {
      id: 93481,
      question: "Scrofula or tuberculous lymphadenitis most commonly affects which lymph node groups?",
      options: [
        "Submandibular and cervical lymph nodes",
        "Axillary and inguinal lymph nodes",
        "Mesenteric and paratracheal lymph nodes",
        "Preauricular and occipital lymph nodes"
      ],
      correctAnswer: 0
    },
    {
      id: 93482,
      question: "Which two medications are part of the combination treatment regimen for tuberculosis?",
      options: [
        "Penicillin and rifampin",
        "Hydroxychloroquine and isoniazid (INH)",
        "Chlorambucil and metronidazole",
        "Isoniazid (INH) and rifampin"
      ],
      correctAnswer: 3
    },
    {
      id: 93483,
      question: "Why is tuberculosis considered an occupationally transmitted disease in dentistry?",
      options: [
        "Close patient contact during dental procedures can expose dental workers to infectious droplets",
        "Dental instruments can harbor the bacteria if not properly sterilized",
        "Dental materials contain compounds that promote mycobacterial growth",
        "Dental patients frequently present with active open oral tuberculosis lesions"
      ],
      correctAnswer: 0
    },
    {
      id: 93484,
      question: "Actinomycosis is caused by which organism?",
      options: [
        "Mycobacterium tuberculosis",
        "Actinomyces israelii",
        "Treponema pallidum",
        "Borrelia vincentii"
      ],
      correctAnswer: 1
    },
    {
      id: 93485,
      question: "What is the characteristic clinical presentation of actinomycosis?",
      options: [
        "Painful, nonhealing oral ulcers that slowly enlarge over weeks",
        "Multiple grayish-white painless plaques on oral mucous membranes",
        "Draining abscesses in the affected region",
        "Erythematous gingivitis with cratering of the interdental papillae"
      ],
      correctAnswer: 2
    },
    {
      id: 93486,
      question: "What is the appropriate treatment for actinomycosis?",
      options: [
        "Long-term, high doses of antibiotics",
        "Short-term topical antifungal agents",
        "Surgical debridement alone without antibiotic support",
        "Systemic corticosteroids and immunosuppressive agents"
      ],
      correctAnswer: 0
    },
    {
      id: 93487,
      question: "Syphilis is caused by which type of organism?",
      options: [
        "A filamentous bacterium called Actinomyces israelii",
        "A gram-positive coccus called Streptococcus pyogenes",
        "A spirochete called Treponema pallidum",
        "An intracellular bacterium called Mycobacterium tuberculosis"
      ],
      correctAnswer: 2
    },
    {
      id: 93488,
      question: "Which of the following correctly describes how Treponema pallidum organisms behave outside the body?",
      options: [
        "They can survive on dry surfaces for up to 72 hours",
        "They can persist in dried secretions for up to one week",
        "They remain viable in saliva for several hours at room temperature",
        "They die when exposed to air and changes in temperature"
      ],
      correctAnswer: 3
    },
    {
      id: 93489,
      question: "What is the oral lesion associated with the PRIMARY stage of syphilis?",
      options: [
        "Gumma",
        "Mucous patch",
        "Chancre",
        "Pseudomembranous ulcer"
      ],
      correctAnswer: 2
    },
    {
      id: 93490,
      question: "Which oral lesion is associated with the SECONDARY stage of syphilis?",
      options: [
        "Chancre",
        "Gumma",
        "Painless ulcer with indurated margins",
        "Mucous patch"
      ],
      correctAnswer: 3
    },
    {
      id: 93491,
      question: "Which of the following best describes mucous patches in secondary syphilis?",
      options: [
        "Multiple, painless, grayish-white plaques covering ulcerated mucosa that are highly infectious",
        "A solitary, firm, painless nodule that may perforate the palatal bone",
        "Painful, slowly enlarging ulcers that do not heal spontaneously",
        "Shallow vesicles that rupture to form crusted lesions on the lips"
      ],
      correctAnswer: 0
    },
    {
      id: 93492,
      question: "The TERTIARY stage of syphilis primarily involves which two body systems?",
      options: [
        "Respiratory system and musculoskeletal system",
        "Cardiovascular system and nervous system",
        "Endocrine system and lymphatic system",
        "Gastrointestinal system and integumentary system"
      ],
      correctAnswer: 1
    },
    {
      id: 93493,
      question: "A gumma in tertiary syphilis is best described as:",
      options: [
        "A painful vesicular lesion that ruptures to form a superficial ulcer",
        "A white plaque covering ulcerated mucosa that is highly contagious",
        "A painless chancre with well-defined borders and induration",
        "A firm, noninfectious, destructive lesion that can perforate the palatal bone"
      ],
      correctAnswer: 3
    },
    {
      id: 93494,
      question: "In congenital syphilis, how does Treponema pallidum reach the fetus?",
      options: [
        "By crossing the placenta and entering the fetal circulation",
        "Through contaminated amniotic fluid during the birth process",
        "Via inhalation of infected particles during delivery",
        "Through breast milk from an infected mother after birth"
      ],
      correctAnswer: 0
    },
    {
      id: 93495,
      question: "Which blood tests are used in the diagnosis of syphilis?",
      options: [
        "Anti-nuclear antibody test and rheumatoid factor assay",
        "VDRL test and fluorescent treponemal antibody absorption test (FTA-ABS)",
        "Complete blood count and erythrocyte sedimentation rate",
        "Skin test and tuberculin purified protein derivative test"
      ],
      correctAnswer: 1
    },
    {
      id: 93496,
      question: "What is the treatment of choice for syphilis?",
      options: [
        "Isoniazid (INH) and rifampin combination therapy",
        "Long-term, high doses of tetracycline",
        "Penicillin",
        "Systemic corticosteroids with antifungal coverage"
      ],
      correctAnswer: 2
    },
    {
      id: 93497,
      question: "Necrotizing ulcerative gingivitis (NUG) is most likely caused by which combination of organisms?",
      options: [
        "Streptococcus pyogenes and Staphylococcus aureus",
        "A fusiform bacillus and a spirochete (Borrelia vincentii)",
        "Mycobacterium tuberculosis and Actinomyces israelii",
        "Treponema pallidum and Mycobacterium tuberculosis"
      ],
      correctAnswer: 1
    },
    {
      id: 93498,
      question: "Which of the following is the hallmark clinical sign used to diagnose necrotizing ulcerative gingivitis?",
      options: [
        "Multiple grayish-white plaques on the gingival margin",
        "Desquamative gingivitis with positive Nikolsky sign",
        "Painful vesicular eruptions along the gingival sulcus",
        "Cratering of the interdental papillae with a pseudomembrane over necrotic tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 93499,
      question: "What is the treatment approach for necrotizing ulcerative gingivitis?",
      options: [
        "High-dose systemic corticosteroids and debridement",
        "Topical antifungal agents and daily chlorhexidine rinses",
        "Gentle debridement and antibiotics only when fever is present",
        "Surgical removal of affected interdental papillae and antifungal therapy"
      ],
      correctAnswer: 2
    },
    {
      id: 93500,
      question: "Pericoronitis is defined as:",
      options: [
        "Acute inflammation of the bone and bone marrow caused by a periapical abscess",
        "Long-standing inflammation of bone with diffuse radiolucency on radiograph",
        "Inflammation around the crown of a partially erupted, impacted tooth",
        "Painful erythematous gingivitis with necrosis of interdental papillae"
      ],
      correctAnswer: 2
    },
    {
      id: 93501,
      question: "Pericoronitis most commonly affects which tooth?",
      options: [
        "Upper first molar",
        "Lower third molar",
        "Upper canine",
        "Lower second premolar"
      ],
      correctAnswer: 1
    },
    {
      id: 93502,
      question: "What is the soft tissue flap overlying a partially erupted tooth in pericoronitis called?",
      options: [
        "Operculum",
        "Pseudomembrane",
        "Interdental papilla",
        "Tuberosity"
      ],
      correctAnswer: 0
    },
    {
      id: 93503,
      question: "What is the definitive long-term treatment solution for recurrent pericoronitis?",
      options: [
        "Prolonged systemic antibiotic therapy",
        "Hyperbaric oxygen treatment",
        "Removal of the offending tooth",
        "Repeated debridement and irrigation only"
      ],
      correctAnswer: 2
    },
    {
      id: 93504,
      question: "Acute osteomyelitis is most commonly caused by which of the following?",
      options: [
        "Pericoronitis around an impacted lower third molar",
        "A periapical abscess spreading to adjacent bone",
        "Bacteremia following dental extraction without prophylaxis",
        "A fracture of the mandible without subsequent infection"
      ],
      correctAnswer: 1
    },
    {
      id: 93505,
      question: "Which of the following histologic findings is characteristic of acute osteomyelitis?",
      options: [
        "Chronic granulomatous inflammation with multinucleated giant cells",
        "Nonviable bone, necrotic debris, bacterial colonies in marrow spaces, and acute inflammation",
        "Plasma cells and eosinophils infiltrating the periosteum",
        "Lymphocytic aggregates surrounding bone trabeculae"
      ],
      correctAnswer: 1
    },
    {
      id: 93506,
      question: "What is the treatment for acute osteomyelitis?",
      options: [
        "Topical antibiotics and irrigation only",
        "Drainage of purulent exudate and systemic antibiotics",
        "Systemic corticosteroids and hyperbaric treatment",
        "Debridement and long-term antifungal therapy"
      ],
      correctAnswer: 1
    },
    {
      id: 93507,
      question: "In chronic osteomyelitis, what does the initial radiographic appearance show, and what does it eventually become?",
      options: [
        "Initial radiopacity that gradually becomes radiolucent as bone resorption progresses",
        "Initially shows a diffuse and irregular radiolucency that can eventually become opaque",
        "Initially shows a well-defined radiolucency that remains stable over time",
        "Initially shows multiple radiolucent cysts that gradually merge into one lesion"
      ],
      correctAnswer: 1
    },
    {
      id: 93508,
      question: "What is the specific term for chronic osteomyelitis when it develops radiographic radiopacity?",
      options: [
        "Chronic suppurative osteomyelitis",
        "Diffuse sclerosing periodontitis",
        "Chronic sclerosing osteomyelitis",
        "Focal cemento-osseous dysplasia"
      ],
      correctAnswer: 2
    },
    {
      id: 93509,
      question: "Which of the following is a treatment option for chronic osteomyelitis that may be required in addition to debridement and systemic antibiotics?",
      options: [
        "Hyperbaric oxygen treatment",
        "Long-term topical antifungal therapy",
        "Systemic corticosteroids and immunosuppressive agents",
        "Radiation therapy to destroy remaining bacterial colonies"
      ],
      correctAnswer: 0
    },
    {
      id: 93510,
      question: "Humoral immunity involving antibodies is an effective defense against all types of microorganisms, including intracellular bacteria, viruses, and fungi.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93511,
      question: "Impetigo is a bacterial skin infection that can infect intact, unbroken skin without requiring any disruption to the skin surface.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93512,
      question: "Tuberculosis is considered an occupationally transmitted disease in dentistry, and the use of a special mask is recommended to prevent its transmission.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93513,
      question: "The mucous patches of secondary syphilis are the most infectious of all syphilitic oral lesions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93514,
      question: "In necrotizing ulcerative gingivitis (NUG), antibiotics are always required as part of treatment regardless of whether fever is present.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93515,
      question: "Congenital syphilis caused by Treponema pallidum crossing the placenta can cause serious, irreversible facial and dental abnormalities in the child.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "9. Infectious Diseases": [
    {
      id: 93516,
      question: "Which organism is responsible for causing candidiasis?",
      options: [
        "Aspergillus fumigatus",
        "Histoplasma capsulatum",
        "Cryptococcus neoformans",
        "Candida albicans"
      ],
      correctAnswer: 3
    },
    {
      id: 93517,
      question: "Which of the following conditions is NOT listed as a predisposing factor for candidiasis?",
      options: [
        "Hypertension, hyperthyroidism, and vitamin D excess",
        "Antibiotics, cancer chemotherapy, and corticosteroid therapy",
        "Dentures, diabetes mellitus, and HIV infection",
        "Xerostomia, hypoparathyroidism, and multiple myeloma"
      ],
      correctAnswer: 0
    },
    {
      id: 93518,
      question: "How is Candida identified from an oral lesion?",
      options: [
        "Blood culture sent to a microbiology laboratory",
        "Urine sample tested for fungal antigens",
        "Scraping of the lesion examined microscopically",
        "Chest X-ray used to detect pulmonary spread"
      ],
      correctAnswer: 2
    },
    {
      id: 93519,
      question: "What is the clinical appearance of pseudomembranous candidiasis?",
      options: [
        "Fissuring and cracking at the corners of the mouth",
        "White curdlike material on the mucosal surface with erythema underneath",
        "Red, flat erosion on the dorsal tongue midline only",
        "White lesion that does not wipe off the mucosa"
      ],
      correctAnswer: 1
    },
    {
      id: 93520,
      question: "A patient with pseudomembranous candidiasis may experience which symptoms?",
      options: [
        "Numbness, blurred vision, and jaw stiffness",
        "Bleeding gums, tooth mobility, and bone loss",
        "Facial swelling, trismus, and cervical lymphadenopathy",
        "Burning sensation and/or a metallic taste in the mouth"
      ],
      correctAnswer: 3
    },
    {
      id: 93521,
      question: "Which type of candidiasis is considered the most common?",
      options: [
        "Denture stomatitis (chronic atrophic candidiasis)",
        "Erythematous candidiasis",
        "Chronic hyperplastic candidiasis",
        "Pseudomembranous candidiasis"
      ],
      correctAnswer: 0
    },
    {
      id: 93522,
      question: "Denture stomatitis is most commonly found on which oral structures?",
      options: [
        "Tongue and floor of the mouth",
        "Buccal mucosa and labial frenum",
        "Palate and maxillary alveolar ridge",
        "Mandibular alveolar ridge and retromolar pad"
      ],
      correctAnswer: 2
    },
    {
      id: 93523,
      question: "Which statement best describes denture stomatitis?",
      options: [
        "A white lesion under a full or partial denture that causes severe pain",
        "Erythematous mucosa limited to denture-covered areas, usually asymptomatic",
        "Painful ulcers beneath the denture that bleed on contact",
        "Diffuse white coating with underlying erythema throughout the mouth"
      ],
      correctAnswer: 1
    },
    {
      id: 93524,
      question: "Chronic hyperplastic candidiasis (candidal leukoplakia) is best described as which of the following?",
      options: [
        "A white lesion that cannot be wiped off but responds to antifungal medication",
        "A red, painful lesion that responds to antifungal therapy within days",
        "A painful ulcer on the dorsal tongue that does not respond to treatment",
        "A white lesion that wipes off easily and leaves a bleeding surface beneath"
      ],
      correctAnswer: 0
    },
    {
      id: 93525,
      question: "If a lesion diagnosed as chronic hyperplastic candidiasis does NOT respond to antifungal medication, what is the next recommended step?",
      options: [
        "Monitor the lesion for six months before taking further action",
        "Prescribe a second course of a stronger antifungal agent",
        "Refer the patient for radiographic imaging of the head and neck",
        "Perform a biopsy of the lesion"
      ],
      correctAnswer: 3
    },
    {
      id: 93526,
      question: "Angular cheilitis is characterized by which clinical finding?",
      options: [
        "Raised white plaques on the hard palate",
        "Swelling and erythema of the major salivary glands",
        "Erythema or fissuring at the labial commissures",
        "Vesicles and ulcers along the soft palate and pharynx"
      ],
      correctAnswer: 2
    },
    {
      id: 93527,
      question: "Angular cheilitis is most commonly caused by which organism, though other factors may contribute?",
      options: [
        "Herpes simplex virus type 1",
        "Staphylococcus aureus",
        "Candida species",
        "Streptococcus mutans"
      ],
      correctAnswer: 2
    },
    {
      id: 93528,
      question: "Which of the following is an additional non-infectious contributing factor for angular cheilitis?",
      options: [
        "Immunosuppression from organ transplantation",
        "Prolonged antibiotic use for systemic infection",
        "Uncontrolled diabetes mellitus causing immunosuppression",
        "Nutritional deficiency affecting tissue integrity"
      ],
      correctAnswer: 3
    },
    {
      id: 93529,
      question: "Chronic mucocutaneous candidiasis typically presents with involvement of which body areas?",
      options: [
        "Lungs, heart, and liver with superficial skin changes",
        "Joints, bones, and lymph nodes with mucosal ulcers",
        "Oral mucosa, genital mucosa, and skin lesions simultaneously",
        "Eyes, ears, and nasal mucosa with systemic fungemia"
      ],
      correctAnswer: 2
    },
    {
      id: 93530,
      question: "Median rhomboid glossitis most commonly appears in which location?",
      options: [
        "Lateral border of the tongue near the molars",
        "Tip of the tongue on the ventral surface",
        "Floor of the mouth adjacent to Wharton's duct",
        "Midline of the posterior dorsal tongue"
      ],
      correctAnswer: 3
    },
    {
      id: 93531,
      question: "How is median rhomboid glossitis diagnosed?",
      options: [
        "A mucosal smear sent to the laboratory for staining and examination",
        "CT scan of the head and neck to rule out malignancy",
        "Blood test showing elevated Candida antibody titers",
        "Incisional biopsy always required before any treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 93532,
      question: "A patient has persistent and recurrent candidiasis. What may this indicate?",
      options: [
        "A minor salivary gland dysfunction requiring surgical correction",
        "A sign of a severe underlying medical problem",
        "Normal variation in oral flora not requiring further workup",
        "Inadequate oral hygiene that can be resolved with better brushing"
      ],
      correctAnswer: 1
    },
    {
      id: 93533,
      question: "Deep fungal infections that cause oral lesions primarily involve which organ system first?",
      options: [
        "The skin and peripheral lymph nodes",
        "The gastrointestinal tract and oral cavity together",
        "The central nervous system and meninges",
        "The lungs, with oral lesions appearing after pulmonary involvement"
      ],
      correctAnswer: 3
    },
    {
      id: 93534,
      question: "Which fungi are associated with deep fungal infections that can produce oral lesions?",
      options: [
        "Candida albicans, Aspergillus, Mucor, and Rhizopus",
        "Trichophyton, Epidermophyton, Microsporum, and Fusarium",
        "Histoplasma, Coccidioides, Blastomyces, and Cryptococcus",
        "Alternaria, Penicillium, Sporothrix, and Paracoccidioides"
      ],
      correctAnswer: 2
    },
    {
      id: 93535,
      question: "How do oral lesions from deep fungal infections typically appear clinically?",
      options: [
        "White, curdlike plaques that wipe off easily",
        "Chronic, nonhealing ulcers that can resemble squamous cell carcinoma",
        "Multiple vesicles that rupture and form shallow ulcers within days",
        "Smooth, raised, pink nodules that are painless and well-demarcated"
      ],
      correctAnswer: 1
    },
    {
      id: 93536,
      question: "How is a definitive diagnosis of a deep fungal infection made?",
      options: [
        "Biopsy and microscopic examination of the affected tissue",
        "Serological blood testing with ELISA for fungal antigen detection",
        "Culture of saliva on Sabouraud dextrose agar for fungal growth",
        "Clinical examination and response to empirical antifungal therapy"
      ],
      correctAnswer: 0
    },
    {
      id: 93537,
      question: "Which medications are used to treat deep fungal infections?",
      options: [
        "Acyclovir, valacyclovir, or famciclovir administered orally",
        "Nystatin rinse, clotrimazole troches, or topical fluconazole",
        "Amphotericin B, ketoconazole, or itraconazole systemically",
        "Penicillin, amoxicillin, or metronidazole for secondary infection"
      ],
      correctAnswer: 2
    },
    {
      id: 93538,
      question: "What is a notable concern regarding deep fungal infections after treatment?",
      options: [
        "They permanently destroy mucosal tissue with no recovery",
        "Latent infections may remain and reactivate if the immune system is compromised",
        "They frequently spread to bones and joints despite treatment",
        "Treated infections always confer lifelong immunity and do not recur"
      ],
      correctAnswer: 1
    },
    {
      id: 93539,
      question: "Mucormycosis most commonly presents in the oral cavity as which of the following?",
      options: [
        "White, removable plaques on the buccal mucosa bilaterally",
        "A proliferating or destructive mass in the maxilla",
        "Painless swelling of the submandibular salivary gland",
        "Multiple small vesicles on the soft palate that rupture quickly"
      ],
      correctAnswer: 1
    },
    {
      id: 93540,
      question: "Which patient populations are most susceptible to mucormycosis?",
      options: [
        "Patients with uncontrolled diabetes and otherwise debilitated individuals",
        "Children with primary herpetic gingivostomatitis under age five",
        "Healthy young adults with recent viral upper respiratory infections",
        "Elderly patients with nutritional deficiencies and poor oral hygiene"
      ],
      correctAnswer: 0
    },
    {
      id: 93541,
      question: "Where is the mucormycosis organism normally found in nature?",
      options: [
        "Soil, where it is commonly found and usually nonpathogenic",
        "The oral cavity as part of normal commensal microflora",
        "Stagnant freshwater sources and tropical environments",
        "Bird droppings in urban and agricultural environments"
      ],
      correctAnswer: 0
    },
    {
      id: 93542,
      question: "How many types of human papillomavirus (HPV) have been identified?",
      options: [
        "Fewer than 20 distinct types with limited clinical significance",
        "More than 100 types with varying tissue tropism",
        "Exactly 76 types, all linked to oral lesions",
        "Approximately 50 types affecting only mucosal surfaces"
      ],
      correctAnswer: 1
    },
    {
      id: 93543,
      question: "Verruca vulgaris in the oral cavity is most commonly transmitted by which route?",
      options: [
        "Respiratory droplets from an infected individual during conversation",
        "Contaminated food or water ingested during meals",
        "Direct contact with saliva from an infected person during kissing",
        "Skin to oral mucosa, often via finger sucking or fingernail biting"
      ],
      correctAnswer: 3
    },
    {
      id: 93544,
      question: "What is the recommended treatment for verruca vulgaris in the oral cavity?",
      options: [
        "Conservative surgical excision, though recurrence is possible",
        "Topical antifungal cream applied twice daily for four weeks",
        "Systemic antiviral therapy for a minimum of two weeks",
        "Laser ablation as the only effective treatment option"
      ],
      correctAnswer: 0
    },
    {
      id: 93545,
      question: "Condyloma acuminatum is generally transmitted by which primary route?",
      options: [
        "Fecal-oral contamination in children under five years of age",
        "Sexual contact, oral-genital contact, or self-inoculation",
        "Contaminated dental instruments during routine oral examinations",
        "Respiratory aerosols from coughing or sneezing in close contact"
      ],
      correctAnswer: 1
    },
    {
      id: 93546,
      question: "How does condyloma acuminatum appear clinically in the oral cavity?",
      options: [
        "Flat, white, non-wipeable plaques on keratinized mucosa",
        "Papillary, bulbous pink masses that may occur anywhere in the oral mucosa",
        "Multiple vesicles that progress rapidly to painful ulcers",
        "Smooth, dark-red nodules on the gingiva near the cervical margins"
      ],
      correctAnswer: 1
    },
    {
      id: 93547,
      question: "Focal epithelial hyperplasia (Heck Disease) is characterized by which clinical presentation?",
      options: [
        "Single white plaque on the hard palate not responding to antifungals",
        "Vesicles limited to the soft palate and posterior pharyngeal wall",
        "Multiple whitish to pale pink nodules distributed throughout the oral mucosa",
        "Red, bleeding ulcers on the attached gingiva with extensive bone loss"
      ],
      correctAnswer: 2
    },
    {
      id: 93548,
      question: "Which statement is true regarding focal epithelial hyperplasia (Heck Disease)?",
      options: [
        "It requires aggressive surgical excision to prevent malignant transformation",
        "It affects mainly immunocompromised adults requiring systemic antiviral therapy",
        "It is a premalignant condition requiring biopsy and long-term surveillance",
        "Lesions are generally asymptomatic, require no treatment, and resolve spontaneously"
      ],
      correctAnswer: 3
    },
    {
      id: 93549,
      question: "Oral infections caused by herpes simplex virus are most commonly due to which type?",
      options: [
        "Type 3, also known as varicella-zoster virus",
        "Type 2, typically associated with genital lesions",
        "Type 1, which primarily causes oral infections",
        "Type 4, also known as Epstein-Barr virus"
      ],
      correctAnswer: 2
    },
    {
      id: 93550,
      question: "Primary herpetic gingivostomatitis most commonly affects which age group?",
      options: [
        "Children between 6 months and 6 years of age",
        "Adults between 25 and 45 years of age",
        "Elderly adults over the age of 65 with compromised immunity",
        "Adolescents between 13 and 17 years of age"
      ],
      correctAnswer: 0
    },
    {
      id: 93551,
      question: "Which systemic symptoms may accompany primary herpetic gingivostomatitis?",
      options: [
        "Chest pain, shortness of breath, and generalized skin rash",
        "Fever, malaise, and cervical lymphadenopathy",
        "Abdominal pain, nausea, and jaundice with liver involvement",
        "Joint pain, muscle weakness, and loss of sensation in limbs"
      ],
      correctAnswer: 1
    },
    {
      id: 93552,
      question: "Where does recurrent herpes simplex infection most frequently occur intraorally?",
      options: [
        "On the soft palate and moveable mucosa of the floor of the mouth",
        "On keratinized mucosa that is firmly attached to bone",
        "On the lateral tongue and buccal mucosa near the occlusal plane",
        "On the gingival margin adjacent to erupting third molar teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 93553,
      question: "During which stage of herpes simplex infection is the viral load at its highest?",
      options: [
        "The prodromal stage with tingling and burning sensations",
        "The vesicle stage before rupture and ulcer formation",
        "The latent stage when the virus is dormant in neural tissue",
        "The crusting and healing stage following ulcer resolution"
      ],
      correctAnswer: 1
    },
    {
      id: 93554,
      question: "Where does the herpes simplex virus persist in its latent state?",
      options: [
        "In the nerve tissue of the trigeminal ganglion",
        "In the epithelial cells of the oral mucosa between recurrences",
        "In the bone marrow of the mandible and maxilla",
        "In the submandibular lymph nodes and tonsillar crypts"
      ],
      correctAnswer: 0
    },
    {
      id: 93555,
      question: "Which of the following is NOT listed as a trigger for recurrent herpes simplex infection?",
      options: [
        "Stress and sunlight exposure",
        "Menstruation and fatigue",
        "High-protein diet and dehydration",
        "Fever and general physical illness"
      ],
      correctAnswer: 2
    },
    {
      id: 93556,
      question: "Herpetic whitlow is best described as which of the following?",
      options: [
        "A deep fungal infection that creates ulcerations on the dorsal tongue",
        "An asymptomatic herpes lesion of the nail bed without vesicle formation",
        "A bacterial superinfection of pre-existing herpetic lesions on the hand",
        "A painful herpes simplex infection of the fingers from primary or secondary infection"
      ],
      correctAnswer: 3
    },
    {
      id: 93557,
      question: "How is recurrent herpes simplex infection primarily diagnosed?",
      options: [
        "Polymerase chain reaction testing on oral mucosal cells",
        "Laboratory culture of vesicle fluid sent within 24 hours of onset",
        "Based on clinical appearance and patient history",
        "Serological testing for herpes simplex virus antibody titers"
      ],
      correctAnswer: 2
    },
    {
      id: 93558,
      question: "Varicella-zoster virus is responsible for causing which two diseases?",
      options: [
        "Measles (rubeola) and rubella (German measles)",
        "Hand-foot-and-mouth disease and herpangina",
        "Chickenpox (varicella) and shingles (herpes zoster)",
        "Infectious mononucleosis and hairy leukoplakia"
      ],
      correctAnswer: 2
    },
    {
      id: 93559,
      question: "How is varicella-zoster virus transmitted from person to person?",
      options: [
        "Only through direct skin-to-skin contact with active vesicles",
        "Via blood transfusion or organ transplantation from infected donors",
        "Exclusively through contaminated food and water sources",
        "Through respiratory aerosols and contact with secretions from skin lesions"
      ],
      correctAnswer: 3
    },
    {
      id: 93560,
      question: "Herpes zoster (shingles) is best described as which of the following?",
      options: [
        "A primary varicella infection in immunocompromised adults",
        "A new infection acquired through contact with an active chickenpox patient",
        "A reactivation of latent varicella-zoster virus causing unilateral vesicular eruption along a nerve",
        "A fungal co-infection triggered by prior chickenpox exposure"
      ],
      correctAnswer: 2
    },
    {
      id: 93561,
      question: "When herpes zoster affects the face, which nerve may be involved?",
      options: [
        "Any branch of the trigeminal nerve",
        "The facial nerve (CN VII) and vagus nerve only",
        "The oculomotor nerve and abducens nerve exclusively",
        "The glossopharyngeal nerve and hypoglossal nerve"
      ],
      correctAnswer: 0
    },
    {
      id: 93562,
      question: "What is the typical treatment for varicella (chickenpox) in otherwise healthy patients?",
      options: [
        "Prophylactic antibiotics to prevent secondary bacterial skin infections",
        "Immediate intravenous acyclovir regardless of immune status",
        "Systemic antifungal medications given for a minimum of four weeks",
        "Supportive care, with antiviral drugs reserved for immunocompromised patients"
      ],
      correctAnswer: 3
    },
    {
      id: 93563,
      question: "Which of the following diseases is associated with Epstein-Barr virus (EBV)?",
      options: [
        "Herpangina, hand-foot-and-mouth disease, and mucormycosis",
        "Median rhomboid glossitis, angular cheilitis, and denture stomatitis",
        "Candidiasis, verruca vulgaris, and condyloma acuminatum",
        "Infectious mononucleosis, hairy leukoplakia, Burkitt lymphoma, and nasopharyngeal carcinoma"
      ],
      correctAnswer: 3
    },
    {
      id: 93564,
      question: "Which clinical finding may appear in the oral cavity of a patient with infectious mononucleosis?",
      options: [
        "White curdlike plaques on the tongue responding to antifungal therapy",
        "Multiple vesicles on the soft palate resolving without treatment",
        "Median rhomboid-shaped erythematous lesion on the posterior dorsal tongue",
        "Petechiae on the palate along with fever and generalized lymphadenopathy"
      ],
      correctAnswer: 3
    },
    {
      id: 93565,
      question: "In what population does infectious mononucleosis most commonly occur in the United States?",
      options: [
        "Children under five years of age attending daycare facilities",
        "Adolescents and young adults, often transmitted by kissing",
        "Elderly adults over age 70 in long-term care settings",
        "Middle-aged adults with occupational respiratory exposure"
      ],
      correctAnswer: 1
    },
    {
      id: 93566,
      question: "Hairy leukoplakia associated with Epstein-Barr virus appears most commonly in which location?",
      options: [
        "The floor of the mouth adjacent to the salivary gland ducts",
        "The dorsal surface of the tongue near the circumvallate papillae",
        "The lateral border of the tongue",
        "The hard palate along the midpalatine raphe"
      ],
      correctAnswer: 2
    },
    {
      id: 93567,
      question: "Which patient group is most commonly affected by hairy leukoplakia?",
      options: [
        "Diabetic patients on long-term metformin therapy",
        "Patients infected with HIV",
        "Elderly patients with xerostomia from salivary gland dysfunction",
        "Patients with untreated chronic periodontitis and poor oral hygiene"
      ],
      correctAnswer: 1
    },
    {
      id: 93568,
      question: "Coxsackievirus infections can be transmitted by which routes?",
      options: [
        "Only through blood-to-blood contact and sexual transmission",
        "Fecal-oral contamination, saliva, and respiratory droplets",
        "Contaminated water and food sources only",
        "Airborne transmission exclusively during sneezing"
      ],
      correctAnswer: 1
    },
    {
      id: 93569,
      question: "Which of the following is a distinctive oral lesion caused by coxsackievirus infection?",
      options: [
        "Hairy leukoplakia on the lateral tongue border",
        "Median rhomboid glossitis on the dorsal tongue",
        "Angular cheilitis with fissuring at the commissures",
        "Herpangina with vesicles on the soft palate"
      ],
      correctAnswer: 3
    },
    {
      id: 93570,
      question: "Herpangina is characterized by which set of clinical features?",
      options: [
        "Fever, malaise, sore throat, dysphagia, vesicles on the soft palate, and erythematous pharyngitis",
        "Vesicles on the hard palate, painless lymphadenopathy, and widespread skin rash",
        "Papillary growths on the tongue, gingival hyperplasia, and cervical swelling",
        "Bilateral parotid swelling, trismus, and difficulty opening the mouth"
      ],
      correctAnswer: 0
    },
    {
      id: 93571,
      question: "How long does herpangina typically take to resolve without treatment?",
      options: [
        "Less than one week without any specific treatment",
        "Two to four weeks with adequate rest and fluid intake",
        "Up to three months if recurrent episodes occur",
        "Approximately 10 to 14 days with antiviral medication"
      ],
      correctAnswer: 0
    },
    {
      id: 93572,
      question: "Hand-foot-and-mouth disease typically affects which population and in what pattern?",
      options: [
        "Adults over 40 years of age with weakened immune systems",
        "Newborns in hospital nurseries with underdeveloped immunity",
        "Pregnant women during the third trimester as an epidemic",
        "Children under 5 years old, usually occurring in epidemic form"
      ],
      correctAnswer: 3
    },
    {
      id: 93573,
      question: "What is the typical time frame for resolution of hand-foot-and-mouth disease?",
      options: [
        "Resolves within 24 to 48 hours with antiviral medication",
        "Resolves within 2 weeks",
        "May persist for months without appropriate antifungal therapy",
        "Takes 4 to 6 weeks to fully heal without leaving scarring"
      ],
      correctAnswer: 1
    },
    {
      id: 93574,
      question: "Acute lymphonodular pharyngitis caused by coxsackievirus is characterized by which clinical finding?",
      options: [
        "Painful vesicles on the lateral tongue and floor of the mouth",
        "White plaques on the dorsal tongue that wipe off with a tongue blade",
        "Yellowish or dark pink nodules from hyperplastic lymphoid tissue on the soft palate or tonsillar pillars",
        "Chronic ulcerations on the posterior pharynx lasting more than four weeks"
      ],
      correctAnswer: 2
    },
    {
      id: 93575,
      question: "Measles is caused by which type of virus?",
      options: [
        "A paramyxovirus that is highly contagious and causes systemic symptoms and skin rash",
        "A herpesvirus that reactivates from a latent state in nerve tissue",
        "A papillomavirus that causes both skin and mucosal proliferative lesions",
        "A coxsackievirus transmitted via the fecal-oral route"
      ],
      correctAnswer: 0
    },
    {
      id: 93576,
      question: "Which oral manifestation is associated with measles?",
      options: [
        "White curdlike plaques on the tongue that respond to nystatin",
        "Unilateral vesicles on keratinized mucosa limited to one quadrant",
        "Multiple papillary growths on the buccal mucosa and labial frenum",
        "Small erythematous macules called Koplik spots in the oral cavity"
      ],
      correctAnswer: 3
    },
    {
      id: 93577,
      question: "Mumps primarily affects which structure?",
      options: [
        "The parotid glands, most commonly causing bilateral swelling",
        "The submandibular lymph nodes bilaterally",
        "The sublingual gland causing floor-of-mouth swelling",
        "The thyroid gland, leading to anterior neck enlargement"
      ],
      correctAnswer: 0
    },
    {
      id: 93578,
      question: "Pseudomembranous candidiasis presents as a white curdlike material on the mucosal surface with erythema underneath.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93579,
      question: "Denture stomatitis is the least common type of candidiasis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93580,
      question: "Chronic hyperplastic candidiasis lesions should be biopsied if they do not respond to antifungal medication.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93581,
      question: "Angular cheilitis can only be caused by Candida and has no other contributing factors.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93582,
      question: "Deep fungal infections affecting the oral cavity include histoplasmosis, coccidioidomycosis, blastomycosis, and cryptococcosis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93583,
      question: "Verruca vulgaris is transmitted from the oral mucosa to the skin and never in the reverse direction.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93584,
      question: "Primary herpetic gingivostomatitis represents the initial infection with herpes simplex virus.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93585,
      question: "Recurrent herpes simplex infection occurs on non-keratinized moveable mucosa intraorally.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93586,
      question: "Hairy leukoplakia is an Epstein-Barr virus-associated lesion that most commonly appears on the lateral border of the tongue in HIV-infected patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93587,
      question: "Hand-foot-and-mouth disease is most common in adults over the age of 40.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "10. Developmental Disorders": [
    {
      id: 93601,
      question: "Which structure is formed when ectoderm infolds during the third week of embryonic development?",
      options: [
        "The stomodeum, which becomes the primitive oral cavity",
        "The primary dental lamina, a band of ectoderm in each jaw",
        "The dental sac, which later forms cementum and alveolar bone",
        "The globular process, which forms the philtrum of the upper lip"
      ],
      correctAnswer: 0
    },
    {
      id: 93602,
      question: "What is the term for a disorder caused by an abnormality in the genetic makeup of an individual?",
      options: [
        "Acquired disorder, resulting from environmental exposure after birth",
        "Developmental disorder, caused by a failure during cell differentiation",
        "Inherited disorder, caused by an abnormality in the genetic makeup",
        "Congenital disorder, which is always present at birth regardless of cause"
      ],
      correctAnswer: 2
    },
    {
      id: 93603,
      question: "Two pits develop on the frontal process and divide it into how many named parts?",
      options: [
        "Two parts: the left and right lateral nasal processes only",
        "Four parts: median, bilateral lateral, and inferior nasal processes",
        "Three parts: the median nasal process and two lateral nasal processes",
        "Five parts including the maxillary and mandibular nasal divisions"
      ],
      correctAnswer: 2
    },
    {
      id: 93604,
      question: "The globular process is formed when the median nasal process grows downward. What does the globular process eventually become?",
      options: [
        "The dental lamina, which initiates tooth development in both jaws",
        "The philtrum of the upper lip in the fully developed face",
        "The premaxilla, which fuses with the lateral palatine processes",
        "The stomodeum, the earliest recognizable structure of the oral cavity"
      ],
      correctAnswer: 1
    },
    {
      id: 93605,
      question: "The lateral palatine processes form from which embryonic structure?",
      options: [
        "The globular process, which also gives rise to the premaxilla",
        "The frontal process, after it is divided by two nasal pits",
        "The mandibular process, the lower portion of the first arch",
        "The maxillary process, which also contributes to the cheeks"
      ],
      correctAnswer: 3
    },
    {
      id: 93606,
      question: "The lateral palatine processes fuse with the premaxilla to create what pattern?",
      options: [
        "A Y-shaped pattern during formation of the hard palate",
        "An X-shaped pattern along the midline of the developing palate",
        "A T-shaped pattern separating the nasal and oral cavities",
        "A circular pattern around the developing primary dental lamina"
      ],
      correctAnswer: 0
    },
    {
      id: 93607,
      question: "From which branchial arch does the body of the tongue develop?",
      options: [
        "The second branchial arch, along with the base of the tongue",
        "The third branchial arch, which also contributes to the palate",
        "The first branchial arch, as the primary source of tongue body",
        "The fourth branchial arch, which also forms the laryngeal structures"
      ],
      correctAnswer: 2
    },
    {
      id: 93608,
      question: "From which branchial arches does the base of the tongue develop?",
      options: [
        "The first branchial arch exclusively, same as the tongue body",
        "The fourth and fifth branchial arches together",
        "The second and third branchial arches together",
        "The third branchial arch exclusively, distinct from the tongue body"
      ],
      correctAnswer: 2
    },
    {
      id: 93609,
      question: "Odontogenesis begins at approximately which week of embryonic life?",
      options: [
        "The third week, when the stomodeum first forms in the embryo",
        "The fifth week, when the primary dental lamina begins to develop",
        "The seventh week, after the palate has fully fused together",
        "The tenth week, corresponding to the cap stage of tooth development"
      ],
      correctAnswer: 1
    },
    {
      id: 93610,
      question: "What tissues are involved in odontogenesis, the process of tooth development?",
      options: [
        "Ectoderm and ectomesenchyme, which together initiate tooth formation",
        "Endoderm and mesoderm, which form the enamel and dentin layers",
        "Mesoderm and ectomesenchyme, which build the root supporting tissues",
        "Ectoderm and endoderm, which differentiate into pulp and cementum"
      ],
      correctAnswer: 0
    },
    {
      id: 93611,
      question: "How many small knoblike proliferations develop on the primary dental lamina in each jaw?",
      options: [
        "Eight, corresponding to the primary molar and incisor positions",
        "Twelve, corresponding to the permanent tooth positions in each jaw",
        "Ten, each extending into the underlying mesenchyme tissue",
        "Six, which later form the anterior segment of each dental arch"
      ],
      correctAnswer: 2
    },
    {
      id: 93612,
      question: "What are the three parts of the tooth germ during cell differentiation?",
      options: [
        "Enamel organ, dental papilla, and dental sac or follicle",
        "Dental follicle, stellate reticulum, and Hertwig's epithelial root sheath",
        "Ameloblast layer, odontoblast layer, and the dental pulp core",
        "Primary dental lamina, outer enamel epithelium, and root sheath"
      ],
      correctAnswer: 0
    },
    {
      id: 93613,
      question: "Which cells produce enamel during tooth development?",
      options: [
        "Odontoblasts, which line the pulp chamber and form the dentin",
        "Cementoblasts, which are activated after crown formation is complete",
        "Ameloblasts, which are part of the enamel organ and produce enamel",
        "Fibroblasts, which are located within the dental sac connective tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 93614,
      question: "The dental sac or follicle forms which three structures during tooth development?",
      options: [
        "Enamel, dentin, and dental pulp tissue within the crown of the tooth",
        "Cementum, the periodontal ligament, and alveolar bone around roots",
        "Stellate reticulum, ameloblasts, and the inner enamel epithelium layer",
        "Root sheath, dental papilla, and the primary dental lamina remnants"
      ],
      correctAnswer: 1
    },
    {
      id: 93615,
      question: "What is the function of Hertwig's epithelial root sheath?",
      options: [
        "It produces enamel on the inner surface of the developing tooth crown",
        "It connects the dental sac to the alveolar bone during eruption",
        "It forms the stellate reticulum layer within the enamel organ tissue",
        "It shapes the root and induces formation of root dentin in the tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 93616,
      question: "When is cementum production completed in relation to tooth eruption?",
      options: [
        "After eruption, once the tooth is in occlusion and functioning normally",
        "At the time of crown completion, before the tooth begins to erupt",
        "Before eruption, during the late bell stage of tooth development",
        "During root formation, approximately six months before tooth emergence"
      ],
      correctAnswer: 0
    },
    {
      id: 93617,
      question: "Root length is typically completed how many years after tooth eruption?",
      options: [
        "One to four years after the tooth has erupted into the oral cavity",
        "Five to seven years after the tooth has fully erupted into the mouth",
        "Six months to one year after the crown has emerged through the gingiva",
        "Eight to ten years after initial eruption, depending on the tooth type"
      ],
      correctAnswer: 0
    },
    {
      id: 93618,
      question: "A developmental cyst is defined as which of the following?",
      options: [
        "A solid mass of epithelial cells embedded in fibrous connective tissue",
        "A calcified lesion within bone lined by odontogenic epithelium only",
        "An abnormal fluid-filled, epithelium-lined sac or cavity in the body",
        "A pseudocyst lacking epithelial lining but filled with blood or fluid"
      ],
      correctAnswer: 2
    },
    {
      id: 93619,
      question: "What is the most common oral cyst?",
      options: [
        "The dentigerous cyst, associated with unerupted third molars in bone",
        "The odontogenic keratocyst, found most often in the mandibular area",
        "The radicular cyst (periapical cyst), also known as a residual cyst",
        "The nasopalatine canal cyst, located within the incisive canal region"
      ],
      correctAnswer: 2
    },
    {
      id: 93620,
      question: "Cysts are classified as odontogenic or nonodontogenic based on which factors?",
      options: [
        "Patient age, gender, clinical symptoms, and response to antibiotic therapy",
        "Size, bone expansion, relationship to adjacent teeth, and pain level",
        "Radiographic density, cortication, root resorption, and tooth vitality",
        "Location, cause, origin of epithelial cells, and histologic appearance"
      ],
      correctAnswer: 3
    },
    {
      id: 93621,
      question: "Intraosseous cysts generally appear on radiographs as which of the following?",
      options: [
        "Well-circumscribed radiopacities with a sclerotic border in bone",
        "Diffuse radiolucencies with irregular margins blending into bone",
        "Mixed radiolucent-radiopaque lesions with calcified internal structures",
        "Well-circumscribed radiolucencies that may be unilocular or multilocular"
      ],
      correctAnswer: 3
    },
    {
      id: 93622,
      question: "The dentigerous cyst (follicular cyst) forms around which type of tooth?",
      options: [
        "A fully erupted and functioning tooth within the dental arch",
        "A non-vital tooth with a periapical infection or abscess present",
        "A tooth with severe periodontal disease and significant bone loss",
        "An unerupted or developing tooth, most often an impacted third molar"
      ],
      correctAnswer: 3
    },
    {
      id: 93623,
      question: "What is the epithelial origin of the dentigerous cyst lining?",
      options: [
        "The primary dental lamina remnants trapped within the alveolar bone",
        "The reduced enamel epithelium after the crown has formed and calcified",
        "The oral epithelium that proliferates into the follicular space around teeth",
        "The Hertwig's root sheath cells that remain after root formation ends"
      ],
      correctAnswer: 1
    },
    {
      id: 93624,
      question: "On radiograph, the dentigerous cyst appears as which of the following?",
      options: [
        "A multilocular, soap-bubble radiolucency involving multiple tooth roots",
        "A diffuse, ill-defined radiolucency at the apex of a non-vital tooth",
        "A pear-shaped radiolucency between the roots of two adjacent teeth",
        "A well-defined, unilocular radiolucency around the crown of an unerupted tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 93625,
      question: "Histologically, the dentigerous cyst lumen is most characteristically lined by which epithelium?",
      options: [
        "Pseudostratified ciliated columnar epithelium with numerous goblet cells",
        "Orthokeratinized stratified squamous epithelium filled with keratin debris",
        "Parakeratin-surfaced epithelium eight to ten cell layers in thickness",
        "Cuboidal epithelium surrounded by a wall of connective tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 93626,
      question: "What is the recommended treatment for a dentigerous cyst?",
      options: [
        "Antibiotic therapy alone, which resolves the cyst without surgical need",
        "Removal of the cyst, with awareness of the risk of neoplastic transformation",
        "No treatment required, as the cyst resolves spontaneously over time",
        "Curettage of the bony walls only, leaving the cyst lining in position"
      ],
      correctAnswer: 1
    },
    {
      id: 93627,
      question: "How does the eruption cyst differ from the dentigerous cyst?",
      options: [
        "The eruption cyst is found in soft tissue around the crown of an erupting tooth",
        "The eruption cyst requires immediate surgical intervention for resolution",
        "The eruption cyst is located within bone rather than in soft tissue",
        "The eruption cyst is lined by orthokeratinized epithelium with ghost cells"
      ],
      correctAnswer: 0
    },
    {
      id: 93628,
      question: "What is the recommended treatment for an eruption cyst?",
      options: [
        "Surgical incision and drainage to release the fluid-filled swelling",
        "Antibiotic coverage to prevent secondary infection of the lesion",
        "No treatment, as it resolves on its own when the tooth erupts",
        "Removal of the associated tooth to eliminate the source of the cyst"
      ],
      correctAnswer: 2
    },
    {
      id: 93629,
      question: "Where does the primordial cyst most commonly develop?",
      options: [
        "Around the crown of a retained primary molar in young children",
        "Between the roots of maxillary anterior teeth near the midline",
        "Along the lateral surface of the mandibular premolar root area",
        "In place of a tooth, most commonly in place of a third molar"
      ],
      correctAnswer: 3
    },
    {
      id: 93630,
      question: "In which patient population is the primordial cyst most often discovered?",
      options: [
        "Elderly patients over 70 years old during routine panoramic screening",
        "Children under 10 years old during mixed dentition radiographic surveys",
        "Middle-aged women between 40 and 60 years as an incidental finding",
        "Young adults, usually discovered incidentally on radiographic examination"
      ],
      correctAnswer: 3
    },
    {
      id: 93631,
      question: "Histologically, the primordial cyst lumen is lined by which type of epithelium?",
      options: [
        "Cuboidal epithelium surrounded by loosely arranged connective tissue",
        "Stratified squamous epithelium surrounded by parallel collagen fiber bundles",
        "Pseudostratified ciliated columnar epithelium with mucous goblet cells",
        "Orthokeratinized epithelium with hair follicles visible in the cyst wall"
      ],
      correctAnswer: 1
    },
    {
      id: 93632,
      question: "Which two cysts might a primordial cyst prove to be upon histologic examination?",
      options: [
        "A dentigerous cyst or a calcifying odontogenic cyst with ghost cells",
        "A nasopalatine canal cyst or a median palatine cyst in the palate",
        "A simple bone cyst or an aneurysmal bone cyst with giant cells present",
        "An odontogenic keratocyst or a lateral periodontal cyst upon examination"
      ],
      correctAnswer: 3
    },
    {
      id: 93633,
      question: "The odontogenic keratocyst (OKC) is histologically lined by epithelium of what thickness?",
      options: [
        "Two to four cell layers thick, surfaced by orthokeratin",
        "Eight to ten cell layers thick, surfaced by parakeratin",
        "Fifteen to twenty cell layers thick, surfaced by mucous cells",
        "A single cell layer thick, with a flat, non-keratinized surface"
      ],
      correctAnswer: 1
    },
    {
      id: 93634,
      question: "Where is the OKC most often found in the jaws?",
      options: [
        "In the anterior maxilla, between the central and lateral incisors",
        "At the midline of the mandible, below the mandibular incisors",
        "In the mandibular third molar region of the posterior jaw",
        "Along the hard palate midline between the two central incisors"
      ],
      correctAnswer: 2
    },
    {
      id: 93635,
      question: "What is a notable clinical feature distinguishing the OKC from other cysts?",
      options: [
        "It is the only cyst that exclusively occurs in females under age 20",
        "It never recurs after surgical removal and has an excellent prognosis",
        "It spontaneously resolves without treatment within one to two years",
        "It can move teeth and cause resorption, and has a high recurrence rate"
      ],
      correctAnswer: 3
    },
    {
      id: 93636,
      question: "What is the recommended treatment for the odontogenic keratocyst?",
      options: [
        "Surgical excision and osseous curettage due to the high recurrence rate",
        "No treatment required; observation and periodic radiographic follow-up",
        "Antibiotic therapy alone to control the associated inflammatory process",
        "Drainage and irrigation of the cyst cavity without bony wall removal"
      ],
      correctAnswer: 0
    },
    {
      id: 93637,
      question: "On radiograph, the OKC frequently appears as which type of lesion?",
      options: [
        "A well-defined, unilocular radiolucency around an impacted third molar",
        "A diffuse, poorly defined radiolucency with irregular sclerotic margins",
        "A well-defined, multilocular, radiolucent lesion with a high recurrence rate",
        "A mixed radiolucent-radiopaque lesion with internal calcified structures"
      ],
      correctAnswer: 2
    },
    {
      id: 93638,
      question: "The calcifying odontogenic cyst (COC) is best described as which of the following?",
      options: [
        "A nonaggressive, cystic lesion lined by odontogenic epithelium with ghost cells",
        "A highly aggressive cyst that commonly transforms into squamous carcinoma",
        "A pseudocyst lacking epithelial lining that is filled with blood-derived fluid",
        "A cyst identical to the primordial cyst but located exclusively in the maxilla"
      ],
      correctAnswer: 0
    },
    {
      id: 93639,
      question: "The COC is said to closely resemble which other odontogenic lesion?",
      options: [
        "A lateral periodontal cyst, with thin squamous epithelial lining",
        "A primordial cyst, developing in the location where a tooth is absent",
        "A dentigerous cyst, due to its association with an unerupted tooth crown",
        "An ameloblastoma, due to the similar pattern of epithelial lining"
      ],
      correctAnswer: 3
    },
    {
      id: 93640,
      question: "What is the characteristic histologic feature unique to the calcifying odontogenic cyst?",
      options: [
        "A pseudostratified ciliated lining with mucous-secreting goblet cells",
        "Balloon-shaped ghost cells with clear cytoplasm within the lining",
        "Parallel bundles of collagen fibers surrounding the squamous lining",
        "A lumen filled entirely with keratin and orthokeratinized epithelium"
      ],
      correctAnswer: 1
    },
    {
      id: 93641,
      question: "The lateral periodontal cyst is most often seen in which jaw location?",
      options: [
        "The maxillary anterior region, between the central and lateral incisors",
        "The mandibular cuspid and premolar area along the root lateral surface",
        "The posterior maxilla, in the region of the second and third molars",
        "The anterior mandible, below the apices of the mandibular incisors"
      ],
      correctAnswer: 1
    },
    {
      id: 93642,
      question: "Which gender is the lateral periodontal cyst found most often in?",
      options: [
        "Females, with a 4:1 ratio favoring females over males in all cases",
        "Both sexes equally, with no documented predilection for either gender",
        "Females only during their reproductive years between ages 20 and 45",
        "Males, who are more commonly affected by the lateral periodontal cyst"
      ],
      correctAnswer: 3
    },
    {
      id: 93643,
      question: "The botryoid odontogenic cyst is defined as which variant of another cyst?",
      options: [
        "A unilocular variant of the primordial cyst found in the mandible",
        "A calcified variant of the odontogenic keratocyst with ghost cell features",
        "A bilateral variant of the dentigerous cyst in the third molar region",
        "A multilocular variant of the lateral periodontal cyst resembling grapes"
      ],
      correctAnswer: 3
    },
    {
      id: 93644,
      question: "Histologically, the gingival cyst is lined by which type of epithelium?",
      options: [
        "A thin band of stratified squamous epithelium in the soft tissue",
        "Pseudostratified ciliated columnar epithelium with goblet cells present",
        "Cuboidal epithelium surrounded by a dense wall of connective tissue",
        "Parakeratin-surfaced epithelium eight to ten cell layers in thickness"
      ],
      correctAnswer: 0
    },
    {
      id: 93645,
      question: "The nasopalatine canal cyst (incisive canal cyst) is located in which region?",
      options: [
        "In the midline of the mandible below the apices of the incisors",
        "Within the nasopalatine canal or at the incisive papilla in the palate",
        "Between the roots of the maxillary lateral incisor and canine teeth",
        "In the soft tissue at the base of the nose and upper lip junction"
      ],
      correctAnswer: 1
    },
    {
      id: 93646,
      question: "Which demographic is most commonly affected by the nasopalatine canal cyst?",
      options: [
        "Young females between 20 and 30 years old with palatal swelling",
        "Children under 12 years old in whom it is discovered incidentally",
        "Males between 40 and 60 years old who are usually asymptomatic",
        "Elderly females over 70 years old with associated tooth root resorption"
      ],
      correctAnswer: 2
    },
    {
      id: 93647,
      question: "What shape may the nasopalatine canal cyst appear on a radiograph?",
      options: [
        "Round or triangular in shape, superimposed over the anterior teeth",
        "Oval or heart-shaped, as a well-defined radiolucent lesion",
        "Pear-shaped or teardrop, located between two adjacent root apices",
        "Multilocular or soap-bubble in appearance in the anterior maxilla"
      ],
      correctAnswer: 1
    },
    {
      id: 93648,
      question: "Histologically, the nasopalatine canal cyst is lined by which epithelial type?",
      options: [
        "Only orthokeratinized stratified squamous epithelium throughout the lumen",
        "Parakeratin-surfaced epithelium eight to ten cell layers in thickness",
        "Cuboidal epithelium surrounded by a dense fibrous connective tissue wall",
        "Epithelium ranging from stratified squamous to pseudostratified ciliated columnar"
      ],
      correctAnswer: 3
    },
    {
      id: 93649,
      question: "The median palatine cyst is located in which specific area?",
      options: [
        "Between the maxillary lateral incisor and cuspid along the alveolar ridge",
        "In the midline of the hard palate",
        "Within the incisive canal at the anterior portion of the hard palate",
        "In the soft tissue at the nasal base adjacent to the alar cartilage"
      ],
      correctAnswer: 1
    },
    {
      id: 93650,
      question: "Histologically, the median palatine cyst is lined by which epithelium?",
      options: [
        "Pseudostratified ciliated columnar epithelium with multiple goblet cells",
        "Parakeratin-surfaced epithelium that is eight to ten cell layers thick",
        "Cuboidal epithelium similar in appearance to the dentigerous cyst lining",
        "Stratified squamous epithelium surrounded by dense fibrous connective tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 93651,
      question: "The globulomaxillary cyst appears radiographically as which shape?",
      options: [
        "A pear-shaped radiolucency between the maxillary lateral incisor and cuspid",
        "A round, well-defined unilocular radiolucency at the root apex",
        "A heart-shaped lesion located above the incisive foramen on imaging",
        "A multilocular lesion with scalloped borders along the root surfaces"
      ],
      correctAnswer: 0
    },
    {
      id: 93652,
      question: "The median mandibular cyst is characterized as which type of lesion?",
      options: [
        "A common lesion seen frequently in patients over 50 years of age",
        "A soft tissue cyst originating from the nasolacrimal duct remnants",
        "A rare lesion located in the midline of the mandible lined with squamous epithelium",
        "A pseudocyst arising from traumatic injury to the mandibular symphysis"
      ],
      correctAnswer: 2
    },
    {
      id: 93653,
      question: "Where does the nasolabial cyst clinically present?",
      options: [
        "On the floor of the mouth, causing tongue elevation and displacement",
        "Along the lateral surface of the mandibular premolar root region",
        "At the midline of the palate, causing a palpable swelling in the vault",
        "In the mucobuccal fold near the maxillary canine and floor of the nose"
      ],
      correctAnswer: 3
    },
    {
      id: 93654,
      question: "From which structure is the nasolabial cyst thought to originate?",
      options: [
        "The lower anterior portion of the nasolacrimal duct remnants",
        "The reduced enamel epithelium from a previously developed tooth crown",
        "The primary dental lamina trapped within the alveolar ridge mucosa",
        "The lateral nasal process during embryonic fusion of facial processes"
      ],
      correctAnswer: 0
    },
    {
      id: 93655,
      question: "Which age group and gender is the nasolabial cyst most commonly observed in?",
      options: [
        "Males between 20 and 30 years old with a 4:1 male-to-female ratio",
        "Children under 10 years old during primary dentition development",
        "Adults 40 to 50 years old with a 4:1 ratio favoring females over males",
        "Elderly males over 65 years old discovered on routine panoramic imaging"
      ],
      correctAnswer: 2
    },
    {
      id: 93656,
      question: "Histologically, the nasolabial cyst is lined by which type of epithelium?",
      options: [
        "Orthokeratinized stratified squamous epithelium with a keratin-filled lumen",
        "Pseudostratified ciliated columnar epithelium with multiple goblet cells",
        "Cuboidal epithelium surrounded by a dense fibrous connective tissue wall",
        "Thin stratified squamous epithelium identical to the gingival cyst lining"
      ],
      correctAnswer: 1
    },
    {
      id: 93657,
      question: "The dermoid cyst in the oral cavity is most commonly found in which location?",
      options: [
        "At the midline of the hard palate where it causes palatal expansion",
        "In the mandibular molar region, appearing as a bony expansion",
        "Along the buccal mucosa adjacent to the maxillary molar teeth",
        "In the floor of the mouth, and may cause tongue displacement"
      ],
      correctAnswer: 3
    },
    {
      id: 93658,
      question: "What is the characteristic histologic finding in a dermoid cyst wall?",
      options: [
        "Ghost cells and calcifications similar to the calcifying odontogenic cyst",
        "Multinucleated giant cells and blood-filled spaces in fibrous stroma",
        "Hair follicles, sebaceous glands, and sweat glands in the cyst wall",
        "Pseudostratified ciliated columnar epithelium with multiple goblet cells"
      ],
      correctAnswer: 2
    },
    {
      id: 93659,
      question: "The dermoid cyst lumen is typically filled with which material?",
      options: [
        "Keratin, as the lumen is lined by orthokeratinized stratified squamous epithelium",
        "Blood and fluid surrounded by multinucleated giant cells in the wall",
        "Thin, watery fluid similar in composition to normal tissue fluid",
        "Ghost cells with clear cytoplasm arranged in balloon-like formations"
      ],
      correctAnswer: 0
    },
    {
      id: 93660,
      question: "Pseudocysts differ from true cysts in which fundamental way?",
      options: [
        "They are always located in soft tissue rather than within bone",
        "They are not lined by epithelium, unlike true developmental cysts",
        "They are always filled with keratin rather than fluid or blood",
        "They are always associated with an unerupted or impacted tooth"
      ],
      correctAnswer: 1
    },
    {
      id: 93661,
      question: "The static bone cyst (Stafne bone cyst) is clinically described as which of the following?",
      options: [
        "A pathologic fluid-filled cavity associated with traumatic injury to the jaw",
        "An epithelium-lined sac located within the incisive canal of the palate",
        "A blood-filled space surrounded by giant cells in the posterior mandible",
        "An anatomic depression on the posterior lingual area of the mandible"
      ],
      correctAnswer: 3
    },
    {
      id: 93662,
      question: "The static bone cyst appears radiographically in which location relative to the mandibular canal?",
      options: [
        "In the posterior mandible, as a radiolucency inferior to the mandibular canal",
        "Above the mandibular canal in the premolar region of the mandible",
        "In the mandibular symphysis region, between the lower central incisors",
        "In the ramus near the condylar head, superior to the mandibular canal"
      ],
      correctAnswer: 0
    },
    {
      id: 93663,
      question: "What is the recommended treatment for the static bone cyst?",
      options: [
        "Surgical excision with curettage to stimulate healing of the bone cavity",
        "No treatment is required, as it is an anatomic variation, not a pathologic cavity",
        "Curettage of the bony walls to promote hemorrhage and bone healing",
        "Antibiotic coverage followed by periodic radiographic follow-up imaging"
      ],
      correctAnswer: 1
    },
    {
      id: 93664,
      question: "The simple bone cyst (traumatic bone cyst) may be associated with which factor?",
      options: [
        "A developmental defect in the primary dental lamina during odontogenesis",
        "An infection from a non-vital tooth that spreads into the adjacent bone",
        "Trauma, and the cyst is not lined with epithelium unlike true cysts",
        "A genetic mutation affecting cementogenesis and alveolar bone formation"
      ],
      correctAnswer: 2
    },
    {
      id: 93665,
      question: "The simple bone cyst is treated by which method?",
      options: [
        "Surgical excision of the entire cyst and surrounding bone tissue",
        "No treatment, as it resolves spontaneously without any intervention",
        "Extraction of all associated teeth to eliminate the source of the lesion",
        "Curettage of the wall lining the bony void to stimulate healing"
      ],
      correctAnswer: 3
    },
    {
      id: 93666,
      question: "On radiograph, the simple bone cyst characteristically shows which feature?",
      options: [
        "A well-defined radiolucency with scalloping around the roots of teeth",
        "A multilocular soap-bubble appearance typical of giant cell-containing lesions",
        "A heart-shaped or oval radiolucency above the anterior maxillary teeth",
        "A pear-shaped radiolucency between the lateral incisor and canine roots"
      ],
      correctAnswer: 0
    },
    {
      id: 93667,
      question: "The aneurysmal bone cyst is histologically composed of which elements?",
      options: [
        "Orthokeratinized epithelium filled with keratin and sebaceous glands",
        "Ghost cells with clear cytoplasm surrounded by odontogenic epithelium",
        "Blood-filled spaces surrounded by multinucleated giant cells and fibrous tissue",
        "Cuboidal epithelium with a connective tissue wall and inflammatory infiltrate"
      ],
      correctAnswer: 2
    },
    {
      id: 93668,
      question: "On radiograph, the aneurysmal bone cyst shows which characteristic appearance?",
      options: [
        "A well-defined unilocular radiolucency with scalloping around root apices",
        "A pear-shaped radiolucency between the lateral incisor and cuspid roots",
        "A heart-shaped radiolucency superimposed over the anterior palate region",
        "A multilocular honeycomb or soap-bubble radiolucent appearance in bone"
      ],
      correctAnswer: 3
    },
    {
      id: 93669,
      question: "Which patient demographic is most commonly affected by the aneurysmal bone cyst?",
      options: [
        "Elderly males over 60 years old with a strong male predilection overall",
        "Persons under 30 years old with a slight predilection for females",
        "Middle-aged adults between 40 and 55 with equal gender distribution",
        "Children under 5 years old during early primary dentition development"
      ],
      correctAnswer: 1
    },
    {
      id: 93670,
      question: "The cause of most congenital abnormalities is unknown.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93671,
      question: "The base of the tongue develops from the first branchial arch.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93672,
      question: "Cementogenesis occurs after crown formation is complete in tooth development.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93673,
      question: "The eruption cyst requires surgical removal to allow the tooth to erupt normally.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93674,
      question: "The odontogenic keratocyst has a high recurrence rate and can move teeth and cause resorption.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93675,
      question: "The static bone cyst is a true pathologic cavity that requires surgical treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93676,
      question: "The nasolabial cyst is an intraosseous cyst visible on periapical radiographs.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "13. Genetics": [
    {
      id: 93677,
      question: "Which of the following best describes the term \"genetics\"?",
      options: [
        "The study of chromosomal abnormalities only, excluding all normal inherited traits",
        "The study of only disease-causing mutations passed between generations",
        "The molecular analysis of RNA and DNA sequences within a single organism",
        "The inheritance and expression of inherited traits, including all physical and biochemical characteristics"
      ],
      correctAnswer: 3
    },
    {
      id: 93678,
      question: "Which of the following best defines a \"syndrome\"?",
      options: [
        "A distinctive association of multiple signs and symptoms occurring together",
        "A single clinical sign caused by one specific chromosomal mutation",
        "A biochemical abnormality detected only through laboratory testing",
        "A hereditary disorder affecting only one organ system at a time"
      ],
      correctAnswer: 0
    },
    {
      id: 93679,
      question: "What is the term for the physical, biochemical, and physiological traits of an individual?",
      options: [
        "Genotype",
        "Karyotype",
        "Phenotype",
        "Allele"
      ],
      correctAnswer: 2
    },
    {
      id: 93680,
      question: "In Down syndrome, which chromosome is affected by nondisjunction?",
      options: [
        "Chromosome 5",
        "Chromosome 21",
        "Chromosome 13",
        "Chromosome 23"
      ],
      correctAnswer: 1
    },
    {
      id: 93681,
      question: "Which of the following is a common oral manifestation of Down syndrome?",
      options: [
        "Complete absence of all teeth at birth with no bone involvement",
        "Bilateral cleft lip and palate with microphthalmia",
        "Gingival fibromatosis with firm, granular, corrugated tissue overgrowth",
        "Gingival and periodontal disease reported in approximately 90% of affected individuals"
      ],
      correctAnswer: 3
    },
    {
      id: 93682,
      question: "Which facial characteristic is commonly associated with Down syndrome?",
      options: [
        "Downward sloping of the eyes with a fishlike mouth appearance",
        "Slanted eyes with a depressed bridge of the nose and frontal bossing",
        "Webbing of the neck with a broad chest and widely spaced nipples",
        "Upward slanting of palpebral fissures with hypertelorism of all facial bones"
      ],
      correctAnswer: 1
    },
    {
      id: 93683,
      question: "Which of the following statements about Trisomy 13 is correct?",
      options: [
        "The majority of patients survive past 12 months with appropriate medical treatment",
        "Trisomy 13 is associated with extra X chromosomes in female patients only",
        "Approximately 70% of patients die within the first 7 months of life",
        "The primary oral finding in Trisomy 13 is gingival fibromatosis without clefting"
      ],
      correctAnswer: 2
    },
    {
      id: 93684,
      question: "Which of the following is a characteristic facial feature of Trisomy 13?",
      options: [
        "Broad flat nose, fissured tongue, and prominent frontal bossing",
        "Fishlike mouth, hypoplastic malar bones, and abnormally placed ears",
        "Webbed neck, low hairline, and widely spaced nipples",
        "Bilateral cleft lip and palate, along with microphthalmia or anophthalmia"
      ],
      correctAnswer: 3
    },
    {
      id: 93685,
      question: "Turner syndrome is associated with which of the following findings?",
      options: [
        "Female karyotype with short stature, webbed neck, and primary amenorrhea",
        "Multiple osteomas of facial bones with intestinal polyps prone to malignancy",
        "Bilateral facial swelling beginning at 1.5 to 4 years with multilocular jaw lesions",
        "Male phenotype with extra X chromosomes and taller-than-normal stature"
      ],
      correctAnswer: 0
    },
    {
      id: 93686,
      question: "Which of the following describes the chromosomal basis of Klinefelter syndrome?",
      options: [
        "Monosomy of the X chromosome occurring exclusively in female patients",
        "A deletion on the short arm of chromosome 5 causing a catlike cry at birth",
        "An extra chromosome 21 resulting from nondisjunction during meiosis",
        "Extra X chromosomes present in a male individual, such as XXY or XXXY"
      ],
      correctAnswer: 3
    },
    {
      id: 93687,
      question: "Which physical characteristic is associated with Klinefelter syndrome?",
      options: [
        "Short stature, webbed neck, and widely spaced nipples in a female patient",
        "Catlike cry at birth with mental retardation and deletion of chromosome 5",
        "Bilateral jaw swelling with a multilocular jaw appearance in early childhood",
        "Taller than normal stature with wider hips and smaller, harder testes"
      ],
      correctAnswer: 3
    },
    {
      id: 93688,
      question: "Cri du Chat syndrome is caused by which chromosomal change?",
      options: [
        "A deletion on the short arm of chromosome 4",
        "An extra chromosome 21 resulting from nondisjunction during cell division",
        "A deletion on the short arm of chromosome 5",
        "Extra X chromosomes present in a phenotypically male individual"
      ],
      correctAnswer: 2
    },
    {
      id: 93689,
      question: "Which of the following is a characteristic feature of Wolf-Hirschhorn syndrome?",
      options: [
        "Multiple bony projections on jaw bones and intestinal polyps prone to malignancy",
        "Cleft palate and an IQ under 30, caused by a deletion on chromosome 4",
        "Catlike cry at birth with mental retardation and deletion of chromosome 5",
        "Bilateral swelling of the jaw with a soap bubble radiographic appearance"
      ],
      correctAnswer: 1
    },
    {
      id: 93690,
      question: "Which of the following best describes autosomal dominant inheritance?",
      options: [
        "Both parents must be carriers and the affected child must be homozygous",
        "Only males manifest the trait while females carry it without expression",
        "The trait is only expressed when a double gene dose is present in all cases",
        "The trait is transmitted vertically and males and females are equally affected"
      ],
      correctAnswer: 3
    },
    {
      id: 93691,
      question: "What does \"lack of penetrance\" mean in autosomal dominant inheritance?",
      options: [
        "The gene is expressed more severely in females than in males",
        "An individual carries the gene without presenting any clinical manifestation",
        "The trait requires both alleles to be identical before it can be expressed",
        "The dominant trait is suppressed by a recessive gene from the other parent"
      ],
      correctAnswer: 1
    },
    {
      id: 93692,
      question: "Which of the following best describes autosomal recessive inheritance?",
      options: [
        "The trait is transmitted vertically with equal expression in males and females",
        "Both parents must be carriers, and the child must be homozygous for the gene",
        "Only one parent needs to carry the gene for it to be expressed in the child",
        "The trait is expressed in males more commonly due to X-linkage involvement"
      ],
      correctAnswer: 1
    },
    {
      id: 93693,
      question: "Which of the following correctly describes Cyclic Neutropenia?",
      options: [
        "An autosomal recessive condition caused by decreased serum alkaline phosphatase",
        "An autosomal dominant condition with cyclic decreases in circulating neutrophils",
        "An X-linked condition characterized by decreased sweating, hair, and teeth",
        "A genetic condition with hyperkeratosis of palms, soles, and gingival tissues"
      ],
      correctAnswer: 1
    },
    {
      id: 93694,
      question: "Which of the following oral manifestations is associated with Cyclic Neutropenia?",
      options: [
        "Severe ulcerative gingivitis, gingivostomatitis, and recurrent periodontal disease",
        "Multiple hyaline fibromas on the nose, chin, and head with gingival enlargement",
        "Bilateral cleft lip and palate with enamel hypoplasia and missing central incisors",
        "Gingival fibromatosis with firm, granular tissue and delayed tooth eruption"
      ],
      correctAnswer: 0
    },
    {
      id: 93695,
      question: "Papillon-Lefèvre Syndrome follows which pattern of inheritance?",
      options: [
        "Autosomal recessive inheritance with depressed peripheral blood neutrophils",
        "X-linked recessive affecting primarily males with carrier females",
        "Autosomal dominant with complete penetrance and uniform expression",
        "Autosomal dominant with variable expressivity and incomplete penetrance"
      ],
      correctAnswer: 0
    },
    {
      id: 93696,
      question: "Which of the following best describes the oral findings in Papillon-Lefèvre Syndrome?",
      options: [
        "Multiple cysts of the jaws classified histologically as odontogenic keratocysts",
        "Gingivoperiodontal inflammation beginning at 1.5 to 2 years with premature loss of both dentitions",
        "Gingival enlargement with firm tissue and a granular corrugated surface only",
        "Teeth with opalescent color, short roots, and completely absent pulp chambers"
      ],
      correctAnswer: 1
    },
    {
      id: 93697,
      question: "Which systemic feature distinguishes Papillon-Lefèvre Syndrome from Focal Palmoplantar and Gingival Hyperkeratosis?",
      options: [
        "Gingival fibromatosis with firm tissue is present only in Papillon-Lefèvre Syndrome",
        "Hyperkeratosis of palms and soles is present only in Papillon-Lefèvre Syndrome",
        "Premature loss of both the primary and permanent dentitions occurs in Papillon-Lefèvre",
        "Café au lait pigmentation is found on the skin only in Papillon-Lefèvre Syndrome"
      ],
      correctAnswer: 2
    },
    {
      id: 93698,
      question: "Focal Palmoplantar and Gingival Hyperkeratosis follows which pattern of inheritance?",
      options: [
        "Autosomal dominant with hyperkeratinization of palms, soles, and labial/lingual gingiva",
        "Autosomal recessive with depressed neutrophil chemotaxis",
        "Autosomal recessive with hyperkeratosis only on the palms and soles",
        "X-linked dominant affecting primarily females"
      ],
      correctAnswer: 0
    },
    {
      id: 93699,
      question: "Gingival Fibromatosis is characterized by which of the following tissue features?",
      options: [
        "Thin atrophic gingival tissue with widespread exposed root surfaces",
        "Soft spongy white folded tissue with outer surface desquamation",
        "Vascular tissue with capillary dilations causing spontaneous hemorrhage",
        "Very firm tissue with a granular corrugated surface"
      ],
      correctAnswer: 3
    },
    {
      id: 93700,
      question: "Which of the following syndromes is associated with Gingival Fibromatosis and also features dysplastic or absent nails and hepatosplenomegaly?",
      options: [
        "Papillon-Lefèvre Syndrome with hyperkeratosis of palms and soles",
        "Laband Syndrome with autosomal dominant inheritance pattern",
        "Cyclic neutropenia with fever, malaise, and recurrent sore throat",
        "Turner syndrome with short stature and primary amenorrhea"
      ],
      correctAnswer: 1
    },
    {
      id: 93701,
      question: "Laband Syndrome is characterized by which combination of features?",
      options: [
        "Gingival fibromatosis, hyperkeratosis of palms and soles, and premature tooth loss",
        "Multiple hyaline fibrous tumors on the head, nose, and chin with gingival enlargement",
        "Gingival enlargement with epilepsy, hypertrichosis, and bilateral cleft palate",
        "Gingival fibromatosis, dysplastic or absent nails, malformed nose and ears, and hypoplasia of terminal phalanges"
      ],
      correctAnswer: 3
    },
    {
      id: 93702,
      question: "Which of the following syndromes is associated with Gingival Fibromatosis, epilepsy, and hypertrichosis?",
      options: [
        "Laband syndrome with hepatosplenomegaly and hypoplastic terminal phalanges",
        "Murray-Puretic-Drescher syndrome with multiple hyaline fibromas",
        "Gingival Fibromatosis with Hypertrichosis, Epilepsy, and Mental Retardation Syndrome",
        "Cyclic neutropenia with recurrent fever and severe periodontal destruction"
      ],
      correctAnswer: 2
    },
    {
      id: 93703,
      question: "Cherubism is best described by which of the following?",
      options: [
        "Unilateral swelling of the maxilla beginning at puberty with a soap bubble appearance",
        "Multiple osteomas of facial bones with intestinal polyps prone to malignant change",
        "Bilateral facial enlargement due to gingival fibromatosis with granular corrugated tissue",
        "Progressive bilateral facial swelling beginning at 1.5 to 4 years with multilocular jaw lesions"
      ],
      correctAnswer: 3
    },
    {
      id: 93704,
      question: "What is the characteristic radiographic appearance of Cherubism?",
      options: [
        "Multiple odontogenic keratocysts along the inferior border of the mandible",
        "Periapical radiolucencies with short thin roots and absent pulp chambers",
        "A soap bubble or multilocular radiolucent appearance of the jaw bones",
        "Multiple bony projections on the jaw with impacted supernumerary teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 93705,
      question: "Ellis-van Creveld Syndrome (Chondroectodermal Dysplasia) is associated with which of the following oral findings?",
      options: [
        "Progressive bilateral jaw swelling with multilocular radiolucencies",
        "Multiple impacted supernumerary teeth with delayed eruption and jaw cysts",
        "Fusion of the maxillary gingiva to the lip, missing central incisors, and natal teeth",
        "Bilateral cleft lip and palate with microphthalmia and extra fingers"
      ],
      correctAnswer: 2
    },
    {
      id: 93706,
      question: "Ellis-van Creveld Syndrome follows which pattern of inheritance?",
      options: [
        "Autosomal recessive with dwarfism and polydactyly on the ulnar side",
        "Autosomal dominant with variable expressivity and incomplete penetrance",
        "X-linked dominant affecting primarily females with low serum phosphorus",
        "Autosomal dominant with complete penetrance and bilateral jaw involvement"
      ],
      correctAnswer: 0
    },
    {
      id: 93707,
      question: "Cleidocranial Dysplasia is characterized by which of the following findings?",
      options: [
        "Bilateral jaw swelling beginning in early childhood with a soap bubble radiograph",
        "Multiple hyaline fibrous tumors on the nose, chin, and head with jaw involvement",
        "Mushroom-shaped cranium, hypoplastic clavicles, and multiple supernumerary impacted teeth",
        "Osteomas of facial bones, multiple odontomas, and intestinal polyps in the jaw"
      ],
      correctAnswer: 2
    },
    {
      id: 93708,
      question: "Gardner Syndrome is also known as which of the following?",
      options: [
        "Chondroectodermal Dysplasia",
        "Familial Colorectal Polyposis",
        "Mandibulofacial Dysostosis",
        "Nevoid Basal Cell Carcinoma Syndrome"
      ],
      correctAnswer: 1
    },
    {
      id: 93709,
      question: "Which of the following is the most clinically significant feature of Gardner Syndrome?",
      options: [
        "Progressive bilateral jaw swelling resembling giant cell granuloma lesions",
        "Multiple supernumerary impacted teeth leading to pathological jaw fractures",
        "Odontogenic keratocysts forming along the jaw with associated basal cell carcinomas",
        "Intestinal polyps that are benign initially but become malignant around age 30 or later"
      ],
      correctAnswer: 3
    },
    {
      id: 93710,
      question: "Mandibulofacial Dysostosis (Treacher-Collins Syndrome) is characterized by which of the following?",
      options: [
        "Downward sloping palpebral fissures, hypoplastic malar bones, and fishlike mouth",
        "Bilateral facial swelling, soap bubble jaw radiolucencies, and short stature",
        "Multiple osteomas of facial bones, multiple odontomas, and intestinal polyps",
        "Open fontanelles, mushroom-shaped skull, and multiple impacted supernumerary teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 93711,
      question: "Which of the following dental findings is associated with Treacher-Collins Syndrome?",
      options: [
        "Natal teeth with conical shape, enamel hypoplasia, and missing central incisors",
        "Malposed teeth with malocclusion, anterior open bite, and high arched palate",
        "Multiple supernumerary impacted teeth with associated jaw cysts",
        "Opalescent teeth with short thin roots and no visible pulp chambers"
      ],
      correctAnswer: 1
    },
    {
      id: 93712,
      question: "Nevoid Basal Cell Carcinoma Syndrome is also known by which name?",
      options: [
        "Gardner Syndrome",
        "Laband Syndrome",
        "Gorlin Syndrome",
        "Van der Woude Syndrome"
      ],
      correctAnswer: 2
    },
    {
      id: 93713,
      question: "Which of the following jaw findings is characteristic of Nevoid Basal Cell Carcinoma Syndrome?",
      options: [
        "Progressive bilateral jaw swelling with multilocular bone lesions resembling giant cell granuloma",
        "Multiple osteomas of the jaw with impacted odontomas and intestinal polyps",
        "Soap bubble jaw radiolucency with bilateral swelling beginning in early childhood",
        "Multiple jaw cysts that are histologically classified as odontogenic keratocysts"
      ],
      correctAnswer: 3
    },
    {
      id: 93714,
      question: "Osteogenesis Imperfecta is primarily caused by which underlying problem?",
      options: [
        "Mutations affecting collagen resulting in abnormally formed bones that fracture easily",
        "Decreased alkaline phosphatase leading to failure of cementum and bone formation",
        "Extra X chromosomes causing defective bone matrix and dental enamel formation",
        "Depressed neutrophil chemotaxis causing recurrent bone and periodontal infections"
      ],
      correctAnswer: 0
    },
    {
      id: 93715,
      question: "Which of the following dental findings is associated with Osteogenesis Imperfecta?",
      options: [
        "Multiple supernumerary impacted teeth with associated odontogenic cysts",
        "Hypodontia, conically shaped teeth, and fusion of the gingiva to the lip",
        "Natal teeth with conical crowns and enamel hypoplasia",
        "Dentinogenesis imperfecta-like condition with opalescent or translucent teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 93716,
      question: "Van der Woude Syndrome is characterized by which of the following?",
      options: [
        "Multiple melanotic macular pigmentations with gastrointestinal polyposis hamartomas",
        "Multiple capillary dilations on skin and mucous membranes with epistaxis",
        "White corrugated folded buccal mucosa with a thick desquamating keratin layer",
        "Cleft lip and palate combined with congenital lip pits on the lower lip"
      ],
      correctAnswer: 3
    },
    {
      id: 93717,
      question: "Hereditary Hemorrhagic Telangiectasia (Osler-Rendu-Parkes Weber Syndrome) is characterized by which finding?",
      options: [
        "White corrugated folded buccal mucosa with desquamation of the keratin layer",
        "Multiple melanotic macular pigmentations with gastrointestinal hamartomas",
        "Multiple capillary dilations of skin and mucous membranes called telangiectasias",
        "Gingival fibromatosis with firm granular tissue and associated hypertrichosis"
      ],
      correctAnswer: 2
    },
    {
      id: 93718,
      question: "Neurofibromatosis of von Recklinghausen is associated with which characteristic finding?",
      options: [
        "Melanotic macular pigmentation on the lips and perioral skin surface",
        "Hyperpigmentation of the buccal mucosa with spider-like vascular patterns",
        "Café au lait pigmentation on the skin with multiple neurofibromas",
        "Melanotic macules limited to the gingiva and alveolar mucosa only"
      ],
      correctAnswer: 2
    },
    {
      id: 93719,
      question: "White Sponge Nevus is characterized by which oral feature?",
      options: [
        "White corrugated soft folded buccal mucosa that does not affect the free gingiva",
        "Multiple neuromas on the lips, tongue, and buccal mucosa",
        "Melanotic macular pigmentation on the lips and gingival tissues",
        "Multiple capillary dilations affecting the oral mucosa and nasal cavities"
      ],
      correctAnswer: 0
    },
    {
      id: 93720,
      question: "Amelogenesis Imperfecta is best defined as which of the following?",
      options: [
        "A single inherited disorder causing absent pulp chambers and short thin roots",
        "A genetic condition affecting cementum and bone with premature tooth exfoliation",
        "A group of inherited conditions affecting tooth enamel with no associated systemic defects",
        "A group of inherited conditions affecting dentin of teeth with systemic bone involvement"
      ],
      correctAnswer: 2
    },
    {
      id: 93721,
      question: "Which type of Amelogenesis Imperfecta is characterized by enamel that does not develop to normal thickness?",
      options: [
        "Type II – Hypocalcified amelogenesis imperfecta",
        "Type I – Hypoplastic amelogenesis imperfecta",
        "Type IV – Hypoplastic-hypomaturation amelogenesis imperfecta",
        "Type III – Hypomaturation amelogenesis imperfecta"
      ],
      correctAnswer: 1
    },
    {
      id: 93722,
      question: "Which type of Amelogenesis Imperfecta features enamel of normal thickness but poor calcification?",
      options: [
        "Type III – Hypomaturation amelogenesis imperfecta",
        "Type I – Hypoplastic amelogenesis imperfecta",
        "Type IV – Hypoplastic-hypomaturation amelogenesis imperfecta",
        "Type II – Hypocalcified amelogenesis imperfecta"
      ],
      correctAnswer: 3
    },
    {
      id: 93723,
      question: "Which type of Amelogenesis Imperfecta is described as having a \"snowcapped\" appearance?",
      options: [
        "Type III – Hypomaturation amelogenesis imperfecta",
        "Type I – Hypoplastic amelogenesis imperfecta",
        "Type II – Hypocalcified amelogenesis imperfecta",
        "Type IV – Hypoplastic-hypomaturation amelogenesis imperfecta"
      ],
      correctAnswer: 0
    },
    {
      id: 93724,
      question: "Which of the following radiographic findings is associated with Dentinogenesis Imperfecta?",
      options: [
        "Enamel with radiodensity similar to dentin and enlarged pulp chambers",
        "Multiple cysts associated with impacted supernumerary teeth in the jaw",
        "Large pulp chambers with very long pulp horns and dentin cracks",
        "Absent pulp chambers and root canals, with short thin roots and periapical radiolucencies"
      ],
      correctAnswer: 3
    },
    {
      id: 93725,
      question: "Dentin Dysplasia Type I (Radicular) is characterized by which of the following?",
      options: [
        "Primary teeth with translucent amber color while adult teeth appear completely normal",
        "Teeth with opalescent bluish color, short roots, and absent pulp chambers",
        "Normal-appearing tooth crowns with abnormal roots and premature tooth exfoliation",
        "Large pulp chambers and taurodontic molars with apically displaced furcation"
      ],
      correctAnswer: 2
    },
    {
      id: 93726,
      question: "Which of the following is the classic triad of features in Hypohidrotic Ectodermal Dysplasia?",
      options: [
        "Hyperkeratosis, hypodontia, and hyperhydrosis",
        "Hyperdontia, hypotrichosis, and absence of sweat glands",
        "Gingival fibromatosis, sparse hair, and increased sweating",
        "Hypodontia, hypotrichosis, and hypohidrosis"
      ],
      correctAnswer: 3
    },
    {
      id: 93727,
      question: "Hypophosphatasia is associated with which of the following dental findings?",
      options: [
        "Opalescent teeth with absent pulp chambers and periapical radiolucencies",
        "Multiple supernumerary teeth with impaction and associated jaw cysts",
        "Teeth lacking cementum with premature exfoliation",
        "Conically shaped teeth with enamel hypoplasia and natal teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 93728,
      question: "Hypophosphatemic Vitamin D-Resistant Rickets follows which pattern of inheritance?",
      options: [
        "Autosomal recessive with decreased serum alkaline phosphatase levels",
        "Autosomal dominant with multiple supernumerary impacted teeth in the jaws",
        "X-linked dominant with large pulp chambers, long pulp horns, and dentin cracks",
        "Autosomal recessive with decreased serum phosphorus and large pulp chambers"
      ],
      correctAnswer: 2
    },
    {
      id: 93729,
      question: "Taurodontism is characterized by which of the following features?",
      options: [
        "Large pyramid-shaped molars with large pulp chambers and apically displaced furcation",
        "Conically shaped teeth with enamel hypoplasia and premature exfoliation",
        "Normal crowns with abnormal roots and premature tooth exfoliation",
        "Short thin roots with periapical radiolucencies and absent pulp chambers"
      ],
      correctAnswer: 0
    },
    {
      id: 93730,
      question: "Pegged or Absent Maxillary Lateral Incisors follows which pattern of inheritance?",
      options: [
        "Autosomal dominant with variable expression",
        "X-linked dominant affecting females primarily",
        "Autosomal recessive with complete penetrance",
        "Autosomal recessive with variable expressivity and reduced penetrance"
      ],
      correctAnswer: 0
    },
    {
      id: 93731,
      question: "Which of the following syndromes is associated with multiple supernumerary impacted teeth and osteomas of the jaw and facial skeleton?",
      options: [
        "Cherubism",
        "Cleidocranial Dysplasia",
        "Gardner Syndrome",
        "Gorlin Syndrome"
      ],
      correctAnswer: 2
    },
    {
      id: 93732,
      question: "Which of the following syndromes involves bilateral enlargement of the jaw with bone lesions histologically similar to central giant cell granuloma?",
      options: [
        "Gardner Syndrome",
        "Nevoid Basal Cell Carcinoma Syndrome",
        "Ellis-van Creveld Syndrome",
        "Cherubism"
      ],
      correctAnswer: 3
    },
    {
      id: 93733,
      question: "A patient presents with multiple jaw cysts, skin basal cell carcinomas, bifurcated ribs, and skeletal anomalies. Which syndrome is most likely?",
      options: [
        "Cleidocranial Dysplasia",
        "Nevoid Basal Cell Carcinoma Syndrome (Gorlin Syndrome)",
        "Mandibulofacial Dysostosis (Treacher-Collins Syndrome)",
        "Gardner Syndrome (Familial Colorectal Polyposis)"
      ],
      correctAnswer: 1
    },
    {
      id: 93734,
      question: "A patient has hyperkeratosis of the palms and soles with progressive gingival inflammation beginning at age 2, and both primary and permanent teeth are lost prematurely. Which syndrome is most likely?",
      options: [
        "Focal Palmoplantar and Gingival Hyperkeratosis",
        "Cyclic Neutropenia (Kostmann Syndrome)",
        "Papillon-Lefèvre Syndrome",
        "Gingival Fibromatosis with Hypertrichosis and Epilepsy"
      ],
      correctAnswer: 2
    },
    {
      id: 93735,
      question: "Which of the following syndromes is associated with multiple capillary dilations that can cause nosebleeds and gingival hemorrhage?",
      options: [
        "Hereditary Hemorrhagic Telangiectasia",
        "Neurofibromatosis of von Recklinghausen",
        "White Sponge Nevus",
        "Neurofibromatosis with café au lait skin lesions"
      ],
      correctAnswer: 0
    },
    {
      id: 93736,
      question: "A patient has a characteristic mushroom-shaped head, absent or hypoplastic clavicles, and many unerupted supernumerary teeth causing jaw cysts. Which syndrome does this describe?",
      options: [
        "Gardner Syndrome",
        "Cherubism",
        "Nevoid Basal Cell Carcinoma Syndrome",
        "Cleidocranial Dysplasia"
      ],
      correctAnswer: 3
    },
    {
      id: 93737,
      question: "In oral pathology, gross chromosomal abnormalities that can be observed in a karyotype include which of the following?",
      options: [
        "Molecular mutations at the DNA level visible only under electron microscopy",
        "Changes in chromosome structure such as deletion, translocation, or inversion",
        "Single-gene mutations that cause the most common inherited disorders of alleles",
        "Mitochondrial DNA abnormalities that are inherited exclusively from the father"
      ],
      correctAnswer: 1
    },
    {
      id: 93738,
      question: "Which of the following correctly defines \"alleles\"?",
      options: [
        "Single genes responsible for multiple unrelated traits across different chromosomes",
        "Genes located on sex chromosomes that control X-linked characteristics only",
        "Pairs of chromosomes with identical DNA sequences found only in somatic cells",
        "Genes located at the same locus on homologous chromosomes that control identical functions"
      ],
      correctAnswer: 3
    },
    {
      id: 93739,
      question: "Which of the following correctly defines the difference between penetrance and expressivity?",
      options: [
        "Penetrance refers to severity of expression, while expressivity refers to number affected",
        "Penetrance applies to recessive traits only, while expressivity applies to dominant traits",
        "Penetrance refers to the number of individuals affected, while expressivity pertains to the degree to which an individual is affected",
        "Penetrance and expressivity are the same concept applied to different inheritance patterns"
      ],
      correctAnswer: 2
    },
    {
      id: 93740,
      question: "Down syndrome results from trisomy of chromosome 21, meaning there are three copies of that chromosome.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93741,
      question: "Turner syndrome affects males and is characterized by extra X chromosomes causing female secondary sex characteristics.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93742,
      question: "Papillon-Lefèvre Syndrome is inherited in an autosomal recessive pattern and involves hyperkeratosis of the palms and soles.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93743,
      question: "Gingival and periodontal disease is reported in approximately 90% of individuals with Down syndrome.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93744,
      question: "Klinefelter syndrome is characterized by a female karyotype with short stature, webbed neck, and primary amenorrhea.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93745,
      question: "Cherubism causes bilateral facial swelling due to multilocular jaw lesions that appear as a soap bubble pattern radiographically.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93746,
      question: "Cleidocranial Dysplasia is most notably associated with multiple impacted supernumerary teeth and hypoplastic or absent clavicles.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93747,
      question: "Gardner Syndrome intestinal polyps are malignant from birth and require immediate surgical removal in all affected patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93748,
      question: "Dentinogenesis Imperfecta is characterized by absent or obliterated pulp chambers, short thin roots, and hereditary opalescent dentin.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93749,
      question: "White Sponge Nevus affects the free gingiva and presents as red, ulcerated tissue on the buccal mucosa.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93750,
      question: "Hypohidrotic Ectodermal Dysplasia is characterized by hypodontia, hypotrichosis, and hypohidrosis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93751,
      question: "Amelogenesis Imperfecta is a group of inherited conditions affecting only the dentin of teeth with no associated systemic defects.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ]
};
